// MARK: Endpoints and URL params
export const wfsEndpoints = {
   "Geus": {
      endpoint: "https://data.geus.dk/geusmap/ows/4326.jsp",
      fetchMethods: "Post_Xml",
      featureTypes: {
         "Aerogravity/magnetic 3d surveys": "aeromag_3d_surveys",
         "Towns, settlements & airfields": "byer_og_bygder",
         "covered_g500_labels": "covered_g500_labels",
         "covered_g500_labels_regions": "covered_g500_labels_regions",
         "CSEM 2d surveys": "csem_2d_surveys",
         "CSEM 3d surveys": "csem_3d_surveys",
         "danske_vandforsyningsomraader_gruk": "danske_vandforsyningsomraader_gruk",
         "Data compilation polygons": "data_compilations",
         "Over 400 m dybe, danske boringer iflg. Jupiter": "deep_wells_jupiter",
         "Atlasblade": "dk_atlasblade",
         "Dodex Reports": "dodex_survey_publications_test",
         "Dodex Reports (opacity 0.01) - brug lag 47 i stedet": "dodex_reports_ows",
         "Dodex Reports Nickel": "dodex_reports_visible_nickel",
         "GEUS publication series": "dodex_survey_publications",
         "Earthquakes Denmark": "earthquakes_denmark",
         "earthquakes_greenland": "earthquakes_greenland",
         "earthquakes_world": "earthquakes_world",
         "egdi_mineraloccurr_critical_raw_materials_2023": "egdi_mineraloccurr_critical_raw_materials_2023",
         "ens_flight_safety": "ens_flight_safety",
         "ENS Platforms": "ens_platform",
         "EUOGA Sedimentary Basin": "eugoa_geology_sedimentary_basins",
         "EUOGA Water stress": "euoga_env_risk_stress_water_risk",
         "Infrastructure": "euoga_geography_man_made_elm_infrastruct",
         "EUOGA Countries": "euoga_world",
         "EUOGA Rivers and lakes": "euoga_geography_natural_elm_rivers_and_lakes",
         "Shale plays": "euoga_geology_shale_plays",
         "Field maps for SW Greenland": "field_maps",
         "District heating plants": "fjernvarme_anlaeg",
         "floodwarning_branches": "floodwarning_branches",
         "floodwarning_qpoints": "floodwarning_qpoints",
         "FOHM udbredelsesområder": "fohm_udbredelsesomraader",
         "Greenland gem DB from MIM": "gem_db_occurences_mim",
         "Geochemical data packages": "geochemistry",
         "Geochemical data packages - Company data": "geochemistry_companies_stream",
         "Geochemical analyses of Soil samples from Greenland": "geochemistry_greenland_soil",
         "Geochemical Atlas of Stream sediment samples North Greenland": "geochemistry_greenland_ss_n",
         "Geochemical Atlas of Stream sediment samples from South and West Greenland": "geochemistry_greenland_ss_sw",
         "Geochemical analyses of Stream sediment samples from Greenland": "geochemistry_greenland_v2_external",
         "Geochemical data - Heavy minerals concentrates": "geochemistry_heavy_minerals_conc_zinc",
         "Geochemical data - Nunaminerals Database": "geochemistry_nunaminerals",
         "Geochemical data packages - Stream sediments - raw": "geochemistry_stream_raw_test",
         "Geochemical data - Rock Samples": "geochemistry_rock_samples_open",
         "Geochemical data packages - Scree sediments": "geochemistry_scree",
         "Geochemical data packages - Soil sediments": "geochemistry_soil",
         "Geochemical data packages - Stream sediments - Combined": "geochemistry_stream_combined_zinc",
         "Geochemical data packages - Stream sediments - Combined Nickel": "geochemistry_stream_combined_nickel_pct",
         "Geochemical data packages - Stream sediments - Combined Sb percentiles": "geochemistry_stream_combined_sb_pct",
         "Geochemical data packages - Stream sediments - Combined Thallium": "geochemistry_stream_combined_thallium",
         "Geochemical data packages - Stream sediments N Grl": "geochemistry_stream_ngrl",
         "Geochemical data packages - Stream sediments SV Grl": "geochemistry_stream_svgrl",
         "Geochronology (MMR)": "geochron",
         "Geophysical Surveys": "geophysical_surveys",
         "Geophysical Surveys for sale": "geophysical_surveys_for_sale",
         "Geotermi polygon til test af 3D-link fra polygon": "geotermi_3d_testpoly",
         "Geothermal plants": "geotermi_anlaeg",
         "Geotermi screeningprojekter": "geotermi_screeninglokaliteter",
         "Geotermi screeningprojekter - no label": "geotermi_screeningproj_nolabel",
         "Alle arealer": "geotreat_area",
         "Lokationer for geofysiske data": "gerda_data",
         "Lokationer for geofysiske data (som linjer)": "gerda_lines",
         "Lokationer for geofysiske modeller": "gerda_models",
         "Geofysiske projekter": "gerda_projects",
         "gg_g500_gm_labels": "gg_g500_gm_labels",
         "Map archive polygons": "gg_maparchive",
         "published map polygons": "gg_maparchive_published",
         "Oblique photos from Greenland": "gg_oblique_scenes",
         "Profile lines": "gg_profiles",
         "Tracts from the Mineral Resource Assessment Workshops": "gmom_tracts_zinc",
         "Greencore (MMR)": "greencore",
         "Greenland licences": "greenland_licences",
         "Greenland reports": "greenland_reports",
         "Greenland populated places": "grl_byer_og_bygder_gst",
         "grl_g2500_geol_regions": "grl_g2500_geol_regions",
         "grl_g500_lithostr_search": "grl_g500_lithostr_search",
         "Greenland licenses - Applications for new license": "grl_lic_applications_for_new_zinc",
         "Greenland licenses - Applications for renewal": "grl_lic_applications_for_renew_zinc",
         "Greenland mineral licenses - Exploitation": "grl_lic_minerals_exploitation_zinc",
         "Greenland mineral licenses - Exploration": "grl_lic_minerals_exploration_zinc",
         "Greenland mineral licenses - Exploration - Small Scale": "grl_lic_minerals_exploration_small",
         "Greenland licenses licenses - Historical": "grl_lic_minerals_historical_zinc",
         "Greenland licenses - Protected areas": "grl_lic_protected_areas",
         "Greenland water sample locations": "grl_vandproevesteder",
         "NE Greenland Higgins Placenames": "grl_ne_higgins_placenames",
         "grl_ne_placenames": "grl_ne_placenames",
         "grl_placenames": "grl_placenames",
         "grl_placenames_new_cbp": "grl_placenames_new_cbp",
         "Greenland lakes": "grl_soer",
         "Rubin- og safirforekomster i Grønland": "gr_rubies",
         "gr_ruby_exploitation_licenses": "gr_ruby_exploitation_licenses",
         "gr_ruby_exploration_licenses": "gr_ruby_exploration_licenses",
         "gr_ruby_fieldmap": "gr_ruby_fieldmap",
         "Danske boringer - high value dataset": "hvd_jupiter_boringer_lithologi",
         "Karakteristiske afstroemninger": "hydrovandweb_diversitet_count",
         "Oekologiske tilstandselementer": "hydrovandweb_diversitet_eqr",
         "Aendringer i oekologisk tilstand": "hydrovandweb_diversitetsdiff_eqr",
         "Aendringer i afstroemning PCT": "hydrovandweb_diversitetsdiff_pct",
         "intrusion_localities": "intrusion_localities",
         "Intrusion points": "intrusions",
         "Gmom intrusions": "intrusions_nickel",
         "inventory_onshore_petr_": "inventory_onshore_petr_",
         "Anlaeganalyser paa stoffer": "jupiter_anlaegsanalyser",
         "Aktive almene danske vandforsyningsanlaeg": "jupiter_anlaeg_vandfors_almen_wmts",
         "Danske anlaeg": "jupiter_anlaeg_ws",
         "Boringer-anlaeg koblet": "jupiter_bor_anl_koblet",
         "Boringer med ikke-digitaliseret lithologi": "jupiter_boringer_lithologi_todo",
         "Danske boringer (WMTS)": "jupiter_boringer_wmts",
         "Danske boringer": "marta_boringer",
         "jupiter_bor_lithologi": "jupiter_bor_lithologi",
         "Danske vandforsyningsboringer - WMTS": "jupiter_bor_vandfors_almen_wmts",
         "Danske vandforsyningsboringer": "jupiter_bor_vandfors_almen_ws",
         "Danske vandforsyningsboringer, resten": "jupiter_bor_vandfors_andre_ws",
         "Anlaegsanalyser paa stofgrupper": "jupiter_grp_anlaegsanalyser_test",
         "Danske boringer o 10 m dybe": "jupiter_lithologi_over_10m_dybe",
         "Paabud": "jupiter_paabud_ws",
         "pejlinger": "jupiter_pejlinger",
         "Kommunegraenser": "kommunegraenser",
         "Kortlagte skred": "landskredsportal_kortlagte_skred_2025",
         "Greenland lithologies": "lithologies",
         "Greenland geological localities": "localities",
         "Grabsamples": "marta_grab",
         "Billeder af havbunden": "marta_images",
         "Marta lines": "marta_lines",
         "Marta lines data": "marta_lines_data",
         "Oevrige marine punktdata": "marta_oevrige",
         "Marta omraaderapporter": "marta_omraaderapporter",
         "Projektomraader": "marta_projektomraader",
         "Rapporter": "marta_report",
         "Habitatrapporter": "marta_report_habitat",
         "Marta resource": "marta_resource",
         "Marta resourcerapporter": "marta_resourcerapporter",
         "Marine sedimentproever": "marta_sedimentproever",
         "Slaebsugninger": "marta_slaebsugning",
         "Stiksugninger": "marta_stiksugning",
         "Video af havbunden": "marta_video",
         "Analyser paa stoffer": "mc_analyse",
         "Analyser paa stofgrupper": "mc_grp_analyse",
         "Kvalitetssikring af analysedata": "mc_kvalitetssikring",
         "Kvalitetssikring af analysedata paa stofgruppeniveau": "mc_kvalitetssikring_grp",
         "pejlinger, miljoekontrol": "mc_pejling",
         "Vandtyper": "mc_vandtype",
         "miljoevurderinger": "miljoevurderinger",
         "miljoevurderinger_kladder": "miljoevurderinger_kladder",
         "Greenland mineral occurrences": "minerals_yearbook",
         "Greenland mineral occurrences nickel": "mineral_occurrences_nickel",
         "Greenland mineral occurrences regions": "mineral_occurrences_regions",
         "Lokale, geologiske modeller": "modeldb_lokale",
         "Nationale, geologiske modeller": "modeldb_nationale",
         "Geologiske modeller": "modeldb_outlines",
         "Regionale, geologiske modeller": "modeldb_regionale",
         "nitrat_2mg_and_above": "nitrat_2mg_and_above",
         "nitrat_2mg_and_above_aggr5km": "nitrat_2mg_and_above_aggr5km",
         "northpole_graticule": "northpole_graticule",
         "Scenevector for oblique photos": "oblique_scene",
         "perform geothermal plants": "perform_geothermal_plants",
         "perform plant factsheet": "perform_plant_factsheet",
         "perform wells": "perform_well",
         "Simplified pipelines": "pipelines_simplified",
         "Structural profiles for SW Greenland": "profiles",
         "Outlines for rapporter fra rapportdatabasen": "rapportdb_rapporter_pg",
         "Ruby samples greenland": "ruby_project_ntk",
         "Blocks divisions32 for Frisbee": "samba_blocks_32_frisbee",
         "Danish oil and gas field areas": "samba_fields",
         "Danish samba licences": "samba_licences",
         "samba_petroleum_wellbores_test": "samba_petroleum_wellbores_test",
         "Samba Wellbores": "samba_wellbores",
         "Samba Wellbores in CenSys": "samba_wellbores_censys",
         "Samba Wellbores in PetSys": "samba_wellbores_petsys",
         "Samba Wellbores Strat Intervals": "samba_wellbore_strat_intervals",
         "Samba Wells": "samba_wells",
         "Samba Wells for Frisbee": "samba_wells_frisbee",
         "Deep wells east of 6.25E": "samba_wells_geotermi",
         "Deep wells log data": "samba_wells_geotermi_logdata",
         "Deep wells east of 6.25E - no label": "samba_wells_geotermi_nolabel",
         "Samba wells in Greenland": "samba_wells_grl",
         "Greenland samples": "samples",
         "Greenland geochronological samples": "samples_geochronological",
         "Greenland samples ": "samples_grportal",
         "Greenland metamorphic samples": "samples_metamorphism",
         "Seismic 2d processings": "seismic_2d_processings",
         "2D surveys": "seismic_2d_surveys",
         "Seismic 3d processings": "seismic_3d_processings",
         "Seismic 3d processings for Frisbee": "seismic_3d_processings_frisbee",
         "Seismic 3d surveys": "seismic_3d_surveys",
         "Seismic 3d surveys for Frisbee": "seismic_3d_surveys_frisbee",
         "Seismic 3d surveys in Greenland": "seismic_3d_surveys_grl",
         "Seismic bathymetric outlines": "seismic_bathymetric",
         "Seismic CSEM lines in Greenland": "seismic_csem_grl",
         "Seismic lines": "seismic_lines",
         "Seismic lines for Frisbee": "seismic_lines_frisbee",
         "Seismic lines in Greenland": "seismic_lines_grl",
         "Seismic surveys in Greenland": "seismic_surveys_grl",
         "Sensordata": "sensordata",
         "store_sten_i_danmark": "store_sten_i_danmark",
         "stratigraphic_unit_localities": "stratigraphic_unit_localities",
         "Drillhole localities": "totalcore",
         "ujarassiorit samples": "ujarassiorit",
         "Varmelagring Geoenergi boringer": "varmelagring_geoenergi_boringer",
         "Grundvandskortlaegning": "varmelagring_grundvandskortlaegning",
         "Omraadetyper ift varmelagring (gammel)": "varmelagring_omraadetyper",
         "Overfladepotentiale Kalk": "varmelagring_potentiale_kalk",
         "Varmelagring rapporter": "varmelagring_rapporter",
         "Overfladepotentiale regionale": "varmelagring_regionale_potkort",
         "Overfladepotentiale gl. Ringkobing Amt": "varmelagring_ringamt_overflade_pot",
         "Vertical photos from Greenland": "vertical_photo",
         "waste_heat_map": "waste_heat_map",
         "Danske Boringer": "jupiter_boringer_ws"
      }
   },
   "Geus (Begrænset)": {
      endpoint: "https://data.geus.dk/geusmap/ows/25832.jsp",
      fetchMethods: "Post_Xml",
      active: false,
      whoAmI: true,
      featureTypes: {
         "Aerogravity/magnetic 3d surveys": "aeromag_3d_surveys",
         "CSEM 2d surveys": "csem_2d_surveys",
         "CSEM 3d surveys": "csem_3d_surveys",
         "danske_vandforsyningsomraader_gruk": "danske_vandforsyningsomraader_gruk",
         "Over 400 m dybe, danske boringer iflg. Jupiter": "deep_wells_jupiter",
         "Atlasblade": "dk_atlasblade",
         "Earthquakes Denmark": "earthquakes_denmark",
         "earthquakes_world": "earthquakes_world",
         "ens_flight_safety": "ens_flight_safety",
         "ENS Platforms": "ens_platform",
         "EUOGA Sedimentary Basin": "eugoa_geology_sedimentary_basins",
         "EUOGA Water stress": "euoga_env_risk_stress_water_risk",
         "Infrastructure": "euoga_geography_man_made_elm_infrastruct",
         "EUOGA Countries": "euoga_world",
         "EUOGA Rivers and lakes": "euoga_geography_natural_elm_rivers_and_lakes",
         "Shale plays": "euoga_geology_shale_plays",
         "District heating plants": "fjernvarme_anlaeg",
         "floodwarning_branches": "floodwarning_branches",
         "floodwarning_qpoints": "floodwarning_qpoints",
         "FOHM udbredelsesområder": "fohm_udbredelsesomraader",
         "Geotermi polygon til test af 3D-link fra polygon": "geotermi_3d_testpoly",
         "Geothermal plants": "geotermi_anlaeg",
         "Geotermi screeningprojekter": "geotermi_screeninglokaliteter",
         "Geotermi screeningprojekter - no label": "geotermi_screeningproj_nolabel",
         "Lokationer for geofysiske data": "gerda_data",
         "Lokationer for geofysiske data (som linjer)": "gerda_lines",
         "Lokationer for geofysiske modeller": "gerda_models",
         "Geofysiske projekter": "gerda_projects",
         "gg_g500_gm_labels": "gg_g500_gm_labels",
         "grundvandet_dk_landpolygon": "grundvandet_dk_landpolygon",
         "pejlinger til HIP": "hip_pejlinger",
         "Danske boringer - high value dataset": "hvd_jupiter_boringer_lithologi",
         "Karakteristiske afstroemninger": "hydrovandweb_diversitet_count",
         "Oekologiske tilstandselementer": "hydrovandweb_diversitet_eqr",
         "Aendringer i oekologisk tilstand": "hydrovandweb_diversitetsdiff_eqr",
         "Aendringer i afstroemning PCT": "hydrovandweb_diversitetsdiff_pct",
         "Anlaeganalyser paa stoffer": "jupiter_anlaegsanalyser",
         "Danske anlaeg": "jupiter_anlaeg_ws",
         "Boringer-anlaeg koblet": "jupiter_bor_anl_koblet",
         "Boringer med ikke-digitaliseret lithologi": "jupiter_boringer_lithologi_todo",
         "jupiter_boringer_plastisk_ler": "jupiter_boringer_plastisk_ler",
         "Danske boringers sandtykkelser 0-25 mut": "jupiter_boringer_sandtykkelser_0_til_25",
         "Danske boringers sandtykkelser 100-150 mut": "jupiter_boringer_sandtykkelser_100_til_150",
         "Danske boringers sandtykkelser 150-200 mut": "jupiter_boringer_sandtykkelser_150_til_200",
         "Danske boringers sandtykkelser 25-50 mut": "jupiter_boringer_sandtykkelser_25_til_50",
         "Danske boringers sandtykkelser 50-100 mut": "jupiter_boringer_sandtykkelser_50_til_100",
         "jupiter_boringer_seneste_pejling": "jupiter_boringer_seneste_pejling",
         "Danske boringer": "marta_boringer",
         "jupiter_bor_lithologi": "jupiter_bor_lithologi",
         "Danske vandforsyningsboringer": "jupiter_bor_vandfors_almen_ws",
         "Danske vandforsyningsboringer, resten": "jupiter_bor_vandfors_andre_ws",
         "Anlaegsanalyser paa stofgrupper": "jupiter_grp_anlaegsanalyser_test",
         "jupiter_indvinding_ydelser": "jupiter_indvinding_ydelser",
         "Danske boringer o 10 m dybe": "jupiter_lithologi_over_10m_dybe",
         "Paabud": "jupiter_paabud_ws",
         "pejlinger": "jupiter_pejlinger",
         "Kommunegraenser": "kommunegraenser",
         "Kortlagte skred": "landskredsportal_kortlagte_skred_2025",
         "Grabsamples": "marta_grab",
         "Billeder af havbunden": "marta_images",
         "Marta lines": "marta_lines",
         "Marta lines data": "marta_lines_data",
         "Oevrige marine punktdata": "marta_oevrige",
         "Marta omraaderapporter": "marta_omraaderapporter",
         "Projektomraader": "marta_projektomraader",
         "Rapporter": "marta_report",
         "Habitatrapporter": "marta_report_habitat",
         "Marta resource": "marta_resource",
         "Marta resourcerapporter": "marta_resourcerapporter",
         "Marine sedimentproever": "marta_sedimentproever",
         "Slaebsugninger": "marta_slaebsugning",
         "Stiksugninger": "marta_stiksugning",
         "Video af havbunden": "marta_video",
         "Analyser paa stoffer": "mc_analyse",
         "Analyser paa stofgrupper": "mc_grp_analyse",
         "Kvalitetssikring af analysedata": "mc_kvalitetssikring",
         "Kvalitetssikring af analysedata paa stofgruppeniveau": "mc_kvalitetssikring_grp",
         "pejlinger, miljoekontrol": "mc_pejling",
         "Vandtyper": "mc_vandtype",
         "miljoevurderinger": "miljoevurderinger",
         "miljoevurderinger_kladder": "miljoevurderinger_kladder",
         "Lokale, geologiske modeller": "modeldb_lokale",
         "Nationale, geologiske modeller": "modeldb_nationale",
         "Geologiske modeller": "modeldb_outlines",
         "Regionale, geologiske modeller": "modeldb_regionale",
         "nitrat_2mg_and_above": "nitrat_2mg_and_above",
         "nitrat_2mg_and_above_aggr5km": "nitrat_2mg_and_above_aggr5km",
         "perform geothermal plants": "perform_geothermal_plants",
         "perform wells": "perform_well",
         "Simplified pipelines": "pipelines_simplified",
         "Outlines for rapporter fra rapportdatabasen": "rapportdb_rapporter_pg",
         "Blocks divisions32 for Frisbee": "samba_blocks_32_frisbee",
         "Danish oil and gas field areas": "samba_fields",
         "Danish samba licences": "samba_licences",
         "samba_petroleum_wellbores_test": "samba_petroleum_wellbores_test",
         "Samba Wellbores": "samba_wellbores",
         "Samba Wellbores in CenSys": "samba_wellbores_censys",
         "Samba Wellbores in PetSys": "samba_wellbores_petsys",
         "Samba Wellbores Strat Intervals": "samba_wellbore_strat_intervals",
         "Samba Wells": "samba_wells",
         "Samba Wells for Frisbee": "samba_wells_frisbee",
         "Deep wells east of 6.25E": "samba_wells_geotermi",
         "Deep wells log data": "samba_wells_geotermi_logdata",
         "Deep wells east of 6.25E - no label": "samba_wells_geotermi_nolabel",
         "Seismic 2d processings": "seismic_2d_processings",
         "2D surveys": "seismic_2d_surveys",
         "Seismic 3d processings": "seismic_3d_processings",
         "Seismic 3d processings for Frisbee": "seismic_3d_processings_frisbee",
         "Seismic 3d surveys": "seismic_3d_surveys",
         "Seismic 3d surveys for Frisbee": "seismic_3d_surveys_frisbee",
         "Seismic bathymetric outlines": "seismic_bathymetric",
         "Seismic lines": "seismic_lines",
         "Seismic lines for Frisbee": "seismic_lines_frisbee",
         "store_sten_i_danmark": "store_sten_i_danmark",
         "Jordarter beskrevet som silt eller blødbund (jordartskort 1:25000)": "varmelagring_damvarmelager_silt",
         "Varmelagring Geoenergi boringer": "varmelagring_geoenergi_boringer",
         "Grundvandskortlaegning": "varmelagring_grundvandskortlaegning",
         "Omraadetyper ift varmelagring (gammel)": "varmelagring_omraadetyper",
         "Omraadetyper ift varmelagring": "varmelagring_omraadetyper_fohm",
         "Overfladepotentiale Kalk": "varmelagring_potentiale_kalk",
         "Varmelagring rapporter": "varmelagring_rapporter",
         "Overfladepotentiale regionale": "varmelagring_regionale_potkort",
         "Overfladepotentiale gl. Ringkobing Amt": "varmelagring_ringamt_overflade_pot",
         "Varmeproducenter i Danmark": "varmelagring_varmeproducenter",
         "waste_heat_map": "waste_heat_map"
      }
   },
   "Miljøgis": {
      endpoint: "https://wfs2-miljoegis.mim.dk/ows",
      featureTypes: {
         "klima:artsscore_poly": "klima:artsscore_poly",
         "klima:hh2050megethojt100aars": "klima:hh2050megethojt100aars",
         "klima:hh2050megethojt50aars": "klima:hh2050megethojt50aars",
         "klima:hojvandshaendelse2010100aars": "klima:hojvandshaendelse2010100aars",
         "klima:hojvandshaendelse201020aars": "klima:hojvandshaendelse201020aars",
         "klima:hojvandshaendelse201050aars": "klima:hojvandshaendelse201050aars",
         "klima:hojvandshaendelse2050hojt100aars": "klima:hojvandshaendelse2050hojt100aars",
         "klima:hojvandshaendelse2050hojt50aars": "klima:hojvandshaendelse2050hojt50aars",
         "klima:hojvandshaendelse2050lavt100aars": "klima:hojvandshaendelse2050lavt100aars",
         "klima:hojvandshaendelse2050lavt50aars": "klima:hojvandshaendelse2050lavt50aars",
         "klima:hojvandshaendelse2050megethojt100aars": "klima:hojvandshaendelse2050megethojt100aars",
         "klima:hojvandshaendelse2050megethojt50aars": "klima:hojvandshaendelse2050megethojt50aars",
         "klima:hojvandshaendelse2050middel100aars": "klima:hojvandshaendelse2050middel100aars",
         "klima:hojvandshaendelse2050middel50aars": "klima:hojvandshaendelse2050middel50aars",
         "klima:hojvandsstatistik": "klima:hojvandsstatistik",
         "klima:klimaekstremvandforing": "klima:klimaekstremvandforing",
         "klima:kystbeskyttelse": "klima:kystbeskyttelse",
         "klima:lavningermedattributter": "klima:lavningermedattributter",
         "klima:lavningeroplande": "klima:lavningeroplande",
         "klima:nedborsstatistik": "klima:nedborsstatistik",
         "klima:screeningskort": "klima:screeningskort",
         "klima:stromningsveje": "klima:stromningsveje",
         "klima:vaerdikort": "klima:vaerdikort",
         "A1 -  Forundersøgelser helhedsplaner": "natureman:a1_forunders_helhed",
         "A1 - Biologisk forundersøgelser": "natureman:a1_bio_forunders",
         "A1 - Ejendomsmæssige forundersøgelser": "natureman:a1_ejd_forunders",
         "A1 - Hydrologiske forundersøgelser": "natureman:a1_hydro_forunders",
         "AIS Andre passive redskaber": "np3basis2020:np3b2020_ais_andre",
         "AIS Garn": "np3basis2020:np3b2020_ais_garn",
         "AIS Pelagiske redskaber": "np3basis2020:np3b2020_ais_pelagiske",
         "AIS beskyttet natur - historisk": "natur:ais_par3",
         "Ansøgt placering til havbrug med produktion": "havbrug:ansoeg_placering_havbrug_med_prod",
         "Arealkort 2022 (digital skovkort)": "skovdrift:digitalt_skovkort_2022",
         "Arter": "np3basis2020:np3b2020_arter",
         "Auktionstilladelser": "raastofpaahavet:auktionstilladelser",
         "Bevaringsværdigt egekrat": "diverse:egekrat",
         "Biodiversitetsprioriteringskort": "vandprojekter:kla_e23_bioprio",
         "Biogeografiske regioner": "np3basis2020:np3b2020_marine_biogeoreg",
         "Bygherretilladelser": "raastofpaahavet:bygherretilladelser",
         "C1a afgræsning": "natureman:c1a_afgraesning",
         "C1b hegning": "natureman:c1b_hegning",
         "C1c græsningsfaciliteter": "natureman:c1c_graesningsfaciliteter",
         "C2 rydning": "natureman:c2_rydning",
         "C3a hydrologiprojekter": "natureman:c3a_hydrologiprojekter",
         "C3b vandhuller": "natureman:c3b_vandhuller",
         "C3c vådområdeprojekter": "natureman:c3c_vaadomraadeprojekter",
         "C3d lavbundsprojekter": "natureman:c3d_lavbundsprojekter",
         "C4 særlig forvaltning": "natureman:c4_saerligforvaltning",
         "C5 biomassehøst": "natureman:c5_biomassehoest",
         "C6 erstatninger": "natureman:c6_erstatninger",
         "C7 nyteknologi": "natureman:c7_nyteknologi",
         "C8 stiforloeb": "natureman:c8_stiforloeb",
         "C9 vandløbsrestaurering": "natureman:c9_vandloebsrestaurering",
         "D1 artsovervågning": "natureman:d1_monitering2",
         "D1 prøvefelter effektmonitering": "natureman:d1_monitering3",
         "D1_stationer effektmonitering": "natureman:d1_monitering1",
         "D2 pilotprojekt hydrologi": "natureman:d2_monitering4",
         "E2 formidling": "natureman:e2_formidling",
         "E4.2 outputbaseret støtteordning": "natureman:e42_outputbaseret_stoetteordning",
         "EF-fuglebeskyttelsesområder": "np3basis2020:np3b2020_fugle_beskyt",
         "EF-habitatområder": "np3basis2020:np3b2020_habitatomr",
         "Efterafgrødekrav N-følsom habitat 2018/19": "husdyr2017:theme-saarbarhedkort_nitrat_habitat_2018_19",
         "Efterafgrødekrav kystvandoplande 2018/19": "husdyr2017:theme-husdyr2018_19_kystvandoplande",
         "Efterforskningsområder": "raastofpaahavet:efterforskningsomraader",
         "Eksisterende havbrug": "havbrug:eksisterende_havbrug",
         "Forslag til n2000 arealer til pleje": "natur:n2000tillskud3_arealer_til_pleje",
         "Forslag til n2000 arealer til rydning": "natur:n2000tillskud3_arealer_til_rydning",
         "Fredskov": "np3basis2020:np3b2020_fredskov",
         "Fællesområder": "raastofpaahavet:faellesomraader",
         "Gammel skovjordbund": "dai:gammel_skovjordbund",
         "Husdyrefterafgrøder krav 2017-2018": "husdyr2017:efterafgrodekrav_2017_18",
         "Husdyrefterafgrøder krav 2018-2019": "husdyr2017:efterafgrodekrav_2018_19",
         "Husdyrefterafgrøder krav 2019-2020": "husdyr2017:efterafgrodekrav_2019_20",
         "Jernbaner i by, 1,5m": "stoej:d1_mtr_agg_rail_lden_1_5",
         "Jernbaner i by, 4m": "stoej:d2_mtr_agg_rail_lden_4m",
         "Jernbaner i by, nat, 1,5m": "stoej:d3_mtr_agg_rail_lnight_1_5",
         "Jernbaner i by, nat, 4m": "stoej:d4_mtr_agg_rail_lnight_4m",
         "Kategori 1 - Habitatnatur": "husdyr2017:theme-pg-natura2000_omraader_habitatnatur",
         "Kategori 1 – Heder og overdrev": "husdyr2017:theme-kategori1natur",
         "Kategori 2 - Heder og overdrev": "husdyr2017:theme-kategori2natur",
         "Kategori 2 - lobeliesøer og højmoser": "husdyr2017:theme-hoejmoser_lobsoer",
         "Kategori 3 - Heder - moser og overdrev": "dai:theme-kategori3natur",
         "Kategori 3 - Heder, moser og overdrev": "husdyr2017:theme-kategori3natur",
         "Klima Lavbund projektforslag": "vandprojekter:kla_projektforslag",
         "Klima lavbund projektomraader": "vandprojekter:kla_projektomraader",
         "Kystvandoplande": "husdyr2017:theme-vp2_2016nbel12_deloplande",
         "Levesteder arter": "np3basis2020:np3b2020_levesteder_arter",
         "Levesteder fuglearter": "np3basis2020:np3b2020_levesteder_fuglearter",
         "Lysåbne naturtyper (2016 - 2019) - Naturtilstand": "np3basis2020:np3b2020_lysaaben_natur2016_2019",
         "MST enheder overvågning": "vand:mst_enheder_overvaagning",
         "Marin kortlægning 2004-2018": "np3basis2020:np3b2020_marine_kortlaeg_2004_2018",
         "Marine boblerev (2004-2018)": "np3basis2020:np3b2020_marin_boblerev_2004_2018",
         "N-følsom habitatnatur i N-2000 områder - vådhede": "husdyr2017:habitat_vaadhede",
         "N-følsom habitatnatur i N-2000 områder-marin": "husdyr2017:habitat_marine",
         "N-følsom habitatnatur i N-2000 områder-sø": "husdyr2017:habitat_soer_14mar2017",
         "NP2-2016 Bechsteins flagermus": "np2_2016:theme-np2_2016-artskort_flagermus_bechstein",
         "NP2-2016 Biogeografiske regioner": "np2_2016:theme-np2_2016-biogeografisk_land",
         "NP2-2016 Blank seglmos": "np2_2016:theme-np2_2016-artskort_seglmos",
         "NP2-2016 Bred vandkalv": "np2_2016:theme-np2_2016-artskort_bred_vandkalv",
         "NP2-2016 Bredøret flagermus": "np2_2016:theme-np2_2016-artskort_flagermus_bredoeret",
         "NP2-2016 Bæklampret": "np2_2016:theme-np2_2016-artskort_baeklampret",
         "NP2-2016 Damflagermus": "np2_2016:theme-np2_2016-artskort_damflagermus",
         "NP2-2016 EF-fuglebeskyttelsesområder": "np2_2016:theme-np2_2016-fuglbeskyttelsesomrader",
         "NP2-2016 EF-habitatområder": "np2_2016:theme-np2_2016-habitatomraader",
         "NP2-2016 Enkelt månerude": "np2_2016:theme-np2_2016-artskort_maanerude",
         "NP2-2016 Eremit": "np2_2016:theme-np2_2016-artskort_eremit",
         "NP2-2016 Fredskov": "np2_2016:theme-np2_2016-fredskov",
         "NP2-2016 Fruesko": "np2_2016:theme-np2_2016-artskort_fruesko",
         "NP2-2016 Grøn buxbaumia": "np2_2016:theme-np2_2016-artskort_buxbaumia",
         "NP2-2016 Grøn kølleguldsmed": "np2_2016:theme-np2_2016-artskort_gronkolleguldsmed",
         "NP2-2016 Gul stenbræk": "np2_2016:theme-np2_2016-artskort_stenbraek",
         "NP2-2016 Hedepletvinge": "np2_2016:theme-np2_2016-artskort_hedepletvinge",
         "NP2-2016 Kildevælds vindelsnegl": "np2_2016:theme-np2_2016-artskort_kildeveldsvindelsnegl",
         "NP2-2016 Klokkefrø": "np2_2016:theme-np2_2016-artskort_klokkefroe",
         "NP2-2016 Laks": "np2_2016:theme-np2_2016-artskort_laks",
         "NP2-2016 Levesteder": "np2_2016:np2_2016ynglefugle_levesteder",
         "NP2-2016 Levesteder almindelig ryle - tilstand": "np2_2016:theme-np2_2016-levestedalmindelig_ryle",
         "NP2-2016 Levesteder brushane - tilstand": "np2_2016:theme-np2_2016-levested_brushane",
         "NP2-2016 Levesteder dværg måge - tilstand": "np2_2016:theme-np2_2016-levested_dvaergmaage",
         "NP2-2016 Levesteder dværgterne - tilstand": "np2_2016:theme-np2_2016-levested_dvaergterne",
         "NP2-2016 Levesteder eremit - tilstand": "np2_2016:theme-np2_2016-levestederemit",
         "NP2-2016 Levesteder fjordterne - tilstand": "np2_2016:theme-np2_2016-levested_fjordterne",
         "NP2-2016 Levesteder havterne - tilstand": "np2_2016:theme-np2_2016-levested_havterne",
         "NP2-2016 Levesteder hvidbrystet præstekrave - tilstand": "np2_2016:theme-np2_2016-levested_hvidbrystetpraest",
         "NP2-2016 Levesteder klokkefrø - tilstand": "np2_2016:theme-np2_2016-levestedklokkefroe",
         "NP2-2016 Levesteder klyde - tilstand": "np2_2016:theme-np2_2016-levestedklyde",
         "NP2-2016 Levesteder plettet rørvagtel - tilstand": "np2_2016:theme-np2_2016-levested_plettetrorvagtel",
         "NP2-2016 Levesteder rovterne - tilstand": "np2_2016:theme-np2_2016-levested_rovterne",
         "NP2-2016 Levesteder rørdrum - tilstand": "np2_2016:theme-np2_2016-levested_rordrum",
         "NP2-2016 Levesteder rørhøg - tilstand": "np2_2016:theme-np2_2016-levested_rorhog",
         "NP2-2016 Levesteder sandterne - tilstand": "np2_2016:theme-np2_2016-levested_sandterne",
         "NP2-2016 Levesteder sorthovedet måge - tilstand": "np2_2016:theme-np2_2016-levested_sorthovedetmaage",
         "NP2-2016 Levesteder sortterne - tilstand": "np2_2016:theme-np2_2016-levested_sortterne",
         "NP2-2016 Levesteder splitterne - tilstand": "np2_2016:theme-np2_2016-levested_splitterne",
         "NP2-2016 Levesteder stor vandsalamander - tilstand": "np2_2016:theme-np2_2016-levestedvandsalamander",
         "NP2-2016 Levesteder tinksmed - tilstand": "np2_2016:theme-np2_2016-levested_tinksmed",
         "NP2-2016 Liden Najade": "np2_2016:theme-np2_2016-artskort_najade",
         "NP2-2016 Lys skivevandkalv": "np2_2016:theme-np2_2016-artskort_lys_skivevandkalv",
         "NP2-2016 Lysåbne naturtyper (2004-2006) - Naturtilstand": "np2_2016:theme-np2_2016-naturtilstand2004_2006",
         "NP2-2016 Lysåbne naturtyper (2010-2011) - Naturtilstand": "np2_2016:theme-np2_2016-naturtilstand2010_2011",
         "NP2-2016 Marine naturtyper (2004-2012) point": "np2_2016:theme-np2_2016-marinkortlaegning-point",
         "NP2-2016 Marine naturtyper (2004-2012) polygon": "np2_2016:theme-np2_2016-marinkortlaegning-polygon",
         "NP2-2016 Mygblomst": "np2_2016:theme-np2_2016-artskort_mygblomst",
         "NP2-2016 Natur- og vildtreservater": "np2_2016:theme-np2_2016-naturvildtreservat",
         "NP2-2016 Natura 2000 områder": "np2_2016:theme-np2_2016-natura2000omraader",
         "NP2-2016 Natura 2000- statsejede arealer": "np2_2016:theme-np2_2016-natura2000statsejet",
         "NP2-2016 Odder": "np2_2016:theme-np2_2016-artskort_odder",
         "NP2-2016 Pigsmerling": "np2_2016:theme-np2_2016-artskort_pigsmerling",
         "NP2-2016 Ramsarområder": "np2_2016:theme-np2_2016-ramsar",
         "NP2-2016 Skovnatur, arealer med fredskovspligt (2005-2011) - Skovtilstand": "np2_2016:theme-np2_2016-fredsskov_naturtilstand2005_2011",
         "NP2-2016 Skovnatur, arealer uden fredskovspligt (2005-2011) - Skovtilstand": "np2_2016:theme-np2_2016-ikkefredsskov_naturtilstand2005_2011",
         "NP2-2016 Skæv vindelsnegl": "np2_2016:theme-np2_2016-artskort_skev_vindelsnegl",
         "NP2-2016 Stellas mosskorpion": "np2_2016:theme-np2_2016-artskort_mosskorpion",
         "NP2-2016 Stor kærguldsmed": "np2_2016:theme-np2_2016-artskort_stor_kaerguldsmed",
         "NP2-2016 Stor vandsalamander": "np2_2016:theme-np2_2016-artskort_vandsalamander",
         "NP2-2016 Sump vindelsnegl": "np2_2016:theme-np2_2016-artskort_sumpvindelsnegl",
         "NP2-2016 Søer under 5 ha, naturtyper (2007-2012) - Søtilstand": "np2_2016:theme-np2_2016-soer_naturtilstand2007_2012",
         "NP2-2016 Tykskallet malermusling": "np2_2016:theme-np2_2016-artskort_malermusling",
         "NP2-2016 Vandranke": "np2_2016:theme-np2_2016-artskort_vandranke",
         "Natur- og vildtreservater": "np3basis2020:np3b2020_naturvildtreservat",
         "Natura 2000 områder med områdenr.": "natur:natura_2000_omraader",
         "Natura 2000- statsejede arealer": "np3basis2020:np3b2020_statsejede_arealer_n2000",
         "Natura2000 områder": "np3basis2020:np3b2020_natura_2000_omraader",
         "Natura2000 tilskud2 - n2kindberet_diverse": "natura2000t2:n2kindberet_diverse",
         "Natura2000 tilskud2 - n2kindberet_facilitering": "natura2000t2:n2kindberet_facilitering",
         "Natura2000 tilskud2 - n2kindberet_korridorer": "natura2000t2:n2kindberet_korridorer",
         "Natura2000 tilskud2 - n2kindberet_life": "natura2000t2:n2kindberet_life",
         "Natura2000 tilskud2 - n2kindberet_lysaaben_natur": "natura2000t2:n2kindberet_lysaaben_natur",
         "Natura2000 tilskud2 - n2kindberet_naturlig_hydrologi": "natura2000t2:n2kindberet_naturlig_hydrologi",
         "Natura2000 tilskud2 - n2kindberet_omdriftsjord": "natura2000t2:n2kindberet_omdriftsjord",
         "Natura2000 tilskud2 - n2kindberet_problemarter": "natura2000t2:n2kindberet_problemarter",
         "Natura2000 tilskud2 - n2kindberet_skadelig_faerdsel": "natura2000t2:n2kindberet_skadelig_faerdsel",
         "Natura2000 tilskud2 - n2kindberet_vandhul": "natura2000t2:n2kindberet_vandhul",
         "Naturlig tilgroet lysåben areal": "dai:naturlig_tilgroet_lysaaben_areal",
         "Naturmæssig særlig værdifuld skov": "dai:naturmaessig_saerlig_vaerdifuld_skov",
         "Naturmæssigt særlig værdifuld skov på offentlige arealer (§25-skov)": "dai:theme-p25_offentligareal",
         "Naturstyrelsens arealoversigt": "skovdrift:Naturstyrelsens arealoversigt",
         "Oplande med husdyrefterafgrødekrav i planperioden 2018/2019": "husdyr2017:theme-theme-efterafgroedekrav2018_19",
         "Oplande til N-følsom habitatnatur": "husdyr2017:theme-saarbarhedkort_ver30aug2016",
         "Potentielle Fællesområder": "raastofpaahavet:potentiellefaellesomraader",
         "Ramsarområder": "np3basis2020:np3b2020_ramsaromr",
         "Reservationsområder": "raastofpaahavet:reservationsomraader",
         "Skovnaturtyper (2005-2012)": "np3basis2020:np3b2020_skovkortlaeg_2005_2012",
         "Skovnaturtyper (2016-2019)": "np3basis2020:np3b2020_skov",
         "Sprøjtemiddelfølsomme sandjorde": "grukos:sproejtemiddelfoelsomme_sandjorde",
         "Større jernbane, nat, 1,5m (BaneDK)": "stoej:c3_bdk_mrail_lnight_1_5",
         "Større jernbane, nat, 1,5m (Movia)": "stoej:c3_mva_agg_rail_lnight_1_5",
         "Større jernbane, nat, 1,5m (Storebælt)": "stoej:c3_sob_mrail_lnight_1_5",
         "Større jernbane, nat, 1,5m (Øresund)": "stoej:c3_ores_mrail_lnight_1_5",
         "Større jernbane, nat, 4m (BaneDK)": "stoej:c4_bdk_mrail_lnight_4m",
         "Større jernbane, nat, 4m (Movia)": "stoej:c4_mva_agg_rail_lnight_4m",
         "Større jernbane, nat, 4m (Storebælt)": "stoej:c4_sob_mrail_lnight_4m",
         "Større jernbane, nat, 4m (Øresund)": "stoej:c4_ores_mrail_lnight_4m",
         "Større jernbaner, 1,5m (BaneDK)": "stoej:c1_bdk_mrail_lden_1_5",
         "Større jernbaner, 1,5m (Movia)": "stoej:c1_mva_agg_rail_lden_1_5",
         "Større jernbaner, 1,5m (Storebælt)": "stoej:c1_sob_mrail_lden_1_5",
         "Større jernbaner, 1,5m (Øresund)": "stoej:c1_ores_mrail_lden_1_5",
         "Større jernbaner, 4m (BaneDK)": "stoej:c2_bdk_mrail_lden_4m",
         "Større jernbaner, 4m (Movia)": "stoej:c2_mva_agg_rail_lden_4m",
         "Større jernbaner, 4m (Storebælt)": "stoej:c2_sob_mrail_lden_4m",
         "Større jernbaner, 4m (Øresund)": "stoej:c2_ores_mrail_lden_4m",
         "Større lufthavne": "stoej:lufthavne_st_e1_2017",
         "Større lufthavne, nat": "stoej:lufthavne_st_e2_2017",
         "Større veje, 1,5m": "stoej:a1_mroad_lden_1_5",
         "Større veje, 4m": "stoej:a2_mroad_lden_v2",
         "Større veje, nat, 1,5m": "stoej:a3_mroad_lnight_1_5",
         "Større veje, nat, 4m": "stoej:a4_mroad_lnight",
         "Søer omfattet af vandområdeplanerne": "husdyr2017:theme-vp2_2016-soer",
         "Søer over 5 ha (2007-2018)": "np3basis2020:np3b2020_soer_over5ha",
         "Søer under 5 ha, naturtyper (2013-2018) - Søtilstand": "np3basis2020:np3b2020_habitatsoer_u5ha",
         "Søoplande med skærpede fosforlofter": "husdyr2017:theme-husdyr_delopl_soer_risiko",
         "Urtebræmmer (2016-2019)": "np3basis2020:np3b2020_urtebraemmer",
         "VMS Andre passive redskaber": "np3basis2020:np3b2020_vms_andre",
         "VMS Garn": "np3basis2020:np3b2020_vms_garn",
         "VMS Pelagiske redskaber": "np3basis2020:np3b2020_vms_pelagiske",
         "Vadehavet, Naturvidenskabelige referenceområder i Danmark, Schleswig Holstein og Hamburg": "diverse:ref_area_dk_sh_hh",
         "Vadehavet, trilateralt beskyttelsesområde": "diverse:trilateral_conservation_area",
         "Vadehavet, trilateralt samarbejdsområde": "diverse:wadden_sea_area",
         "Vandløb (2014-2018)": "np3basis2020:np3b2020_vandlob",
         "Veje i by, 1,5m": "stoej:b1_dk_aggroad_lden1_5_test",
         "Veje i by, 4m": "stoej:b2_dk_aggroad_lden",
         "Veje i by, nat, 1,5m": "stoej:b3_dk_aggroad_lnight",
         "Veje i by, nat, 4m": "stoej:b4_dk_aggroad_lnight",
         "Verdensarv Vadehavet (UNESCO)": "diverse:wadden_sea_nst",
         "Virksomheder i by, 1,5m": "stoej:mst_agg_ind_lden_1_5_g1",
         "Virksomheder i by, 4m": "stoej:mst_agg_ind_lden_4m_g2",
         "Virksomheder i by, nat, 1,5m": "stoej:mst_agg_ind_lnight_1_5_g3",
         "Virksomheder i by, nat, 4m": "stoej:mst_agg_ind_lnight_4m_g4",
         "afdelingssystem_polyline": "skovdrift:afdelingssystem_polyline",
         "afdelingssystem_text": "skovdrift:afdelingssystem_text",
         "afgpolygon": "grukos:afgpolygon",
         "aftaler_natur_tinglyst_v": "skovtilskud:aftaler_natur_tinglyst_v",
         "agerhone": "skovdrift:agerhone",
         "arealreservation_havbrug_havplan": "havbrug:arealreservation_havbrug_havplan",
         "beskyttede_havstrategiomraader": "raastofpaahavet:beskyttede_havstrategiomraader",
         "bnbo": "grukos:bnbo",
         "bnbo_statusopgoerelse": "grukos:bnbo_statusopgoerelse",
         "bnbostatus_historisk_aktuel_sammenligning": "grukos:bnbostatus_historisk_aktuel_sammenligning",
         "devano_kortlaegning_v2": "skovdrift:devano_kortlaegning_v2",
         "dk_retentionskort_2020": "diverse:dk_retentionskort_2020",
         "drikkevandsinteresser": "grukos:drikkevandsinteresser",
         "egekrat": "dai:egekrat",
         "eksisterende_havbrug_pkt": "havbrug:eksisterende_havbrug_pkt",
         "eksisterende_havbrug_poly": "havbrug:eksisterende_havbrug_poly",
         "foelsommeindvindingsomraader": "grukos:foelsommeindvindingsomraader",
         "giregionmidtjylland": "diverse:theme-vaerdifulde_geologiske_omraader",
         "gkoprojekt": "grukos:gkoprojekt",
         "groundwater_age": "grukos:groundwater_age",
         "hare": "skovdrift:hare",
         "havbrug_ansogninger_2018_empty": "havbrug:havbrug_ansogninger_2018_empty",
         "havbrug_ansogninger_2018_emty": "havbrug:havbrug_ansogninger_2018_emty",
         "havbrug_placeringstilladelser": "havbrug:havbrug_placeringstilladelser",
         "havbrugszoner": "havbrug:havbrugszoner",
         "helhedsprojekter_tilsagn2020": "vandprojekter:helhedsprojekter_tilsagn2020",
         "hnvskov": "skovtilskud:hnvskov",
         "indberettet17_st_privat_skovrejsning": "skovtilskud:indberettet17_st_privat_skovrejsning",
         "indberettet17_st_skov_biodivformaal": "skovtilskud:indberettet17_st_skov_biodivformaal",
         "indsatsomraader": "grukos:indsatsomraader",
         "indvindingsoplande_alle": "grukos:indvindingsoplande_alle",
         "indvindingsoplande_udenfor_osd": "grukos:indvindingsoplande_udenfor_osd",
         "ioluosdihtjfl": "grukos:ioluosdihtjfl",
         "jagtfrie_omr_byzoner__04_region": "skovdrift:jagtfrie_omr_byzoner__04_region",
         "jagtfrie_omr_sommerhuszoner_04_region": "skovdrift:jagtfrie_omr_sommerhuszoner_04_region",
         "jagttid_daadyr": "skovdrift:jagttid_daadyr",
         "jagttid_krondyr": "skovdrift:jagttid_krondyr",
         "kategori2_hoejmoser": "husdyr2017:kategori2_hoejmoser",
         "klappladser_seneste_viden": "raastofpaahavet:theme-klapplny",
         "kortlaegningsindmeldinger_afsluttet": "grukos:kortlaegningsindmeldinger_afsluttet",
         "kortlaegningsindmeldinger_ejpaabegyndt": "grukos:kortlaegningsindmeldinger_ejpaabegyndt",
         "kortlaegningsindmeldinger_ikke_proriteret": "grukos:kortlaegningsindmeldinger_ikke_proriteret",
         "kortlaegningsindmeldinger_paabegyndt": "grukos:kortlaegningsindmeldinger_paabegyndt",
         "kulstof2022": "natur:kulstof2022",
         "kulstof2022_3_6_pct": "natur:kulstof2022_3_6_pct",
         "kvaelstofretention": "vandprojekter:kvaelstofretention",
         "lertykkelse_polygon": "grukos:lertykkelse_polygon",
         "litraoplysninger_danmark_text": "skovdrift:litraoplysninger_danmark_text",
         "lysaaben_kortlaegning_2016_2018": "natur:lysaaben_kortlaegning_2016_2018",
         "lysaabennaturba2014": "diverse:lysaabennaturba2014",
         "magasinlag_linjer": "grukos:magasinlag_linjer",
         "magasinlag_polygon": "grukos:magasinlag_polygon",
         "mat_reg_minus_bypoly2": "skovdrift:mat_reg_minus_bypoly2",
         "mc_graense": "diverse:mc_graense",
         "modelomr_geokemisk": "grukos:modelomr_geokemisk",
         "modelomr_geologisk": "grukos:modelomr_geologisk",
         "modelomr_hydrologisk": "grukos:modelomr_hydrologisk",
         "modelomr_hydrostratigrafisk": "grukos:modelomr_hydrostratigrafisk",
         "motorbaad_region": "skovdrift:motorbaad_region",
         "natura2000planer": "skovdrift:natura2000planer",
         "natureman_hydrologi": "natureman:natureman_hydrologi",
         "natureman_opkob": "natureman:natureman_opkob",
         "natureman_plg": "natureman:natureman_plg",
         "natureman_rfa": "natureman:natureman_rfa",
         "natureman_sammhaeng_tinglyst": "natureman:natureman_sammhaeng_tinglyst",
         "natureman_subregions": "natureman:natureman_subregions",
         "noedomraader_point": "raastofpaahavet:noedomraader_point",
         "noedomraader_region": "raastofpaahavet:noedomraader_region",
         "novana_2017_21_point": "novana:novana_2017_21_point",
         "novana_2017_21_polygon": "novana:novana_2017_21_polygon",
         "np11beskyt_natur_dai": "naturplan2011:np11beskyt_natur_dai",
         "np11beskyt_vandlob_dai": "naturplan2011:np11beskyt_vandlob_dai",
         "np11bioreg_land": "naturplan2011:np11bioreg_land",
         "np11devano_label": "naturplan2011:np11devano_label",
         "np11devano_tilstand": "naturplan2011:np11devano_tilstand",
         "np11devanosoer": "naturplan2011:np11devanosoer",
         "np11driftsbetingethabitatnatur": "naturplan2011:np11driftsbetingethabitatnatur",
         "np11ef_fugle_beskyt": "naturplan2011:np11ef_fugle_beskyt",
         "np11fredede_omraader_dai": "naturplan2011:np11fredede_omraader_dai",
         "np11fredskov_dai": "naturplan2011:np11fredskov_dai",
         "np11fuglevenligdrift": "naturplan2011:np11fuglevenligdrift",
         "np11habitat": "naturplan2011:np11habitat",
         "np11marine_kortlegning": "naturplan2011:np11marine_kortlegning",
         "np11mvj_aftaler_dai": "naturplan2011:np11mvj_aftaler_dai",
         "np11natura_2000_dai": "naturplan2011:np11natura_2000_dai",
         "np11naturperler": "naturplan2011:np11naturperler",
         "np11ramsar_beskyt": "naturplan2011:np11ramsar_beskyt",
         "np11rydning": "naturplan2011:np11rydning",
         "np3_2022_ais_andre": "np3_2022:np3_2022_ais_andre",
         "np3_2022_ais_garn": "np3_2022:np3_2022_ais_garn",
         "np3_2022_ais_pelagiske": "np3_2022:np3_2022_ais_pelagiske",
         "np3_2022_arealer_invasive": "np3_2022:np3_2022_arealer_invasive",
         "np3_2022_arter": "np3_2022:np3_2022_arter",
         "np3_2022_bioreg_land": "np3_2022:np3_2022_bioreg_land",
         "np3_2022_fredskov": "np3_2022:np3_2022_fredskov",
         "np3_2022_fugle_beskyt": "np3_2022:np3_2022_fugle_beskyt",
         "np3_2022_habitatomr": "np3_2022:np3_2022_habitatomr",
         "np3_2022_habitatsoer_u5ha": "np3_2022:np3_2022_habitatsoer_u5ha",
         "np3_2022_levesteder": "np3_2022:np3_2022_levesteder",
         "np3_2022_levesteder_arter": "np3_2022:np3_2022_levesteder_arter",
         "np3_2022_levesteder_fuglearter": "np3_2022:np3_2022_levesteder_fuglearter",
         "np3_2022_lysaaben_natur2016_2019": "np3_2022:np3_2022_lysaaben_natur2016_2019",
         "np3_2022_marin_boblerev_2004_2018": "np3_2022:np3_2022_marin_boblerev_2004_2018",
         "np3_2022_marine_biogeoreg": "np3_2022:np3_2022_marine_biogeoreg",
         "np3_2022_marine_kortlaeg_2004_2018": "np3_2022:np3_2022_marine_kortlaeg_2004_2018",
         "np3_2022_natura_2000_omraader": "np3_2022:np3_2022_natura_2000_omraader",
         "np3_2022_naturtyper2010_2011": "np3_2022:np3_2022_naturtyper2010_2011",
         "np3_2022_naturvildtreservat": "np3_2022:np3_2022_naturvildtreservat",
         "np3_2022_ramsaromr": "np3_2022:np3_2022_ramsaromr",
         "np3_2022_skov": "np3_2022:np3_2022_skov",
         "np3_2022_skovkortlaeg_2005_2012": "np3_2022:np3_2022_skovkortlaeg_2005_2012",
         "np3_2022_soer_over5ha": "np3_2022:np3_2022_soer_over5ha",
         "np3_2022_statsejede_arealer_n2000": "np3_2022:np3_2022_statsejede_arealer_n2000",
         "np3_2022_urtebraemmer": "np3_2022:np3_2022_urtebraemmer",
         "np3_2022_vandlob": "np3_2022:np3_2022_vandlob",
         "np3_2022_vms_andre": "np3_2022:np3_2022_vms_andre",
         "np3_2022_vms_garn": "np3_2022:np3_2022_vms_garn",
         "np3_2022_vms_pelagiske": "np3_2022:np3_2022_vms_pelagiske",
         "np3h2021_ais_andre": "np3h2021:np3h2021_ais_andre",
         "np3h2021_ais_garn": "np3h2021:np3h2021_ais_garn",
         "np3h2021_ais_pelagiske": "np3h2021:np3h2021_ais_pelagiske",
         "np3h2021_arter": "np3h2021:np3h2021_arter",
         "np3h2021_bioreg_land": "np3h2021:np3h2021_bioreg_land",
         "np3h2021_fredskov": "np3h2021:np3h2021_fredskov",
         "np3h2021_fugle_beskyt": "np3h2021:np3h2021_fugle_beskyt",
         "np3h2021_habitatomr": "np3h2021:np3h2021_habitatomr",
         "np3h2021_habitatsoer_u5ha": "np3h2021:np3h2021_habitatsoer_u5ha",
         "np3h2021_levesteder": "np3h2021:np3h2021_levesteder",
         "np3h2021_levesteder_arter": "np3h2021:np3h2021_levesteder_arter",
         "np3h2021_levesteder_fuglearter": "np3h2021:np3h2021_levesteder_fuglearter",
         "np3h2021_lysaaben_natur2016_2019": "np3h2021:np3h2021_lysaaben_natur2016_2019",
         "np3h2021_marin_boblerev_2004_2018": "np3h2021:np3h2021_marin_boblerev_2004_2018",
         "np3h2021_marine_biogeoreg": "np3h2021:np3h2021_marine_biogeoreg",
         "np3h2021_marine_kortlaeg_2004_2018": "np3h2021:np3h2021_marine_kortlaeg_2004_2018",
         "np3h2021_natura_2000_omraader": "np3h2021:np3h2021_natura_2000_omraader",
         "np3h2021_naturtyper2010_2011": "np3h2021:np3h2021_naturtyper2010_2011",
         "np3h2021_naturvildtreservat": "np3h2021:np3h2021_naturvildtreservat",
         "np3h2021_ramsaromr": "np3h2021:np3h2021_ramsaromr",
         "np3h2021_skov": "np3h2021:np3h2021_skov",
         "np3h2021_skovkortlaeg_2005_2012": "np3h2021:np3h2021_skovkortlaeg_2005_2012",
         "np3h2021_soer_over5ha": "np3h2021:np3h2021_soer_over5ha",
         "np3h2021_statsejede_arealer_n2000": "np3h2021:np3h2021_statsejede_arealer_n2000",
         "np3h2021_urtebraemmer": "np3h2021:np3h2021_urtebraemmer",
         "np3h2021_vandlob": "np3h2021:np3h2021_vandlob",
         "np3h2021_vms_andre": "np3h2021:np3h2021_vms_andre",
         "np3h2021_vms_garn": "np3h2021:np3h2021_vms_garn",
         "np3h2021_vms_pelagiske": "np3h2021:np3h2021_vms_pelagiske",
         "np_dk_planzone1_region": "skovdrift:np_dk_planzone1_region",
         "np_dk_planzone2_region": "skovdrift:np_dk_planzone2_region",
         "np_dk_planzone3_region": "skovdrift:np_dk_planzone3_region",
         "npydreafgr": "skovdrift:npydreafgr",
         "nst_topografi_polyline": "skovdrift:nst_topografi_polyline",
         "nst_transport_polyline": "skovdrift:nst_transport_polyline",
         "nst_transport_text": "skovdrift:nst_transport_text",
         "nst_vand_polyline": "skovdrift:nst_vand_polyline",
         "nst_vand_text": "skovdrift:nst_vand_text",
         "overvaagning_krebsepest": "diverse:overvaagning_krebsepest",
         "potentiale_linjer": "grukos:potentiale_linjer",
         "potentiale_polygon": "grukos:potentiale_polygon",
         "reduceret_lertykkelse_pktgrid": "grukos:reduceret_lertykkelse_pktgrid",
         "reduceret_lertykkelse_polygon": "grukos:reduceret_lertykkelse_polygon",
         "saarbaregrundvandsdannendeomraader": "grukos:saarbaregrundvandsdannendeomraader",
         "saarbarhed_nitrat": "grukos:saarbarhed_nitrat",
         "saarbarhed_redox_pkt": "grukos:saarbarhed_redox_pkt",
         "saarbarhed_redox_polygon": "grukos:saarbarhed_redox_polygon",
         "saba_litra_evw": "skovdrift:saba_litra_evw",
         "saedgaas": "skovdrift:saedgaas",
         "skov_fredskov_ba2014": "diverse:skov_fredskov_ba2014",
         "skov_ikkefredskov_ba2014": "diverse:skov_ikkefredskov_ba2014",
         "skov_kortlaegning_2016_2018": "natur:skov_kortlaegning_2016_2018",
         "skov_np2h2014_join_150601": "skovdrift:skov_np2h2014_join_150601",
         "skov_nst_transport_polyline": "skovdrift:skov_nst_transport_polyline",
         "skov_nst_transport_text": "skovdrift:skov_nst_transport_text",
         "skovdrift_grasningsskov": "skovdrift:skovdrift_grasningsskov",
         "skovdrift_plukhugst": "skovdrift:skovdrift_plukhugst",
         "skovdrift_staevningsskov": "skovdrift:skovdrift_staevningsskov",
         "skovdrift_urortskov": "skovdrift:skovdrift_urortskov",
         "skovudviklingsplan": "skovdrift:skovudviklingsplan",
         "smaasoeer_ba2014": "diverse:smaasoeer_ba2014",
         "soe_kortlaegning_2014_2018": "natur:soe_kortlaegning_2014_2018",
         "stationstema_datamodel_amo": "diverse:stationstema_datamodel_amo",
         "statsejede_arealer": "diverse:statsejede_arealer",
         "strengt_beskyttede_havstrategiomraader": "raastofpaahavet:strengt_beskyttede_havstrategiomraader",
         "tekstur_2014": "natur:tekstur_2014",
         "theme-geol_overordnede_omrader": "diverse:theme-geol_overordnede_omrader",
         "theme-geologi_geosites": "diverse:theme-geologi_geosites",
         "theme-geologi_nationale_kystlandskaber": "diverse:theme-geologi_nationale_kystlandskaber",
         "theme-geologi_rgi": "diverse:theme-geologi_rgi",
         "theme-grundvandsmagasiner_osd_iol_link": "dai:theme-grundvandsmagasiner_osd_iol_link",
         "theme-grundvandsmagasiner_osd_iol_link_old": "dai:theme-grundvandsmagasiner_osd_iol_link_old",
         "theme-indvindingsoplande_i_osd": "grukos:theme-indvindingsoplande_i_osd",
         "theme-nationale_geologiske_omraader": "diverse:theme-nationale_geologiske_omraader",
         "theme-plangroen-proevepkt_2015": "vandprojekter:theme-plangroen-proevepkt_2015",
         "tilsagn17_st_uroert_skov_v": "skovtilskud:tilsagn17_st_uroert_skov_v",
         "tilsagn18_st_sammenhaengende_arealer_v": "skovtilskud:tilsagn18_st_sammenhaengende_arealer_v",
         "tilsagn18_st_uroert_skov_v": "skovtilskud:tilsagn18_st_uroert_skov_v",
         "tilsagn19_st_sammenhaengende_arealer_v": "skovtilskud:tilsagn19_st_sammenhaengende_arealer_v",
         "tilsagn19_st_uroert_skov_v": "skovtilskud:tilsagn19_st_uroert_skov_v",
         "tilsagn20_st_sammenhaengende_arealer_v": "skovtilskud:tilsagn20_st_sammenhaengende_arealer_v",
         "tilsagn20_st_uroert_skov_v": "skovtilskud:tilsagn20_st_uroert_skov_v",
         "tilsagn21_st_sammenhaengende_arealer_v": "skovtilskud:tilsagn21_st_sammenhaengende_arealer_v",
         "tilsagn21_st_uroert_skov_v": "skovtilskud:tilsagn21_st_uroert_skov_v",
         "tilsagn22_st_uroert_skov_v": "skovtilskud:tilsagn22_st_uroert_skov_v",
         "vaadomraadepotentiale": "vandprojekter:vaadomraadepotentiale",
         "vp2_2016_blandingszoner": "vp2_2016:theme-vp2_2016-blandingszoner",
         "vp2_2016_drikkevandsforekomster": "vp2_2016:theme-vp2_2016-drikkevandsforekomster",
         "vp2_2016_grundvandsforekomst": "vp2_2016:theme-vp2_2016-grundvandsforekomst",
         "vp2_2016_indsats_aabning_rorlagtgenslyngning": "vp2_2016:theme-vp2_2016-indsats-aabning-rorlagtgenslyngning",
         "vp2_2016_indsats_etab_sandfang": "vp2_2016:theme-vp2_2016-indsats-etab-sandfang",
         "vp2_2016_indsats_etab_traeer": "vp2_2016:theme-vp2_2016-indsats-etab-traeer",
         "vp2_2016_indsats_fosforomraader_soer": "vp2_2016:theme-vp2_2016-indsats_fosforomraader_soer",
         "vp2_2016_indsats_fysiskspaerring": "vp2_2016:theme-vp2_2016-indsats-fysiskspaerring",
         "vp2_2016_indsats_genslyngning": "vp2_2016:theme-vp2_2016-indsats-genslyngning",
         "vp2_2016_indsats_genslyngningkomb_medafv": "vp2_2016:theme-vp2_2016-indsats-genslyngningkomb_medafv",
         "vp2_2016_indsats_haevning_vandlobsbund": "vp2_2016:theme-vp2_2016-indsats-haevning-vandlobsbund",
         "vp2_2016_indsats_okkeranleag": "vp2_2016:theme-vp2_2016-indsats-okkeranleag",
         "vp2_2016_indsats_rorlagt_restaurering": "vp2_2016:theme-vp2_2016-indsats-rorlagt_restaurering",
         "vp2_2016_indsats_udlaegning_groftmateriale": "vp2_2016:theme-vp2_2016-indsats-udlaegning_groftmateriale",
         "vp2_2016_indsats_udlaegning_groftmateriale_medtrae": "vp2_2016:theme-vp2_2016-indsats-udlaegning_groftmateriale_medtrae",
         "vp2_2016_indsats_udskiftning_bundmateriale": "vp2_2016:theme-vp2_2016-indsats-udskiftning_bundmateriale",
         "vp2_2016_kemisk_tilstand_grundvand": "vp2_2016:theme-vp2_2016-kemisk-tilstand-grundvand",
         "vp2_2016_kemiske_trends_grundvand": "vp2_2016:theme-vp2_2016-kemiske-trends-grundvand",
         "vp2_2016_kvaelstofindsats_lavbundsjord": "vp2_2016:theme-vp2_2016_kvaelstofindsats_lavbundsjord",
         "vp2_2016_kvaelstofindsats_miljoefokus": "vp2_2016:theme-vp2_2016_kvaelstofindsats_miljoefokus",
         "vp2_2016_kvaelstofindsats_minivaadomraader": "vp2_2016:theme-vp2_2016_kvaelstofindsats_minivaadomraader",
         "vp2_2016_kvaelstofindsats_regulering": "vp2_2016:theme-vp2_2016_kvaelstofindsats_regulering",
         "vp2_2016_kvaelstofindsats_skovrejsning": "vp2_2016:theme-vp2_2016_kvaelstofindsats_skovrejsning",
         "vp2_2016_kvaelstofindsats_vaadomraade": "vp2_2016:theme-vp2_2016_kvaelstofindsats_vaadomraade",
         "vp2_2016_kvantitativ_tilstand_grundvand": "vp2_2016:theme-vp2_2016-kvantitativ-tilstand-grundvand",
         "vp2_2016_kystvande": "vp2_2016:theme-vp2_2016-kystvande",
         "vp2_2016_kystvande_karakterisering": "vp2_2016:theme-vp2_2016-kystvande_karakterisering",
         "vp2_2016_kystvande_kvaelstofbelastning": "vp2_2016:theme-vp2_2016-kystvande_kvaelstofbelastning",
         "vp2_2016_kystvande_miljomaal": "vp2_2016:theme-vp2_2016-kystvande_miljomaal",
         "vp2_2016_kystvande_miljomaal_kemisktilstand": "vp2_2016:theme-vp2_2016-kystvande_miljomaal-kemisktilstand",
         "vp2_2016_kystvande_okotilstand_aalegraes": "vp2_2016:theme-vp2_2016-kystvande_okotilstand_aalegraes",
         "vp2_2016_kystvande_okotilstand_dki": "vp2_2016:theme-vp2_2016-kystvande_okotilstand_dki",
         "vp2_2016_kystvande_okotilstand_klorofyl": "vp2_2016:theme-vp2_2016-kystvande_okotilstand_klorofyl",
         "vp2_2016_kystvande_okotilstand_samlet": "vp2_2016:theme-vp2_2016-kystvande_okotilstand_samlet",
         "vp2_2016_kystvande_tilstand_kemisk": "vp2_2016:theme-vp2_2016-kystvande_tilstand_kemisk",
         "vp2_2016_kystvande_tilstand_mfs": "vp2_2016:theme-vp2_2016-kystvande_tilstand_mfs",
         "vp2_2016_kystvande_typologi": "vp2_2016:theme-vp2_2016-kystvande_typologi",
         "vp2_2016_miljomaal_kemisk_grundvand": "vp2_2016:theme-vp2_2016-miljomaal_kemisk-grundvand",
         "vp2_2016_miljomaal_kvantitativ_grundvand": "vp2_2016:theme-vp2_2016-miljomaal_kvantitativ-grundvand",
         "vp2_2016_renseanlaeg_indsats": "vp2_2016:theme-vp2_2016-renseanlaeg_indsats",
         "vp2_2016_samlet_tilstand_grundvand": "vp2_2016:theme-vp2_2016-samlet-tilstand-grundvand",
         "vp2_2016_soer": "vp2_2016:theme-vp2_2016-soer",
         "vp2_2016_soer_karakterisering": "vp2_2016:theme-vp2_2016-soer_karakterisering",
         "vp2_2016_soer_miljomaal": "vp2_2016:theme-vp2_2016-soer_miljomaal",
         "vp2_2016_soer_miljomaal_kemisktilstand": "vp2_2016:theme-vp2_2016-soer_miljomaa-kemisktilstand",
         "vp2_2016_soer_okotilstand_fisk": "vp2_2016:theme-vp2_2016-soer_okotilstand_fisk",
         "vp2_2016_soer_okotilstand_klorofyl": "vp2_2016:theme-vp2_2016-soer_okotilstand_klorofyl",
         "vp2_2016_soer_okotilstand_makrofytter": "vp2_2016:theme-vp2_2016-soer_okotilstand_makrofytter",
         "vp2_2016_soer_okotilstand_planteplankton": "vp2_2016:theme-vp2_2016-soer_okotilstand_planteplankton",
         "vp2_2016_soer_okotilstand_samlet": "vp2_2016:theme-vp2_2016-soer_okotilstand_samlet",
         "vp2_2016_soer_tilstand_kemisk": "vp2_2016:theme-vp2_2016-soer_tilstand_kemisk",
         "vp2_2016_soer_tilstand_mfs": "vp2_2016:theme-vp2_2016-soer_tilstand_mfs",
         "vp2_2016_soer_typologi": "vp2_2016:theme-vp2_2016-soer_typologi",
         "vp2_2016_spaerringer_undtag": "vp2_2016:theme-vp2_2016-vandlob_spaerringer_undtag",
         "vp2_2016_vandindvinding": "vp2_2016:theme-vp2_2016-vandindvinding",
         "vp2_2016_vandlob_karakterisering": "vp2_2016:theme-vp2_2016-vandlob_karakterisering",
         "vp2_2016_vandlob_miljomaal": "vp2_2016:theme-vp2_2016-vandlob_miljomaal",
         "vp2_2016_vandlob_miljomaal_kemisktilstand": "vp2_2016:theme-vp2_2016-vandlob_miljomaal-kemisktilstand",
         "vp2_2016_vandlob_okotilstand_dvfi": "vp2_2016:theme-vp2_2016-vandlob_okotilstand_dvfi",
         "vp2_2016_vandlob_okotilstand_fisk": "vp2_2016:theme-vp2_2016-vandlob_okotilstand_fisk",
         "vp2_2016_vandlob_okotilstand_planteplankton": "vp2_2016:theme-vp2_2016-vandlob_okotilstand_planteplankton",
         "vp2_2016_vandlob_tilstand_kemisk": "vp2_2016:theme-vp2_2016-vandlob_tilstand_kemisk",
         "vp2_2016_vandlob_tilstand_mfs": "vp2_2016:theme-vp2_2016-vandlob_tilstand_mfs",
         "vp2_2016_vandlob_typbloed": "vp2_2016:theme-vp2_2016-vandlob_typbloed",
         "vp2_2016_vandlob_typologi": "vp2_2016:theme-vp2_2016-vandlob_typologi",
         "vp2_2016badevandsomrader": "vp2_2016:theme-vp2_2016-badevandsomrader",
         "vp2_2016dambrug": "vp2_2016:theme-vp2_2016-dambrug",
         "vp2_2016ef_fugle_beskyt": "vp2_2016:theme-vp2_2016-pg-fuglomr",
         "vp2_2016grundvand_kem_undtagelse": "vp2_2016:theme-vp2_2016-grundvand_undtagelser_kemi",
         "vp2_2016grundvand_kva_undtagels": "vp2_2016:theme-vp2_2016-grundvand_undtagelser_kvantitativ",
         "vp2_2016habitat": "vp2_2016:theme-vp2_2016-pg-habitat2004",
         "vp2_2016havbrug": "vp2_2016:theme-vp2_2016-havbrug",
         "vp2_2016havne": "vp2_2016:theme-vp2_2016-havne",
         "vp2_2016hovedvandoplande": "vp2_2016:theme-vp2_2016-vandramme_oplande",
         "vp2_2016indsats_rbu": "vp2_2016:theme-vp2_2016-rbu_indsats",
         "vp2_2016indsats_ukloakerede_ejendomme": "vp2_2016:theme-vp2_2016-indsats_ukloakerede_ejendomme",
         "vp2_2016industri": "vp2_2016:theme-vp2_2016-industri",
         "vp2_2016klappladser": "vp2_2016:theme-vp2_2016-klappladserdk",
         "vp2_2016lulc_map_poly": "vp2_2016:theme-vp2_2016-arealanvendelse",
         "vp2_2016marin_ensomil": "vp2_2016:theme-vp2_2016-kystvande_typologi_label",
         "vp2_2016marin_undtagelse": "vp2_2016:theme-vp2_2016-kystvande_undtag",
         "vp2_2016mfs_samlettilstandvanlob_linje": "vp2_2016:theme-vp2_2016-vandlob_okotilstand_samlet-prik",
         "vp2_2016mfs_samlettilstandvanlob_prik": "vp2_2016:theme-vp2_2016-vandlob_okotilstand_samlet-linje",
         "vp2_2016n_vaad": "vp2_2016:theme-vp2_2016-indsats_kvaelstofvaadomraader_kystvande",
         "vp2_2016nbel12_deloplande": "vp2_2016:theme-vp2_2016nbel12_deloplande",
         "vp2_2016raastof_samlet": "vp2_2016:theme-vp2_2016-raastofindv",
         "vp2_2016ramsar_beskyt": "vp2_2016:theme-vp2_2016-pg-ramsar2000",
         "vp2_2016rbu": "vp2_2016:theme-vp2_2016-rbu",
         "vp2_2016renseanlaeg": "vp2_2016:theme-vp2_2016-renseanlaeg",
         "vp2_2016skaldyrvande": "vp2_2016:theme-vp2_2016-skaldyrsvande",
         "vp2_2016soer_restaurer": "vp2_2016:theme-vp2_2016-indsatskrav_soer_restaurering",
         "vp2_2016soer_undtag": "vp2_2016:theme-vp2_2016-soer_undtag",
         "vp2_2016spaerringer_paavirkninger": "vp2_2016:theme-vp2_2016-sparringer",
         "vp2_2016spredtbebyggelse": "vp2_2016:theme-vp2_2016-spredtbebyggelse",
         "vp2_2016storresejlrender": "vp2_2016:theme-vp2_2016-sejlrender",
         "vp2_2016vanddistrikter": "vp2_2016:theme-vp2_2016-vanddistrikt",
         "vp2_2016vandlob": "vp2_2016:theme-vp2_2016-vandlob",
         "vp2_2016vandlob_rbu_indsats": "vp2_2016:theme-vp2_2016vandlob_rbu_indsats",
         "vp2_2016vandlob_renseanlaeg_indsats": "vp2_2016:theme-vp2_2016vandlob_renseanlaeg_indsats",
         "vp2_2016vandlob_undtag": "vp2_2016:theme-vp2_2016-vandlob_undtag",
         "vp2_ak_2016_dce_kriterier": "vandraad17:theme-vp2_ak_2016_stotte_indberetvandomr",
         "vp2_ak_2016_indberet_vandomraade": "vandraad17:theme-vp2_ak_2016_indberet_vandomraade",
         "vp2_ak_2016_spaerringer": "vandraad17:vp2_ak_2016_spaerringer",
         "vp2_ak_2016_vandomraade_opg2": "vandraad17:vp2_ak_2016_vandomraade_opg2",
         "vp2_ak_2016_vandomraade_opg3": "vandraad17:vp2_ak_2016_vandomraade_opg3",
         "vp2_v2016nitratfolsom": "vp2_2016:theme-vp2_2016-nitratfolsom",
         "vp2bek 2019 Indsats. Fjernelse af fysiske spærringer": "vp2_2016:vp2bek_2019_indsats_fysiskspaerring",
         "vp2bek 2019 Indsats. Fjernelse af spærringer videreført fra VP1": "vp2_2016:vp2bek_2019_indsats_fjern_spar_vp1",
         "vp2bek 2019 Indsats. Ukloakerede ejendomme": "vp2_2016:vp2bek_2019_indsats_ukloakerede_ejendomme",
         "vp2bek 2019 Indsats. Åbning af rørlagte strækninger m. efterfølgende hævning af bund og/eller genslyngning": "vp2_2016:vp2bek_2019_indsats_aabning_rorlagtgenslyngning",
         "vp2bek 2019 Indsats. Åbning af rørlagte strækninger m. smårestaurering": "vp2_2016:vp2bek_2019_indsats_rorlagt_restaurering",
         "vp2bek 2019 Indsats. Åbning af rørlagte strækninger videreført fra VP1": "vp2_2016:vp2bek_2019_indsats_rorlagt_vp1",
         "vp2bek 2019 indsats regnbetingede udløb": "vp2_2016:vp2bek_2019_indsats_rbu",
         "vp2bek 2019 spærringer påvirkninger": "vp2_2016:vp2bek_2019spaerringer_paavirkninger",
         "vp2bek 2019 spærringer undtagelse": "vp2_2016:vp2bek_2019_spaerringer_undtag",
         "vp2bek 2019 vandløb": "vp2_2016:vp2bek_2019_vandlob",
         "vp2bek 2019 vandløb som forbedres af indsats": "vp2_2016:vp2bek_2019_vandlob_indsats_rbu",
         "vp3_basis_2019_distrikter": "vp3basis2019:vp3_basis_2019_distrikter",
         "vp3_basis_2019_grv_foru_stf_dyb": "vp3basis2019:vp3_basis_2019_grv_foru_stf_dyb",
         "vp3_basis_2019_grv_foru_stf_reg": "vp3basis2019:vp3_basis_2019_grv_foru_stf_reg",
         "vp3_basis_2019_grv_maalestation_dyb": "vp3basis2019:vp3_basis_2019_grv_maalestation_dyb",
         "vp3_basis_2019_grv_maalestation_reg": "vp3basis2019:vp3_basis_2019_grv_maalestation_reg",
         "vp3_basis_2019_grv_maalestation_terr": "vp3basis2019:vp3_basis_2019_grv_maalestation_terr",
         "vp3_basis_2019_grv_overordnet_dyb": "vp3basis2019:vp3_basis_2019_grv_overordnet_dyb",
         "vp3_basis_2019_grv_overordnet_reg": "vp3basis2019:vp3_basis_2019_grv_overordnet_reg",
         "vp3_basis_2019_grv_overordnet_terr": "vp3basis2019:vp3_basis_2019_grv_overordnet_terr",
         "vp3_basis_2019_hovedoplande": "vp3basis2019:vp3_basis_2019_hovedoplande",
         "vp3_basis_2019_lulc_map_poly": "vp3basis2019:vp3_basis_2019_lulc_map_poly",
         "vp3_basis_2019_marin_overordnet": "vp3basis2019:vp3_basis_2019_marin_overordnet",
         "vp3_basis_2019_ov_maalestation_soe": "vp3basis2019:vp3_basis_2019_ov_maalestation_soe",
         "vp3_basis_2019_ov_maalestation_vandl": "vp3basis2019:vp3_basis_2019_ov_maalestation_vandl",
         "vp3_basis_2019_punkt_ferskdam_udl": "vp3basis2019:vp3_basis_2019_punkt_ferskdam_udl",
         "vp3_basis_2019_punkt_havdam_udl": "vp3basis2019:vp3_basis_2019_punkt_havdam_udl",
         "vp3_basis_2019_punkt_ind_udl": "vp3basis2019:vp3_basis_2019_punkt_ind_udl",
         "vp3_basis_2019_punkt_rbu_udl": "vp3basis2019:vp3_basis_2019_punkt_rbu_udl",
         "vp3_basis_2019_punkt_rens_udl": "vp3basis2019:vp3_basis_2019_punkt_rens_udl",
         "vp3_basis_2019_punkt_spredt_udl": "vp3basis2019:vp3_basis_2019_punkt_spredt_udl",
         "vp3_basis_2019_soe_ke": "vp3basis2019:vp3_basis_2019_soe_ke",
         "vp3_basis_2019_soe_overordnet": "vp3basis2019:vp3_basis_2019_soe_overordnet",
         "vp3_basis_2019_soe_prior": "vp3basis2019:vp3_basis_2019_soe_prior",
         "vp3_basis_2019_stf_overordnet_terr": "vp3basis2019:vp3_basis_2019_stf_overordnet_terr",
         "vp3_basis_2019_vandloeb_ke": "vp3basis2019:vp3_basis_2019_vandloeb_ke",
         "vp3_basis_2019_vandloeb_overordnet": "vp3basis2019:vp3_basis_2019_vandloeb_overordnet",
         "vp3_basis_2019_vandloeb_prior": "vp3basis2019:vp3_basis_2019_vandloeb_prior",
         "vp3basis2019_badevand": "vp3basis2019:vp3basis2019_badevand",
         "vp3basis2019_blandingszoner": "vp3basis2019:vp3basis2019_blandingszoner",
         "vp3basis2019_foelsomindvindingomr": "vp3basis2019:vp3basis2019_foelsomindvindingomr",
         "vp3basis2019_fugle_beskyt": "vp3basis2019:vp3basis2019_fugle_beskyt",
         "vp3basis2019_gvf_kemisk": "vp3basis2019:vp3basis2019_gvf_kemisk",
         "vp3basis2019_gvf_risiko": "vp3basis2019:vp3basis2019_gvf_risiko",
         "vp3basis2019_habitatomr": "vp3basis2019:vp3basis2019_habitatomr",
         "vp3basis2019_havne": "vp3basis2019:vp3basis2019_havne",
         "vp3basis2019_klappladser": "vp3basis2019:vp3basis2019_klappladser",
         "vp3basis2019_marin_fys_konstr": "vp3basis2019:vp3basis2019_marin_fys_konstr",
         "vp3basis2019_natura_2000_omraader": "vp3basis2019:vp3basis2019_natura_2000_omraader",
         "vp3basis2019_raastofomr": "vp3basis2019:vp3basis2019_raastofomr",
         "vp3basis2019_ramsaromr": "vp3basis2019:vp3basis2019_ramsaromr",
         "vp3basis2019_sargasso_2014_2017": "vp3basis2019:vp3basis2019_sargasso_2014_2017",
         "vp3basis2019_skaldyrvande": "vp3basis2019:vp3basis2019_skaldyrvande",
         "vp3basis2019_sparring": "vp3basis2019:vp3basis2019_sparring",
         "vp3basis2019_storresejlrender": "vp3basis2019:vp3basis2019_storresejlrender",
         "vp3basis2019_sw_mfs_tilstand": "vp3basis2019:vp3basis2019_sw_mfs_tilstand",
         "vp3basis2019_v1_v2_overfladevand": "vp3basis2019:vp3basis2019_v1_v2_overfladevand",
         "vp3basis2019_vandindvinding": "vp3basis2019:vp3basis2019_vandindvinding",
         "vp3e2022_Afgrænsning af hovedvandoplande": "vp3endelig2022:vp3e2022_hovedoplande",
         "vp3e2022_Afgrænsning af kystvandoplande": "vp3endelig2022:vp3e2022_kystvand_opland_afg",
         "vp3e2022_Afgrænsning af vandområdedistrikter": "vp3endelig2022:vp3e2022_distrikter",
         "vp3e2022_Arealanvendelse": "vp3endelig2022:vp3e2022_lulc_map_poly",
         "vp3e2022_Badevand": "vp3endelig2022:vp3e2022_badevand",
         "vp3e2022_Blandingszoner": "vp3endelig2022:vp3e2022_blandingszoner",
         "vp3e2022_Ferskvandsdambrug": "vp3endelig2022:vp3e2022_punkt_ferskdam_saml",
         "vp3e2022_Forekomst af sargassotang": "vp3endelig2022:vp3e2022_sargasso_2014_2017",
         "vp3e2022_Grundvand dyb trends vending": "vp3endelig2022:vp3e2022_grv_dyb_trend_rev",
         "vp3e2022_Grundvand regional trends vending": "vp3endelig2022:vp3e2022_grv_reg_trend_rev",
         "vp3e2022_Grundvand samlet dyb": "vp3endelig2022:vp3e2022_grv_samlet_dyb",
         "vp3e2022_Grundvand samlet regional": "vp3endelig2022:vp3e2022_grv_samlet_reg",
         "vp3e2022_Grundvand samlet terænnær": "vp3endelig2022:vp3e2022_grv_samlet_terr",
         "vp3e2022_Grundvand terrænnær trends": "vp3endelig2022:vp3e2022_grv_terr_trend",
         "vp3e2022_Grundvand terrænnær trends vending": "vp3endelig2022:vp3e2022_grv_terr_trend_rev",
         "vp3e2022_Grundvand_dyb_trends": "vp3endelig2022:vp3e2022_grv_dyb_trend",
         "vp3e2022_Grundvand_regional_trends": "vp3endelig2022:vp3e2022_grv_reg_trend",
         "vp3e2022_Havne": "vp3endelig2022:vp3e2022_havne",
         "vp3e2022_Indsats: Ukloakerede ejendomme": "vp3endelig2022:vp3e2022_opl_rensekl_inds",
         "vp3e2022_Jordforureninger": "vp3endelig2022:vp3e2022_v1_v2_overfladevand",
         "vp3e2022_Klappladser": "vp3endelig2022:vp3e2022_klappladser",
         "vp3e2022_Kystvande indsats": "vp3endelig2022:vp3e2022_delopl_marin_inds",
         "vp3e2022_Kystvande med fysiske konstruktioner": "vp3endelig2022:vp3e2022_marin_fys_konstr",
         "vp3e2022_Kystvande miljøfarlige forurenende stoffer": "vp3endelig2022:vp3e2022_marin_saml_punkt",
         "vp3e2022_Kystvande samlet": "vp3endelig2022:vp3e2022_marin_samlet",
         "vp3e2022_Kystvande samlet 1 sømil": "vp3endelig2022:vp3e2022_marin_samlet_1mil",
         "vp3e2022_Målestationer dybt grundvand": "vp3endelig2022:vp3e2022_grv_maalestation_dyb",
         "vp3e2022_Målestationer regionalt grundvand": "vp3endelig2022:vp3e2022_grv_maalestation_reg",
         "vp3e2022_Målestationer terrænnært grundvand": "vp3endelig2022:vp3e2022_grv_maalestation_terr",
         "vp3e2022_Målestationer. Kystvande": "vp3endelig2022:vp3e2022_ov_maalestation_marin",
         "vp3e2022_Målestationer. Søer": "vp3endelig2022:vp3e2022_ov_maalestation_soe",
         "vp3e2022_Målestationer. Vandløb": "vp3endelig2022:vp3e2022_ov_maalestation_vandl",
         "vp3e2022_Natura 2000 - Fuglebeskyttelses områder": "vp3endelig2022:vp3e2022_fugle_beskyt",
         "vp3e2022_Natura 2000 - Habitatområder": "vp3endelig2022:vp3e2022_habitatomr",
         "vp3e2022_Natura 2000 områder": "vp3endelig2022:vp3e2022_natura_2000_omraader",
         "vp3e2022_Nitratfølsomme indvindingsområder": "vp3endelig2022:vp3e2022_foelsomindvindingomr",
         "vp3e2022_Oplande_deloplande": "vp3endelig2022:vp3e2022_opl_delopl",
         "vp3e2022_Oplande_heloplande": "vp3endelig2022:vp3e2022_opl_helopl",
         "vp3e2022_Ramsarområder": "vp3endelig2022:vp3e2022_ramsaromr",
         "vp3e2022_Regnbetingede udledninger": "vp3endelig2022:vp3e2022_punkt_rbu_saml",
         "vp3e2022_Renseanlæg": "vp3endelig2022:vp3e2022_punkt_rens_saml",
         "vp3e2022_Råstofindvinding - kystvande": "vp3endelig2022:vp3e2022_raastofomr",
         "vp3e2022_Saltvandsbaseret fiskeopdræt": "vp3endelig2022:vp3e2022_punkt_havdam_saml",
         "vp3e2022_Skaldyrvande": "vp3endelig2022:vp3e2022_skaldyrvande",
         "vp3e2022_Spredt bebyggelse": "vp3endelig2022:vp3e2022_punkt_spredt_saml",
         "vp3e2022_Spredt bebyggelse renseklasse": "vp3endelig2022:vp3e2022_opl_rensekl_pavirk",
         "vp3e2022_Spærringer i vandløb": "vp3endelig2022:vp3e2022_spaerring_samlet",
         "vp3e2022_Større sejlrender": "vp3endelig2022:vp3e2022_storresejlrender",
         "vp3e2022_Sø miljøfarlige forurenende stoffer": "vp3endelig2022:vp3e2022_soe_saml_punkt",
         "vp3e2022_Sø samlet": "vp3endelig2022:vp3e2022_soe_samlet",
         "vp3e2022_Vandløb miljøfarlige forurenende stoffer": "vp3endelig2022:vp3e2022_vandloeb_saml_punkt",
         "vp3e2022_Vandløb samlet": "vp3endelig2022:vp3e2022_vandloeb_samlet",
         "vp3e2022_industrier": "vp3endelig2022:vp3e2022_punkt_ind_saml",
         "vp3e2022_vandindvinding": "vp3endelig2022:vp3e2022_vandindvinding",
         "vp3gen2024_badevand": "vp3gen2024:vp3gen2024_badevand",
         "vp3gen2024_blandingszoner": "vp3gen2024:vp3gen2024_blandingszoner",
         "vp3gen2024_delopl_marin_inds": "vp3gen2024:vp3gen2024_delopl_marin_inds",
         "vp3gen2024_distrikter": "vp3gen2024:vp3gen2024_distrikter",
         "vp3gen2024_foelsomindvindingomr": "vp3gen2024:vp3gen2024_foelsomindvindingomr",
         "vp3gen2024_fugle_beskyt": "vp3gen2024:vp3gen2024_fugle_beskyt",
         "vp3gen2024_grv_dyb_trend": "vp3gen2024:vp3gen2024_grv_dyb_trend",
         "vp3gen2024_grv_dyb_trend_rev": "vp3gen2024:vp3gen2024_grv_dyb_trend_rev",
         "vp3gen2024_grv_maalestation_dyb": "vp3gen2024:vp3gen2024_grv_maalestation_dyb",
         "vp3gen2024_grv_maalestation_reg": "vp3gen2024:vp3gen2024_grv_maalestation_reg",
         "vp3gen2024_grv_maalestation_terr": "vp3gen2024:vp3gen2024_grv_maalestation_terr",
         "vp3gen2024_grv_reg_trend": "vp3gen2024:vp3gen2024_grv_reg_trend",
         "vp3gen2024_grv_reg_trend_rev": "vp3gen2024:vp3gen2024_grv_reg_trend_rev",
         "vp3gen2024_grv_samlet_dyb": "vp3gen2024:vp3gen2024_grv_samlet_dyb",
         "vp3gen2024_grv_samlet_reg": "vp3gen2024:vp3gen2024_grv_samlet_reg",
         "vp3gen2024_grv_samlet_terr": "vp3gen2024:vp3gen2024_grv_samlet_terr",
         "vp3gen2024_grv_terr_trend": "vp3gen2024:vp3gen2024_grv_terr_trend",
         "vp3gen2024_grv_terr_trend_rev": "vp3gen2024:vp3gen2024_grv_terr_trend_rev",
         "vp3gen2024_habitatomr": "vp3gen2024:vp3gen2024_habitatomr",
         "vp3gen2024_havne": "vp3gen2024:vp3gen2024_havne",
         "vp3gen2024_hovedoplande": "vp3gen2024:vp3gen2024_hovedoplande",
         "vp3gen2024_klappladser": "vp3gen2024:vp3gen2024_klappladser",
         "vp3gen2024_kystvand_opland_afg": "vp3gen2024:vp3gen2024_kystvand_opland_afg",
         "vp3gen2024_lulc_map_poly": "vp3gen2024:vp3gen2024_lulc_map_poly",
         "vp3gen2024_marin_fys_konstr": "vp3gen2024:vp3gen2024_marin_fys_konstr",
         "vp3gen2024_marin_saml_punkt": "vp3gen2024:vp3gen2024_marin_saml_punkt",
         "vp3gen2024_marin_samlet": "vp3gen2024:vp3gen2024_marin_samlet",
         "vp3gen2024_marin_samlet_1mil": "vp3gen2024:vp3gen2024_marin_samlet_1mil",
         "vp3gen2024_natura_2000_omraader": "vp3gen2024:vp3gen2024_natura_2000_omraader",
         "vp3gen2024_nedlagte_klappladser": "vp3gen2024:vp3gen2024_nedlagte_klappladser",
         "vp3gen2024_opl_marin_inds": "vp3gen2024:vp3gen2024_opl_marin_inds",
         "vp3gen2024_opl_rensekl_inds": "vp3gen2024:vp3gen2024_opl_rensekl_inds",
         "vp3gen2024_opl_rensekl_pavirk": "vp3gen2024:vp3gen2024_opl_rensekl_pavirk",
         "vp3gen2024_opl_soe_inds": "vp3gen2024:vp3gen2024_opl_soe_inds",
         "vp3gen2024_ov_maalestation_marin": "vp3gen2024:vp3gen2024_ov_maalestation_marin",
         "vp3gen2024_ov_maalestation_soe": "vp3gen2024:vp3gen2024_ov_maalestation_soe",
         "vp3gen2024_ov_maalestation_vandl": "vp3gen2024:vp3gen2024_ov_maalestation_vandl",
         "vp3gen2024_punkt_ferskdam_saml": "vp3gen2024:vp3gen2024_punkt_ferskdam_saml",
         "vp3gen2024_punkt_havdam_saml": "vp3gen2024:vp3gen2024_punkt_havdam_saml",
         "vp3gen2024_punkt_ind_saml": "vp3gen2024:vp3gen2024_punkt_ind_saml",
         "vp3gen2024_punkt_rbu_saml": "vp3gen2024:vp3gen2024_punkt_rbu_saml",
         "vp3gen2024_punkt_rens_saml": "vp3gen2024:vp3gen2024_punkt_rens_saml",
         "vp3gen2024_punkt_spredt_saml": "vp3gen2024:vp3gen2024_punkt_spredt_saml",
         "vp3gen2024_raastofomraader": "vp3gen2024:vp3gen2024_raastofomraader",
         "vp3gen2024_ramsaromr": "vp3gen2024:vp3gen2024_ramsaromr",
         "vp3gen2024_sargasso_2017_2022": "vp3gen2024:vp3gen2024_sargasso_2017_2022",
         "vp3gen2024_skaldyrvande": "vp3gen2024:vp3gen2024_skaldyrvande",
         "vp3gen2024_soe_hoved_ind_p": "vp3gen2024:vp3gen2024_soe_hoved_ind_p",
         "vp3gen2024_soe_hoved_ind_t": "vp3gen2024:vp3gen2024_soe_hoved_ind_t",
         "vp3gen2024_soe_saml_punkt": "vp3gen2024:vp3gen2024_soe_saml_punkt",
         "vp3gen2024_soe_samlet": "vp3gen2024:vp3gen2024_soe_samlet",
         "vp3gen2024_soeoplande_inds": "vp3gen2024:vp3gen2024_soeoplande_inds",
         "vp3gen2024_spaerring_samlet": "vp3gen2024:vp3gen2024_spaerring_samlet",
         "vp3gen2024_storresejlrender": "vp3gen2024:vp3gen2024_storresejlrender",
         "vp3gen2024_v1_v2_overfladevand": "vp3gen2024:vp3gen2024_v1_v2_overfladevand",
         "vp3gen2024_vandindvinding": "vp3gen2024:vp3gen2024_vandindvinding",
         "vp3gen2024_vandloeb_saml_punkt": "vp3gen2024:vp3gen2024_vandloeb_saml_punkt",
         "vp3gen2024_vandloeb_samlet": "vp3gen2024:vp3gen2024_vandloeb_samlet",
         "vp3h2021_badevand": "vp3hoering2021:vp3h2021_badevand",
         "vp3h2021_blandingszoner": "vp3hoering2021:vp3h2021_blandingszoner",
         "vp3h2021_delopl_marin_inds": "vp3hoering2021:vp3h2021_delopl_marin_inds",
         "vp3h2021_distrikter": "vp3hoering2021:vp3h2021_distrikter",
         "vp3h2021_foelsomindvindingomr": "vp3hoering2021:vp3h2021_foelsomindvindingomr",
         "vp3h2021_fugle_beskyt": "vp3hoering2021:vp3h2021_fugle_beskyt",
         "vp3h2021_grv_dyb_trend": "vp3hoering2021:vp3h2021_grv_dyb_trend",
         "vp3h2021_grv_dyb_trend_rev": "vp3hoering2021:vp3h2021_grv_dyb_trend_rev",
         "vp3h2021_grv_maalestation_dyb": "vp3hoering2021:vp3h2021_grv_maalestation_dyb",
         "vp3h2021_grv_maalestation_reg": "vp3hoering2021:vp3h2021_grv_maalestation_reg",
         "vp3h2021_grv_maalestation_terr": "vp3hoering2021:vp3h2021_grv_maalestation_terr",
         "vp3h2021_grv_reg_trend": "vp3hoering2021:vp3h2021_grv_reg_trend",
         "vp3h2021_grv_reg_trend_rev": "vp3hoering2021:vp3h2021_grv_reg_trend_rev",
         "vp3h2021_grv_samlet_dyb": "vp3hoering2021:vp3h2021_grv_samlet_dyb",
         "vp3h2021_grv_samlet_reg": "vp3hoering2021:vp3h2021_grv_samlet_reg",
         "vp3h2021_grv_samlet_terr": "vp3hoering2021:vp3h2021_grv_samlet_terr",
         "vp3h2021_grv_terr_trend": "vp3hoering2021:vp3h2021_grv_terr_trend",
         "vp3h2021_grv_terr_trend_rev": "vp3hoering2021:vp3h2021_grv_terr_trend_rev",
         "vp3h2021_gvf_kemisk": "vp3hoering2021:vp3h2021_gvf_kemisk",
         "vp3h2021_gvf_risiko": "vp3hoering2021:vp3h2021_gvf_risiko",
         "vp3h2021_habitatomr": "vp3hoering2021:vp3h2021_habitatomr",
         "vp3h2021_havne": "vp3hoering2021:vp3h2021_havne",
         "vp3h2021_hovedoplande": "vp3hoering2021:vp3h2021_hovedoplande",
         "vp3h2021_klappladser": "vp3hoering2021:vp3h2021_klappladser",
         "vp3h2021_lulc_map_poly": "vp3hoering2021:vp3h2021_lulc_map_poly",
         "vp3h2021_marin_fys_konstr": "vp3hoering2021:vp3h2021_marin_fys_konstr",
         "vp3h2021_marin_saml_punkt": "vp3hoering2021:vp3h2021_marin_saml_punkt",
         "vp3h2021_marin_samlet": "vp3hoering2021:vp3h2021_marin_samlet",
         "vp3h2021_marin_samlet_1mil": "vp3hoering2021:vp3h2021_marin_samlet_1mil",
         "vp3h2021_natura_2000_omraader": "vp3hoering2021:vp3h2021_natura_2000_omraader",
         "vp3h2021_opl_delopl": "vp3hoering2021:vp3h2021_opl_delopl",
         "vp3h2021_opl_helopl": "vp3hoering2021:vp3h2021_opl_helopl",
         "vp3h2021_opl_marin_inds": "vp3hoering2021:vp3h2021_opl_marin_inds",
         "vp3h2021_opl_rensekl_inds": "vp3hoering2021:vp3h2021_opl_rensekl_inds",
         "vp3h2021_opl_rensekl_pavirk": "vp3hoering2021:vp3h2021_opl_rensekl_pavirk",
         "vp3h2021_opl_soe_inds": "vp3hoering2021:vp3h2021_opl_soe_inds",
         "vp3h2021_ov_maalestation_marin": "vp3hoering2021:vp3h2021_ov_maalestation_marin",
         "vp3h2021_ov_maalestation_soe": "vp3hoering2021:vp3h2021_ov_maalestation_soe",
         "vp3h2021_ov_maalestation_vandl": "vp3hoering2021:vp3h2021_ov_maalestation_vandl",
         "vp3h2021_punkt_ferskdam_saml": "vp3hoering2021:vp3h2021_punkt_ferskdam_saml",
         "vp3h2021_punkt_havdam_saml": "vp3hoering2021:vp3h2021_punkt_havdam_saml",
         "vp3h2021_punkt_ind_saml": "vp3hoering2021:vp3h2021_punkt_ind_saml",
         "vp3h2021_punkt_rbu_saml": "vp3hoering2021:vp3h2021_punkt_rbu_saml",
         "vp3h2021_punkt_rens_saml": "vp3hoering2021:vp3h2021_punkt_rens_saml",
         "vp3h2021_punkt_spredt_saml": "vp3hoering2021:vp3h2021_punkt_spredt_saml",
         "vp3h2021_raastofomr": "vp3hoering2021:vp3h2021_raastofomr",
         "vp3h2021_ramsaromr": "vp3hoering2021:vp3h2021_ramsaromr",
         "vp3h2021_sargasso_2014_2017": "vp3hoering2021:vp3h2021_sargasso_2014_2017",
         "vp3h2021_skaldyrvande": "vp3hoering2021:vp3h2021_skaldyrvande",
         "vp3h2021_soe_saml_punkt": "vp3hoering2021:vp3h2021_soe_saml_punkt",
         "vp3h2021_soe_samlet": "vp3hoering2021:vp3h2021_soe_samlet",
         "vp3h2021_spaerring_samlet": "vp3hoering2021:vp3h2021_spaerring_samlet",
         "vp3h2021_sparring": "vp3hoering2021:vp3h2021_sparring",
         "vp3h2021_storresejlrender": "vp3hoering2021:vp3h2021_storresejlrender",
         "vp3h2021_sw_mfs_tilstand": "vp3hoering2021:vp3h2021_sw_mfs_tilstand",
         "vp3h2021_v1_v2_overfladevand": "vp3hoering2021:vp3h2021_v1_v2_overfladevand",
         "vp3h2021_vandindvinding": "vp3hoering2021:vp3h2021_vandindvinding",
         "vp3h2021_vandloeb_saml_punkt": "vp3hoering2021:vp3h2021_vandloeb_saml_punkt",
         "vp3h2021_vandloeb_samlet": "vp3hoering2021:vp3h2021_vandloeb_samlet",
         "vp3tilstand2021_distrikter": "vp3tilstand2021:vp3tilstand2021_distrikter",
         "vp3tilstand2021_grv_samlet_dyb": "vp3tilstand2021:vp3tilstand2021_grv_samlet_dyb",
         "vp3tilstand2021_grv_samlet_reg": "vp3tilstand2021:vp3tilstand2021_grv_samlet_reg",
         "vp3tilstand2021_grv_samlet_terr": "vp3tilstand2021:vp3tilstand2021_grv_samlet_terr",
         "vp3tilstand2021_hovedoplande": "vp3tilstand2021:vp3tilstand2021_hovedoplande",
         "vp3tilstand2021_marin_saml_punkt": "vp3tilstand2021:vp3tilstand2021_marin_saml_punkt",
         "vp3tilstand2021_marin_samlet": "vp3tilstand2021:vp3tilstand2021_marin_samlet",
         "vp3tilstand2021_marin_samlet_1mil": "vp3tilstand2021:vp3tilstand2021_marin_samlet_1mil",
         "vp3tilstand2021_ov_maalestation_marin": "vp3tilstand2021:vp3tilstand2021_ov_maalestation_marin"
      }
   },
   "Vejman.dk": {
      endpoint: "https://vmgeoserver.vd.dk/geoserver/ows",
      featureTypes: {
         "Adgange": "VD:TEMA_ADMISSION",
         "CPR-vejnavne": "VD:vm_cpr_vejnavn",
         "CSEGEOMVIEW": "VD:CSEGEOMVIEW",
         "DGP grundkort": "VD:DGP_GGK",
         "Frakørsler": "VD:Frakoersler",
         "GPS_TRACK": "VD:GPS_TRACK",
         "GPS_TRACK_TODAY": "VD:GPS_TRACK_TODAY",
         "IntersectionPointVisualization": "STATIC:IntersectionPointVisualization-twolegged",
         "IntersectionVisualization": "STATIC:IntersectionVisualization-twolegged",
         "Kommuner": "VD:kommunegraenser",
         "MARIUSDISTRIBUTION": "VD:MARIUSDISTRIBUTION",
         "Mastra nøgletal": "VD:MASTRA_NOEGLETAL_GEO",
         "Mindre anlæg": "VD:MIN_ANL",
         "Omraade_region": "VD:Omraade_region",
         "PROVISION": "VD:PROVISION",
         "Rastepladser": "VD:tra_servicearea",
         "Rastepladser Lastbil Bus": "VD:tra_servicearea_truck_bus",
         "Ruter": "VD:vm_aroute",
         "Skadespoint": "VD:vm_skadespoint",
         "Stier-materialiseret": "VD:Stier-materialiseret",
         "Større anlæg": "VD:ST_ANL",
         "TEMA_KRYDS_REFSYS": "VD:TEMA_KRYDS_REFSYS",
         "TEMA_MARIUS_EQA": "VD:TEMA_MARIUS_EQA",
         "TEMA_MARIUS_EQA_ASFALTKANT": "VD:TEMA_MARIUS_EQA_ASFALTKANT",
         "TEMA_PROVISION": "VD:TEMA_PROVISION",
         "TEMA_VEJE": "VD:TEMA_VEJE",
         "TEMA_VEJLISTE": "VD:TEMA_VEJLISTE",
         "Traengselsplet": "VD:Traengselsplet",
         "Tungvognsvejnet": "VD:vma_heavynetwork",
         "Tværprofil type-Vej": "VD:vm_tpe_vstype",
         "Vejlængder": "VD:vm_lgd",
         "adgangsbegraensning": "NRPUB:adgangsbegraensning",
         "adm_marks": "VD:adm_marks",
         "belops_skadespoint": "VD:belops_skadespoint",
         "cykelstitaellinger": "VD:cykelstitaellinger",
         "dgoods": "VD:dgoods",
         "dgoods_objects": "VD:dgoods_objects",
         "gc_komfort": "staging:gc_komfort",
         "geometry_collections": "VD:geometry_collections",
         "gs-ping": "VD:gs-ping",
         "klassificerede_strk": "test:klassificerede_strk",
         "modul_objects_vejnetomr": "VD:modul_objects_vejnetomr",
         "odense_admdata": "VD:odense_admdata",
         "oov_stratnet": "OOV:oov_stratnet",
         "rastepladser": "VD:rastepladser",
         "regnvandsbassiner": "regnvand:regnvandsbassiner",
         "samkorselspladser": "VD:samkorselspladser",
         "stoejkurver": "VD:stoejkurver",
         "stoejskaerme": "VD:stoejskaerme",
         "tra_bygvaerker_med_frihoejde": "VD:tra_bygvaerker_med_frihoejde",
         "tra_bygvaerker_med_vaegtbegraensning": "VD:tra_bygvaerker_med_vaegtbegraensning",
         "tra_heavynetwork": "VD:tra_heavynetwork",
         "traengsel": "VD:traengsel",
         "vejadgang": "NRPUB:vejadgang",
         "vejbyggelinjer": "NRPUB:vejbyggelinjer",
         "veje_frihoejde": "VD:veje_frihoejde",
         "veje_vaegtbegraensning": "VD:veje_vaegtbegraensning",
         "vm_Aabningsaar": "VD:vm_Aabningsaar",
         "vm_Vejservice": "VD:vm_Vejservice",
         "vm_acc_cross_error": "VD:vm_acc_cross_error",
         "vm_adm_trafik": "VD:vm_adm_trafik",
         "vm_admcpr": "VD:vm_admcpr",
         "vm_asfaltkant_h": "VD:vm_asfaltkant_h",
         "vm_asfaltkant_v": "VD:vm_asfaltkant_v",
         "vm_autovaern": "VD:vm_autovaern",
         "vm_bbr": "VD:vm_bbr",
         "vm_begraensninger": "VD:vm_begraensninger",
         "vm_bredde_belaeg": "VD:vm_bredde_belaeg",
         "vm_busfortov_vside": "VD:vm_busfortov_vside",
         "vm_busfortov_vside_15": "VD:vm_busfortov_vside_15",
         "vm_bygvaerk": "VD:vm_bygvaerk",
         "vm_cycleway": "staging:vm_cycleway",
         "vm_cykelsti_vside": "VD:vm_cykelsti_vside",
         "vm_cykelsti_vside_15": "VD:vm_cykelsti_vside_15",
         "vm_dir_route": "VD:vm_dir_route",
         "vm_droute_cached": "VD:vm_droute_cached",
         "vm_fortov_vside": "VD:vm_fortov_vside",
         "vm_fortov_vside_15": "VD:vm_fortov_vside_15",
         "vm_fortovcykelsti_vs": "VD:vm_fortovcykelsti_vs",
         "vm_intersection": "VD:vm_intersection",
         "vm_komfort": "VD:vm_komfort",
         "vm_mapinet": "VD:vm_mapinet",
         "vm_metais": "VD:vm_metais",
         "vm_modul_objects": "VD:vm_modul_objects",
         "vm_pathproj": "VD:vm_pathproj",
         "vm_roadwork_layer": "VD:vm_roadwork_layer",
         "vm_servicearea_l_geo": "VD:vm_servicearea_l_geo",
         "vm_slidlag": "VD:vm_slidlag",
         "vm_sti_vside": "VD:vm_sti_vside",
         "vm_sti_vside_15": "VD:vm_sti_vside_15",
         "vm_ternveje": "VD:vm_ternveje",
         "vm_tpe": "VD:vm_tpe",
         "vm_udbudt_strk": "VD:vm_udbudt_strk",
         "vm_veje": "VD:vm_veje",
         "vm_veje_m_kryds": "VD:vm_veje_m_kryds",
         "vm_veje_m_kryds_vside": "VD:vm_veje_m_kryds_vside",
         "vm_veje_m_kryds_vside_15": "VD:vm_veje_m_kryds_vside_15",
         "vm_veje_mellem_kryds": "VD:vm_veje_mellem_kryds",
         "vm_veje_vside": "VD:vm_veje_vside",
         "vm_veje_vside_15": "VD:vm_veje_vside_15",
         "vm_vejlgd_vejid": "VD:vm_vejlgd_vejid",
         "vm_vintervedligehold": "VD:vm_vintervedligehold",
         "vma_admvejdelstype": "VD:vma_admvejdelstype",
         "vma_dgoods": "VD:vma_dgoods",
         "vma_ensretning": "VD:vma_ensretning",
         "vma_hastgraenser": "VD:vma_hastgraenser",
         "vma_justeringsareal": "VD:vma_justeringsareal",
         "vma_notesbog_punkt": "VD:vma_notesbog_punkt",
         "vma_restriktion": "VD:vma_restriktion",
         "vma_traffic": "VD:vma_traffic",
         "vmt_hastgraenser": "VD:vmt_hastgraenser"
      }
   },
   "Vejdirektoratet": {
      endpoint: "https://geocloud.vd.dk/CVF/wfs",
      featureTypes: {
         "CVF vej- og stinet": "CVF:veje",
         "Vejstrækninger med frihøjdebegrænsning": "CVF:veje_frihoejde",
         "Vejstrækninger med vægtbegrænsning": "CVF:veje_vaegtbegraensning"
      }
   },
   "Vejdirektoratet (Statsvej)": {
      endpoint: "https://geocloud.vd.dk/NR/ows",
      featureTypes: {
         "Adgang(Statsvej)": "NR:nr_adgang",
         "Adgangsbegrænsning (Statsvej)": "NR:nr_adgangsbegr",
         "Vejbyggelinje(Statsvej)": "NR:nr_byggelinjer"
      }
   },
   "FVM (Føde, Land og Fisk)": {
      endpoint: "https://geodata.fvm.dk/geoserver/ows",
      featureTypes: {
         "ANS18": "Jordbrugsanalyser:ANS18",
         "Ansoegere2010Til2017Sogn": "Jordbrugsanalyser:Ansoegere2010Til2017Sogn",
         "Ansoegere2010Til2018": "Jordbrugsanalyser:Ansoegere2010Til2018",
         "AnsoegereSogn2010Til2019": "Jordbrugsanalyser:AnsoegereSogn2010Til2019",
         "AnsoegereSogn2010Til2021": "Jordbrugsanalyser:AnsoegereSogn2010Til2021",
         "AnsoegereSogn2010Til2022": "Jordbrugsanalyser:AnsoegereSogn2010Til2022",
         "AnsoegereSogn2010Til2024": "Jordbrugsanalyser:AnsoegereSogn2010Til2024",
         "Ansoegere_Sogn_2010_2023": "Jordbrugsanalyser:Ansoegere_Sogn_2010_2023",
         "Ansoegningsrunder_2018": "Maalrettet_kvaelstofregulering:Ansoegningsrunder_2018",
         "Ansoegningsrunder_2019": "Maalrettet_kvaelstofregulering:Ansoegningsrunder_2019",
         "AnsogereSogn2010til2020": "Jordbrugsanalyser:AnsogereSogn2010til2020",
         "Ansøgere10": "Jordbrugsanalyser:Ansøgere10",
         "Ansøgere11": "Jordbrugsanalyser:Ansøgere11",
         "Ansøgere12": "Jordbrugsanalyser:Ansøgere12",
         "Ansøgere13": "Jordbrugsanalyser:Ansøgere13",
         "Ansøgere14": "Jordbrugsanalyser:Ansøgere14",
         "Ansøgere15": "Jordbrugsanalyser:Ansøgere15",
         "Ansøgere16": "Jordbrugsanalyser:Ansøgere16",
         "Ansøgere17": "Jordbrugsanalyser:Ansoegere17",
         "Ansøgere19": "Jordbrugsanalyser:Ansøgere19",
         "Ansøgere20": "Jordbrugsanalyser:Ansøgere20",
         "Ansøgere21": "Jordbrugsanalyser:Ansøgere21",
         "Ansøgere22": "Jordbrugsanalyser:Ansøgere22",
         "Ansøgere23": "Jordbrugsanalyser:Ansøgere23",
         "Ansøgere24": "Jordbrugsanalyser:Ansøgere24",
         "AnsøgereSogn2010Til2015": "Jordbrugsanalyser:AnsøgereSogn2010Til2015",
         "AnsøgereSogn2010Til2016": "Jordbrugsanalyser:AnsøgereSogn2010Til2016",
         "Arealanvendelse_2019": "GB_MFO_og_groenne_krav:Arealanvendelse_2019",
         "Arealanvendelse_2020": "GB_MFO_og_groenne_krav:Arealanvendelse_2020",
         "Arealanvendelse_2021": "GB_MFO_og_groenne_krav:Arealanvendelse_2021",
         "Arealanvendelse_2022": "GB_MFO_og_groenne_krav:Arealanvendelse_2022",
         "Arealanvendelse_2023": "GB_MFO_og_groenne_krav:Arealanvendelse_2023",
         "Arealanvendelse_2024": "GB_MFO_og_groenne_krav:Arealanvendelse_2024",
         "Arealer_pesticidfri_goedningsfri_drift_2024": "GB_og_bioordninger:Arealer_pesticidfri_goedningsfri_drift_2024",
         "Arealer_pesticidfri_goedningsfri_drift_2025": "GB_og_bioordninger:Arealer_pesticidfri_goedningsfri_drift_2025",
         "Artikel32_Afvist": "GB_MFO_og_groenne_krav:Artikel32_Afvist",
         "Artikel32_Godkendt": "GB_MFO_og_groenne_krav:Artikel32_Godkendt",
         "Baeredygtig_skovdrift": "Skovtilsagn:Baeredygtig_skovdrift",
         "Baeredygtig_skovdrift_ansoegt_2016": "Skovtilsagn:Baeredygtig_skovdrift_ansoegt_2016",
         "Biodiversitetsskov_2024": "Skovtilsagn:Biodiversitetsskov_2024",
         "Braemmepligtige_soer_i_2015": "Kommunebraemmer_2015:Braemmepligtige_soer_i_2015",
         "Braemmepligtige_vandloeb_i_2015": "Kommunebraemmer_2015:Braemmepligtige_vandloeb_i_2015",
         "Braemmer_2-metersbraemme_2023": "GB_og_bioordninger:Braemmer_2-metersbraemme_2023",
         "Braemmer_2-metersbraemme_2024": "GB_og_bioordninger:Braemmer_2-metersbraemme_2024",
         "Braemmer_2-metersbraemme_2025": "GB_og_bioordninger:Braemmer_2-metersbraemme_2025",
         "Braemmer_3-metersbraemme_2023": "GB_og_bioordninger:Braemmer_3-metersbraemme_2023",
         "Braemmer_3-metersbraemme_2024": "GB_og_bioordninger:Braemmer_3-metersbraemme_2024",
         "Braemmer_3-metersbraemme_2025": "GB_og_bioordninger:Braemmer_3-metersbraemme_2025",
         "CHR00": "Jordbrugsanalyser:CHR00",
         "CHR01": "Jordbrugsanalyser:CHR01",
         "CHR02": "Jordbrugsanalyser:CHR02",
         "CHR03": "Jordbrugsanalyser:CHR03",
         "CHR04": "Jordbrugsanalyser:CHR04",
         "CHR05": "Jordbrugsanalyser:CHR05",
         "CHR06": "Jordbrugsanalyser:CHR06",
         "CHR07": "Jordbrugsanalyser:CHR07",
         "CHR08": "Jordbrugsanalyser:CHR08",
         "CHR09": "Jordbrugsanalyser:CHR09",
         "CHR10": "Jordbrugsanalyser:CHR10",
         "CHR11": "Jordbrugsanalyser:CHR11",
         "CHR12": "Jordbrugsanalyser:CHR12",
         "CHR13": "Jordbrugsanalyser:CHR13",
         "CHR14": "Jordbrugsanalyser:CHR14",
         "CHR15": "Jordbrugsanalyser:CHR15",
         "CHR16": "Jordbrugsanalyser:CHR16",
         "CHR17": "Jordbrugsanalyser:CHR17",
         "CHR18": "Jordbrugsanalyser:CHR18",
         "CHR19": "Jordbrugsanalyser:CHR19",
         "CHR20": "Jordbrugsanalyser:CHR20",
         "CHR21": "Jordbrugsanalyser:CHR21",
         "CHR22": "Jordbrugsanalyser:CHR22",
         "CHR23": "Jordbrugsanalyser:CHR23",
         "CHR24": "Jordbrugsanalyser:CHR24",
         "CHRSogn2010til2020": "Jordbrugsanalyser:CHRSogn2010til2020",
         "CHRsogn0018": "Jordbrugsanalyser:CHRsogn0018",
         "CHRsogn2000Til2015": "Jordbrugsanalyser:CHRsogn0015",
         "CHRsogn2000Til2016": "Jordbrugsanalyser:CHRsogn2000Til2016",
         "CHRsogn2000Til2017": "Jordbrugsanalyser:CHRsogn2000Til2017",
         "CHRsogn2010Til2019": "Jordbrugsanalyser:CHRsogn2010Til2019",
         "CHRsogn2010Til2021": "Jordbrugsanalyser:CHRsogn2010Til2021",
         "CHRsogn2010Til2022": "Jordbrugsanalyser:CHRsogn2010Til2022",
         "CHRsogn2010Til2023": "Jordbrugsanalyser:CHRsogn2010Til2023",
         "CHRsogn2010Til2024": "Jordbrugsanalyser:CHRsogn2010Til2024",
         "Ekstensivering_med_slaet": "Miljoe_og_oekologitilsagn:Ekstensivering_med_slaet",
         "Etablering_og_genopretning_kopi": "Natur_og_miljoeprojekter:Etablering_og_genopretning kopi",
         "Forberedelse_til_afgraesning": "N2000_projekter:Forberedelse_til_afgraesning",
         "Fosfor_E_samlet": "Vandprojekter:Fosfor_E_samlet",
         "Fosfor_F_samlet": "Vandprojekter:Fosfor_F_samlet",
         "Fradrag_grundbetaling_2018": "GB_MFO_og_groenne_krav:Fradrag_grundbetaling_2018",
         "Fradrag_grundbetaling_2019": "GB_MFO_og_groenne_krav:Fradrag_grundbetaling_2019",
         "Fradrag_grundbetaling_2020": "GB_MFO_og_groenne_krav:Fradrag_grundbetaling_2020",
         "Fradrag_grundbetaling_2021": "GB_MFO_og_groenne_krav:Fradrag_grundbetaling_2021",
         "Fradrag_grundbetaling_2022": "GB_MFO_og_groenne_krav:Fradrag_grundbetaling_2022",
         "Fradrag_grundbetaling_2023": "GB_MFO_og_groenne_krav:Fradrag_grundbetaling_2023",
         "Fradrag_grundbetaling_2024": "GB_MFO_og_groenne_krav:Fradrag_grundbetaling_2024",
         "Fradrag_grundbetaling_2025": "GB_MFO_og_groenne_krav:Fradrag_grundbetaling_2025",
         "Fradrag_grundbetaling_2026": "GB_MFO_og_groenne_krav:Fradrag_grundbetaling_2026",
         "Fredede_arealer_med_dyrkningsrestriktioner_2024": "GB_og_bioordninger:Fredede_arealer_med_dyrkningsrestriktioner_2024",
         "Fredede_arealer_med_dyrkningsrestriktioner_2025": "GB_og_bioordninger:Fredede_arealer_med_dyrkningsrestriktioner_2025",
         "Fuglevenlig_drift_2025": "Naturudpegninger:Fuglevenlig_drift_2025",
         "GLM7_samme_afgroedekategori_i_3aar_2025": "GB_og_bioordninger:GLM7_samme_afgroedekategori_i_3aar_2025",
         "GLM7_samme_afgroedekategori_i_3aar_2026": "GB_og_bioordninger:GLM7_samme_afgroedekategori_i_3aar_2026",
         "GLM9_forbud_mod_ploejning_og_omlaegning_2023": "GB_og_bioordninger:GLM9_forbud_mod_ploejning_og_omlaegning_2023",
         "GLM9_forbud_mod_ploejning_og_omlaegning_2024": "GB_og_bioordninger:GLM9_forbud_mod_ploejning_og_omlaegning_2024",
         "GLM9_forbud_mod_ploejning_og_omlaegning_2025": "GB_og_bioordninger:GLM9_forbud_mod_ploejning_og_omlaegning_2025",
         "GLM_Fortidsminder_2019": "GB_MFO_og_groenne_krav:GLM_Fortidsminder_2019",
         "GLM_Fortidsminder_2020": "GB_MFO_og_groenne_krav:GLM_Fortidsminder_2020",
         "GLM_Fortidsminder_2021": "GB_MFO_og_groenne_krav:GLM_Fortidsminder_2021",
         "GLM_Fortidsminder_2022": "GB_MFO_og_groenne_krav:GLM_Fortidsminder_2022",
         "GLM_Fortidsminder_2023": "GB_MFO_og_groenne_krav:GLM_Fortidsminder_2023",
         "GLM_Fortidsminder_2024": "GB_MFO_og_groenne_krav:GLM_Fortidsminder_2024",
         "GLM_Fortidsminder_2025": "GB_MFO_og_groenne_krav:GLM_Fortidsminder_2025",
         "GLM_Fortidsminder_2026": "GB_MFO_og_groenne_krav:GLM_Fortidsminder_2026",
         "GLM_Soer_2018": "GB_MFO_og_groenne_krav:GLM_Soer_2018",
         "GLM_Soer_2019": "GB_MFO_og_groenne_krav:GLM_Soer_2019",
         "GLM_Soer_2020": "GB_MFO_og_groenne_krav:GLM_Soer_2020",
         "GLM_Soer_2021": "GB_MFO_og_groenne_krav:GLM_Soer_2021",
         "GLM_Soer_2022": "GB_MFO_og_groenne_krav:GLM_Soer_2022",
         "GLM_Soer_2023": "GB_MFO_og_groenne_krav:GLM_Soer_2023",
         "GLM_Soer_2024": "GB_MFO_og_groenne_krav:GLM_Soer_2024",
         "GLM_Soer_2025": "GB_MFO_og_groenne_krav:GLM_Soer_2025",
         "GLM_Soer_2026": "GB_MFO_og_groenne_krav:GLM_Soer_2026",
         "GLM_fortidsminder_2018": "GB_MFO_og_groenne_krav:GLM_fortidsminder_2018",
         "GLM_jorderosion": "Jordbunds_og_terraenforhold:GLM_jorderosion",
         "Graes_i_5_aar_2016": "Permanent_graes:Graes_i_5_aar_2016",
         "Graes_i_5_aar_2017": "Permanent_graes:Graes_i_5_aar_2017",
         "Graes_i_5_aar_2018": "Permanent_graes:Graes_i_5_aar_2018",
         "Graes_i_5_aar_2019": "Permanent_graes:Graes_i_5_aar_2019",
         "Graes_i_5_aar_2020": "Permanent_graes:Graes_i_5_aar_2020",
         "Graes_i_5_aar_2021": "Permanent_graes:Graes_i_5_aar_2021",
         "Graes_i_5_aar_2022": "Permanent_graes:Graes_i_5_aar_2022",
         "Graes_i_5_aar_2023": "Permanent_graes:Graes_i_5_aar_2023",
         "Graes_i_5_aar_2024": "Permanent_graes:Graes_i_5_aar_2024",
         "Graesningsprojekt_Afgraesning": "Ovrige_projekter:Graesningsprojekt_Afgraesning",
         "HNV_1_4_2019": "Naturudpegninger:HNV_1_4_2019",
         "HNV_1_4_2020": "Naturudpegninger:HNV_1_4_2020",
         "HNV_1_4_2021": "Naturudpegninger:HNV_1_4_2021",
         "HNV_1_4_2022": "Naturudpegninger:HNV_1_4_2022",
         "HNV_1_4_2023": "Naturudpegninger:HNV_1_4_2023",
         "HNV_1_4_2024": "Naturudpegninger:HNV_1_4_2024",
         "HNV_1_4_2025": "Naturudpegninger:HNV_1_4_2025",
         "HNV_1_4_Aug2025": "Naturudpegninger:HNV_1_4_Aug2025",
         "HNV_5_13_2019": "Naturudpegninger:HNV_5_13_2019",
         "HNV_5_13_2020": "Naturudpegninger:HNV_5_13_2020",
         "HNV_5_13_2021": "Naturudpegninger:HNV_5_13_2021",
         "HNV_5_13_2022": "Naturudpegninger:HNV_5_13_2022",
         "HNV_5_13_2023": "Naturudpegninger:HNV_5_13_2023",
         "HNV_5_13_2024": "Naturudpegninger:HNV_5_13_2024",
         "HNV_5_13_2025": "Naturudpegninger:HNV_5_13_2025",
         "HNV_5_13_Aug2025": "Naturudpegninger:HNV_5_13_Aug2025",
         "HNV_skov_2024": "Naturudpegninger:HNV_skov_2024",
         "Husdyrefterafgroedekrav_2022": "Husdyrefterafgroeder:Husdyrefterafgroedekrav_2022",
         "Husdyrefterafgroedekrav_2023": "Husdyrefterafgroeder:Husdyrefterafgroedekrav_2023",
         "Husdyrefterafgroedekrav_2024": "Husdyrefterafgroeder:Husdyrefterafgroedekrav_2024",
         "Husdyrefterafgroedekrav_2025": "Husdyrefterafgroeder:Husdyrefterafgroedekrav_2025",
         "HusdyrtrykOplande2007Til2015": "Jordbrugsanalyser:HusdyrtrykOplande2007Til2015",
         "HusdyrtrykOplande2007Til2016": "Jordbrugsanalyser:HusdyrtrykOplande2007Til2016",
         "Hydrologi_E": "N2000_projekter:Hydrologi_E",
         "Hydrologi_F": "N2000_projekter:Hydrologi_F",
         "ID15oplande": "Vandprojekter:ID15oplande",
         "ID15oplande_2024": "Vandmiljoeplaner:ID15oplande_2024",
         "Ikke-direktivimplementerende_2025": "GB_og_bioordninger:Ikke-direktivimplementerende_2025",
         "Indsatsbehov": "Vandprojekter:Indsatsbehov",
         "Indsatsbehov_maalrettet_kvaelstofregulering_2021": "Maalrettet_kvaelstofregulering:Indsatsbehov_maalrettet_kvaelstofregulering_2021",
         "Indsatsbehov_maalrettet_kvaelstofregulering_2022": "Maalrettet_kvaelstofregulering:Indsatsbehov_maalrettet_kvaelstofregulering_2022",
         "Indsatsbehov_maalrettet_kvaelstofregulering_2023": "Maalrettet_kvaelstofregulering:Indsatsbehov_maalrettet_kvaelstofregulering_2023",
         "Indsatsbehov_maalrettet_kvaelstofregulering_2024": "Maalrettet_kvaelstofregulering:Indsatsbehov_maalrettet_kvaelstofregulering_2024",
         "Indsatsbehov_maalrettet_kvaelstofregulering_2025": "Maalrettet_kvaelstofregulering:Indsatsbehov_maalrettet_kvaelstofregulering_2025",
         "Jordbeholdning": "MARS:Jordbeholdning",
         "Jordbundskort2014": "Jordbrugsanalyser:Jordbundskort2014",
         "Jordbundskort_2014": "Jordbunds_og_terraenforhold:Jordbundskort_2014",
         "Jordbundskort_2019": "Jordbunds_og_terraenforhold:Jordbundskort_2019",
         "Jordbundskort_2024": "Jordbunds_og_terraenforhold:Jordbundskort_2024",
         "Kvaelstof_E_samlet": "Vandprojekter:Kvaelstof_E_samlet",
         "Kvaelstof_F_samlet": "Vandprojekter:Kvaelstof_F_samlet",
         "Kvaelstofretention": "Jordbunds_og_terraenforhold:Kvaelstofretention",
         "Kystvandoplande": "Husdyrefterafgroeder:Kystvandoplande",
         "Kystvandoplande_VP2": "Vandprojekter:Kystvandoplande_VP2",
         "Kystvandoplande_VP3": "Vandprojekter:Kystvandoplande_VP3",
         "Kystvandoplande_VP3_2024": "Vandmiljoeplaner:Kystvandoplande_VP3_2024",
         "Lavbund_E_samlet": "Vandprojekter:Lavbund_E_samlet",
         "Lavbund_F_samlet": "Vandprojekter:Lavbund_F_samlet",
         "Lavbund_Potentialekort": "Vandprojekter:Lavbund_Potentialekort",
         "Levende_hegn": "Ovrige_projekter:Levende_hegn",
         "MFO_Randzone_Braemmekort_2017": "GB_MFO_og_groenne_krav:MFO_Randzone_Braemmekort_2017",
         "Maalrettede_efterafgroeder_2018": "Maalrettet_kvaelstofregulering:Maalrettede_efterafgroeder_2018",
         "Maalrettede_efterafgroeder_2019": "Maalrettet_kvaelstofregulering:Maalrettede_efterafgroeder_2019",
         "Maalrettede_kvaelstofregulering2020": "Maalrettet_kvaelstofregulering:Maalrettede_kvaelstofregulering2020",
         "MarkblokkeSogn2007Til2015": "Jordbrugsanalyser:MarkblokkeSogn2007Til2015",
         "MarkblokkeSogn2007til2016": "Jordbrugsanalyser:MarkblokkeSogn2007til2016",
         "MarkblokkeSogn2007til2017": "Jordbrugsanalyser:MarkblokkeSogn2007til2017",
         "MarkblokkeSogn2007til2018": "Jordbrugsanalyser:MarkblokkeSogn2007til2018",
         "MarkblokkeSogn2007til2019": "Jordbrugsanalyser:MarkblokkeSogn2007til2019",
         "MarkblokkeSogn2007til2020": "Jordbrugsanalyser:MarkblokkeSogn2007til2020",
         "MarkblokkeSogn2007til2021": "Jordbrugsanalyser:MarkblokkeSogn2007til2021",
         "MarkblokkeSogn2007til2022": "Jordbrugsanalyser:MarkblokkeSogn2007til2022",
         "MarkblokkeSogn2010til2021": "Jordbrugsanalyser:MarkblokkeSogn2010til2021",
         "MarkblokkeSogn2010til2022": "Jordbrugsanalyser:MarkblokkeSogn2010til2022",
         "MarkblokkeSogn2010til2023": "Jordbrugsanalyser:MarkblokkeSogn2010til2023",
         "MarkblokkeSogn2010til2024": "Jordbrugsanalyser:MarkblokkeSogn2010til2024",
         "Markblokke_2005": "Markblokke:Markblokke_2005",
         "Markblokke_2006": "Markblokke:Markblokke_2006",
         "Markblokke_2007": "Markblokke:Markblokke_2007",
         "Markblokke_2008": "Markblokke:Markblokke_2008",
         "Markblokke_2009": "Markblokke:Markblokke_2009",
         "Markblokke_2010": "Markblokke:Markblokke_2010",
         "Markblokke_2011": "Markblokke:Markblokke_2011",
         "Markblokke_2012": "Markblokke:Markblokke_2012",
         "Markblokke_2013": "Markblokke:Markblokke_2013",
         "Markblokke_2014": "Markblokke:Markblokke_2014",
         "Markblokke_2015": "Markblokke:Markblokke_2015",
         "Markblokke_2016": "Markblokke:Markblokke_2016",
         "Markblokke_2017": "Markblokke:Markblokke_2017",
         "Markblokke_2018": "Markblokke:Markblokke_2018",
         "Markblokke_2019": "Markblokke:Markblokke_2019",
         "Markblokke_2020": "Markblokke:Markblokke_2020",
         "Markblokke_2021": "Markblokke:Markblokke_2021",
         "Markblokke_2022": "Markblokke:Markblokke_2022",
         "Markblokke_2023": "Markblokke:Markblokke_2023",
         "Markblokke_2024": "Markblokke:Markblokke_2024",
         "Markblokke_2025": "Markblokke:Markblokke_2025",
         "Markblokke_2026": "Markblokke:Markblokke_2026",
         "Marker 12": "Jordbrugsanalyser:Marker12",
         "Marker13": "Jordbrugsanalyser:Marker13",
         "Marker14": "Jordbrugsanalyser:Marker14",
         "Marker15": "Jordbrugsanalyser:Marker15",
         "Marker16": "Jordbrugsanalyser:Marker16",
         "Marker17": "Jordbrugsanalyser:Marker17",
         "Marker18": "Jordbrugsanalyser:Marker18",
         "Marker19": "Jordbrugsanalyser:Marker19",
         "Marker20": "Jordbrugsanalyser:Marker20",
         "Marker21": "Jordbrugsanalyser:Marker21",
         "Marker22": "Jordbrugsanalyser:Marker22",
         "Marker23": "Jordbrugsanalyser:Marker23",
         "Marker24": "Jordbrugsanalyser:Marker24",
         "Marker_2008": "Marker:Marker_2008",
         "Marker_2009": "Marker:Marker_2009",
         "Marker_2010": "Marker:Marker_2010",
         "Marker_2011": "Marker:Marker_2011",
         "Marker_2012": "Marker:Marker_2012",
         "Marker_2013": "Marker:Marker_2013",
         "Marker_2014": "Marker:Marker_2014",
         "Marker_2015": "Marker:Marker_2015",
         "Marker_2016": "Marker:Marker_2016",
         "Marker_2017": "Marker:Marker_2017",
         "Marker_2018": "Marker:Marker_2018",
         "Marker_2019": "Marker:Marker_2019",
         "Marker_2020": "Marker:Marker_2020",
         "Marker_2021": "Marker:Marker_2021",
         "Marker_2022": "Marker:Marker_2022",
         "Marker_2023": "Marker:Marker_2023",
         "Marker_2024": "Marker:Marker_2024",
         "Marker_2025": "Marker:Marker_2025",
         "Marker_2026": "Marker:Marker_2026",
         "Markkrat_2024": "GB_og_bioordninger:Markkrat_2024",
         "Markkrat_2025": "GB_og_bioordninger:Markkrat_2025",
         "Markkrat_2026": "GB_og_bioordninger:Markkrat_2026",
         "Miljoe_og_Klimavenligt_graes_2023": "GB_og_bioordninger:Miljoe_og_Klimavenligt_graes_2023",
         "Miljoe_og_Klimavenligt_graes_2024": "GB_og_bioordninger:Miljoe_og_Klimavenligt_graes_2024",
         "Miljoe_og_Klimavenligt_graes_2025": "GB_og_bioordninger:Miljoe_og_Klimavenligt_graes_2025",
         "Miljoemaessigt_saarbare_omraader": "GB_MFO_og_groenne_krav:Miljoemaessigt_saarbare_omraader",
         "Miljoetilsagn_12_50_55_2012": "Miljoe_og_oekologitilsagn:Miljoetilsagn_12_50_55_2012",
         "Miljoetilsagn_12_50_55_2013": "Miljoe_og_oekologitilsagn:Miljoetilsagn_12_50_55_2013",
         "Miljoetilsagn_oevrige_typer_2012": "Miljoe_og_oekologitilsagn:Miljoetilsagn_oevrige_typer_2012",
         "Miljoetilsagn_oevrige_typer_2013": "Miljoe_og_oekologitilsagn:Miljoetilsagn_oevrige_typer_2013",
         "Miljoetilsagn_oevrige_typer_2014": "Miljoe_og_oekologitilsagn:Miljoetilsagn_oevrige_typer_2014",
         "Miljoetilsagn_oevrige_typer_2015": "Miljoe_og_oekologitilsagn:Miljoetilsagn_oevrige_typer_2015",
         "Miljoetilsagn_oevrige_typer_2016": "Miljoe_og_oekologitilsagn:Miljoetilsagn_oevrige_typer_2016",
         "Miljoetilsagn_oevrige_typer_2017": "Miljoe_og_oekologitilsagn:Miljoetilsagn_oevrige_typer_2017",
         "Miljoetilsagn_oevrige_typer_2018": "Miljoe_og_oekologitilsagn:Miljoetilsagn_oevrige_typer_2018",
         "Miljoetilsagn_oevrige_typer_2019": "Miljoe_og_oekologitilsagn:Miljoetilsagn_oevrige_typer_2019",
         "Miljoetilsagn_oevrige_typer_2020": "Miljoe_og_oekologitilsagn:Miljoetilsagn_oevrige_typer_2020",
         "Miljoetilsagn_oevrige_typer_2021": "Miljoe_og_oekologitilsagn:Miljoetilsagn_oevrige_typer_2021",
         "Miljoetilsagn_oevrige_typer_2022": "Miljoe_og_oekologitilsagn:Miljoetilsagn_oevrige_typer_2022",
         "Miljoetilsagn_oevrige_typer_2023": "Miljoe_og_oekologitilsagn:Miljoetilsagn_oevrige_typer_2023",
         "Miljoetilsagn_vaadomraader_2014": "Miljoe_og_oekologitilsagn:Miljoetilsagn_vaadomraader_2014",
         "Miljoetilsagn_vaadomraader_2015": "Miljoe_og_oekologitilsagn:Miljoetilsagn_vaadomraader_2015",
         "Miljoetilsagn_vaadomraader_2016": "Miljoe_og_oekologitilsagn:Miljoetilsagn_vaadomraader_2016",
         "Miljoetilsagn_vaadomraader_2017": "Miljoe_og_oekologitilsagn:Miljoetilsagn_vaadomraader_2017",
         "Miljoetilsagn_vaadomraader_2018": "Miljoe_og_oekologitilsagn:Miljoetilsagn_vaadomraader_2018",
         "Miljoetilsagn_vaadomraader_2019": "Miljoe_og_oekologitilsagn:Miljoetilsagn_vaadomraader_2019",
         "Miljoetilsagn_vaadomraader_2020": "Miljoe_og_oekologitilsagn:Miljoetilsagn_vaadomraader_2020",
         "Miljoetilsagn_vaadomraader_2021": "Miljoe_og_oekologitilsagn:Miljoetilsagn_vaadomraader_2021",
         "Miljoetilsagn_vaadomraader_2022": "Miljoe_og_oekologitilsagn:Miljoetilsagn_vaadomraader_2022",
         "Miljoetilsagn_vaadomraader_2023": "Miljoe_og_oekologitilsagn:Miljoetilsagn_vaadomraader_2023",
         "Miljoetilsagn_vaadomraader_2024": "Miljoe_og_oekologitilsagn:Miljoetilsagn_vaadomraader_2024",
         "Minivaadomraadekort_bekendtgoerelse_hoering_2025": "Vandprojekter:Minivaadomraadekort_bekendtgoerelse_hoering_2025",
         "Minivaadomraadekort_efter_hoering_2022": "Vandprojekter:Minivaadomraadekort_efter_hoering_2022",
         "Minivaadomraadekort_efter_hoering_2023": "Vandprojekter:Minivaadomraadekort_efter_hoering_2023",
         "Minivaadomraadekort_efter_hoering_2024": "Vandprojekter:Minivaadomraadekort_efter_hoering_2024",
         "Minivaadomraadekort_efter_hoering_2025": "Vandprojekter:Minivaadomraadekort_efter_hoering_2025",
         "Minivaadomraadekort_foer_hoering_2022": "Vandprojekter:Minivaadomraadekort_foer_hoering_2022",
         "Minivaadomraadekort_foer_hoering_2023": "Vandprojekter:Minivaadomraadekort_foer_hoering_2023",
         "Minivaadomraadekort_foer_hoering_2024": "Vandprojekter:Minivaadomraadekort_foer_hoering_2024",
         "Minivaadomraadekort_foer_hoering_2025": "Vandprojekter:Minivaadomraadekort_foer_hoering_2025",
         "Minivaadomraader_ansoegt_2018": "Vandprojekter:Minivaadomraader_ansoegt_2018",
         "Minivaadomraader_ansoegt_2019": "Vandprojekter:Minivaadomraader_ansoegt_2019",
         "Minivaadomraader_ansoegt_2020": "Vandprojekter:Minivaadomraader_ansoegt_2020",
         "Minivaadomraader_ansoegt_2021": "Vandprojekter:Minivaadomraader_ansoegt_2021",
         "Minivaadomraader_ansoegt_2022": "Vandprojekter:Minivaadomraader_ansoegt_2022",
         "Minivaadomraader_ansoegt_2023": "Vandprojekter:Minivaadomraader_ansoegt_2023",
         "Minivaadomraader_ansoegt_2024": "Vandprojekter:Minivaadomraader_ansoegt_2024",
         "Minivaadomraader_ansoegt_2025": "Vandprojekter:Minivaadomraader_ansoegt_2025",
         "Minivaadomraader_udpegningskort_2023": "Vandprojekter:Minivaadomraader_udpegningskort_2023",
         "Minivaadomraader_udpegningskort_2024_kundgjort": "Vandprojekter:Minivaadomraader_udpegningskort_2024_kundgjort",
         "N2000_arealer_til_rydning": "N2000_udpegninger:N2000_arealer_til_rydning",
         "N2000_i_IMK_2019": "N2000_udpegninger:N2000_i_IMK_2019",
         "NP3_habitater_udpegningsgrundlag": "Husdyrefterafgroeder:NP3_habitater_udpegningsgrundlag",
         "Naerhed_habitatnatyrtyper_artslevesteder": "N2000_udpegninger:Naerhed_habitatnatyrtyper_artslevesteder",
         "Nationalparker": "N2000_udpegninger:Nationalparker",
         "OM_2012": "Miljoe_og_oekologitilsagn:OM_2012",
         "OM_2013": "Miljoe_og_oekologitilsagn:OM_2013",
         "OM_2014": "Miljoe_og_oekologitilsagn:OM_2014",
         "OM_2015": "Miljoe_og_oekologitilsagn:OM_2015",
         "OM_2016": "Miljoe_og_oekologitilsagn:OM_2016",
         "OM_2017": "Miljoe_og_oekologitilsagn:OM_2017",
         "OM_2018": "Miljoe_og_oekologitilsagn:OM_2018",
         "OM_2019": "Miljoe_og_oekologitilsagn:OM_2019",
         "O_Stotte": "O_Stotte:O_Stotte",
         "Obligatoriske_efterafgroeder_2018": "Maalrettet_kvaelstofregulering:Obligatoriske_efterafgroeder_2018",
         "Obligatoriske_maalrettede_efterafgroeder_2020": "Maalrettet_kvaelstofregulering:Obligatoriske_maalrettede_efterafgroeder_2020",
         "Obligatoriske_maalrettede_efterafgroeder_2021": "Maalrettet_kvaelstofregulering:Obligatoriske_maalrettede_efterafgroeder_2021",
         "Obligatoriske_maalrettede_efterafgroeder_2022": "Maalrettet_kvaelstofregulering:Obligatoriske_maalrettede_efterafgroeder_2022",
         "Obligatoriske_maalrettede_efterafgroeder_2023": "Maalrettet_kvaelstofregulering:Obligatoriske_maalrettede_efterafgroeder_2023",
         "Obligatoriske_maalrettede_efterafgroeder_2024": "Maalrettet_kvaelstofregulering:Obligatoriske_maalrettede_efterafgroeder_2024",
         "Obligatoriske_maalrettede_efterafgroeder_2025": "Maalrettet_kvaelstofregulering:Obligatoriske_maalrettede_efterafgroeder_2025",
         "Oekologiske_arealer_2012": "Miljoe_og_oekologitilsagn:Oekologiske_arealer_2012",
         "Oekologiske_arealer_2013": "Miljoe_og_oekologitilsagn:Oekologiske_arealer_2013",
         "Oekologiske_arealer_2014": "Miljoe_og_oekologitilsagn:Oekologiske_arealer_2014",
         "Oekologiske_arealer_2015": "Miljoe_og_oekologitilsagn:Oekologiske_arealer_2015",
         "Oekologiske_arealer_2016": "Miljoe_og_oekologitilsagn:Oekologiske_arealer_2016",
         "Oekologiske_arealer_2017": "Miljoe_og_oekologitilsagn:Oekologiske_arealer_2017",
         "Oekologiske_arealer_2018": "Miljoe_og_oekologitilsagn:Oekologiske_arealer_2018",
         "Oekologiske_arealer_2019": "Miljoe_og_oekologitilsagn:Oekologiske_arealer_2019",
         "Oekologiske_arealer_2020": "Miljoe_og_oekologitilsagn:Oekologiske_arealer_2020",
         "Oekologiske_arealer_2021": "Miljoe_og_oekologitilsagn:Oekologiske_arealer_2021",
         "Oekologiske_arealer_2022": "Miljoe_og_oekologitilsagn:Oekologiske_arealer_2022",
         "Oekologiske_arealer_2023": "Miljoe_og_oekologitilsagn:Oekologiske_arealer_2023",
         "Oekologiske_arealer_2024": "Miljoe_og_oekologitilsagn:Oekologiske_arealer_2024",
         "OmdrfitsarealerSogn2010til2020": "Jordbrugsanalyser:OmdrfitsarealerSogn2010til2020",
         "OmdriftsarealerSogn2010Til2015": "Jordbrugsanalyser:OmdriftsarealerSogn2010Til2015",
         "OmdriftsarealerSogn2010Til2016": "Jordbrugsanalyser:OmdriftsarealerSogn2010Til2016",
         "OmdriftsarealerSogn2010Til2017": "Jordbrugsanalyser:OmdriftsarealerSogn2010Til2017",
         "OmdriftsarealerSogn2010Til2018": "Jordbrugsanalyser:OmdriftsarealerSogn2010Til2018",
         "OmdriftsarealerSogn2010Til2019": "Jordbrugsanalyser:OmdriftsarealerSogn2010Til2019",
         "OmdriftsarealerSogn2010Til2021": "Jordbrugsanalyser:OmdriftsarealerSogn2010Til2021",
         "OmdriftsarealerSogn2010Til2022": "Jordbrugsanalyser:OmdriftsarealerSogn2010Til2022",
         "OmdriftsarealerSogn2010Til2023": "Jordbrugsanalyser:OmdriftsarealerSogn2010Til2023",
         "OmdriftsarealerSogn2010Til2024": "Jordbrugsanalyser:OmdriftsarealerSogn2010Til2024",
         "OmdriftsarealerSogn2010til2020": "Jordbrugsanalyser:OmdriftsarealerSogn2010til2020",
         "Paragraf3_i_IMK_2023": "Paragraf3:Paragraf3_i_IMK_2023",
         "Paragraf3_i_IMK_2024": "Paragraf3:Paragraf3_i_IMK_2024",
         "Paragraf3_i_IMK_2024_PE": "Paragraf3:Paragraf3_i_IMK_2024_PE",
         "Paragraf3_i_IMK_2025": "Paragraf3:Paragraf3_i_IMK_2025",
         "Paragraf3_soer_i_IMK_2023": "Paragraf3:Paragraf3_soer_i_IMK_2023",
         "Paragraf3_soer_i_IMK_2024": "Paragraf3:Paragraf3_soer_i_IMK_2024",
         "Paragraf3_soer_i_IMK_2024_PE": "Paragraf3:Paragraf3_soer_i_IMK_2024_PE",
         "Paragraf3_soer_i_IMK_2025": "Paragraf3:Paragraf3_soer_i_IMK_2025",
         "Permanent_ekstensivering_ansoegt_2024": "Miljoe_og_oekologitilsagn:Permanent_ekstensivering_ansoegt_2024",
         "Permanent_graes_2016": "Permanent_graes:Permanent_graes_2016",
         "Permanent_graes_2017": "Permanent_graes:Permanent_graes_2017",
         "Permanent_graes_2018": "Permanent_graes:Permanent_graes_2018",
         "Permanent_graes_2019": "Permanent_graes:Permanent_graes_2019",
         "Permanent_graes_2020": "Permanent_graes:Permanent_graes_2020",
         "Permanent_graes_2021": "Permanent_graes:Permanent_graes_2021",
         "Permanent_graes_2022": "Permanent_graes:Permanent_graes_2022",
         "Permanent_graes_2023": "Permanent_graes:Permanent_graes_2023",
         "Permanent_graes_2024": "Permanent_graes:Permanent_graes_2024",
         "Permanent_graes_i_MSO_2016": "Permanent_graes:Permanent_graes_i_MSO_2016",
         "Permanent_graes_i_MSO_2017": "Permanent_graes:Permanent_graes_i_MSO_2017",
         "Permanent_graes_i_MSO_2018": "Permanent_graes:Permanent_graes_i_MSO_2018",
         "Permanent_graes_i_MSO_2019": "Permanent_graes:Permanent_graes_i_MSO_2019",
         "Permanent_graes_i_MSO_2020": "Permanent_graes:Permanent_graes_i_MSO_2020",
         "Permanent_graes_i_MSO_2021": "Permanent_graes:Permanent_graes_i_MSO_2021",
         "Potentialkort_oekomarker2017": "Biavl:Potentialkort_oekomarker2017",
         "Privat_skovrejsning_ansoegt_2016": "Skovtilsagn:Privat_skovrejsning_ansoegt_2016",
         "Privat_skovrejsning_ansoegt_2017": "Skovtilsagn:Privat_skovrejsning_ansoegt_2017",
         "Privat_skovrejsning_ansoegt_2018": "Skovtilsagn:Privat_skovrejsning_ansoegt_2018",
         "Privat_skovrejsning_ansoegt_2019": "Skovtilsagn:Privat_skovrejsning_ansoegt_2019",
         "Privat_skovrejsning_ansoegt_2020": "Skovtilsagn:Privat_skovrejsning_ansoegt_2020",
         "Privat_skovrejsning_ansoegt_2021": "Skovtilsagn:Privat_skovrejsning_ansoegt_2021",
         "Privat_skovrejsning_ansoegt_2022": "Skovtilsagn:Privat_skovrejsning_ansoegt_2022",
         "Privat_skovrejsning_ansoegt_2023": "Skovtilsagn:Privat_skovrejsning_ansoegt_2023",
         "Privat_skovrejsning_ansoegt_2024": "Skovtilsagn:Privat_skovrejsning_ansoegt_2024",
         "Privat_skovrejsning_ansoegt_2025": "Skovtilsagn:Privat_skovrejsning_ansoegt_2025",
         "Privat_skovrejsning_ansoegt_samlet": "Skovtilsagn:Privat_skovrejsning_ansoegt_samlet",
         "Private_vaadomraader": "Vandprojekter:Private_vaadomraader",
         "Referencekort_2017-2021": "Engangskompensation:Referencekort_2017-2021",
         "Referencekort_2021-2023": "Engangskompensation:Referencekort_2021-2023",
         "Registreret_GB_2015-2022": "GB_og_bioordninger:Registreret_GB_2015-2022",
         "Registreret_GB_2015-2023_2025": "GB_og_bioordninger:Registreret_GB_2015-2023_2025",
         "Restaurering_af_aadale_2024": "Vandprojekter:Restaurering_af_aadale_2024",
         "Restaurering_af_aadale_udpegninger": "Vandprojekter:Restaurering_af_aadale_udpegninger",
         "Robuste2015_17": "Biavl:Robuste2015_17",
         "Robuste2016_18": "Biavl:Robuste2016_18",
         "Robuste2016_22": "Biavl:Robuste2016_22",
         "Robuste2017_19": "Biavl:Robuste2017_19",
         "Robuste2017_23": "Biavl:Robuste2017_23",
         "Robuste2018_20": "Biavl:Robuste2018_20",
         "Robuste2019_21": "Biavl:Robuste2019_21",
         "Robuste2020_22": "Biavl:Robuste2020_22",
         "Robuste2021_23": "Biavl:Robuste2021_23",
         "Rydning": "N2000_projekter:Rydning",
         "Rydning_og_forberedelse_til_afgraesning_2019": "N2000_projekter:Rydning_og_forberedelse_til_afgraesning_2019",
         "Rydning_og_forberedelse_til_afgraesning_2020": "N2000_projekter:Rydning_og_forberedelse_til_afgraesning_2020",
         "Rydning_og_forberedelse_til_afgraesning_2021": "N2000_projekter:Rydning_og_forberedelse_til_afgraesning_2021",
         "Rydning_og_forberedelse_til_afgraesning_2023": "N2000_projekter:Rydning_og_forberedelse_til_afgraesning_2023",
         "Rydning_og_forberedelse_til_afgraesning_2024": "N2000_projekter:Rydning_og_forberedelse_til_afgraesning_2024",
         "Saerlig_N2000_naturtyper_i_IMK_2023": "N2000_udpegninger:Saerlig_N2000_naturtyper_i_IMK_2023",
         "Saerlig_N2000_naturtyper_i_IMK_2024": "N2000_udpegninger:Saerlig_N2000_naturtyper_i_IMK_2024",
         "Saerligt_udpegede_N2000_omraader_i_IMK_2019": "N2000_udpegninger:Saerligt_udpegede_N2000_omraader_i_IMK_2019",
         "Saerligt_udpegede_N2000_omraader_i_IMK_2024": "N2000_udpegninger:Saerligt_udpegede_N2000_omraader_i_IMK_2024",
         "Satskort_2014": "Vandprojekter:Satskort_2014",
         "Skov_med_biodiversitetsformaal_ansoegt_2017": "Skovtilsagn:Skov_med_biodiversitetsformaal_ansoegt_2017",
         "Skov_med_biodiversitetsformaal_ansoegt_2020": "Skovtilsagn:Skov_med_biodiversitetsformaal_ansoegt_2020",
         "Skov_med_biodiversitetsformaal_ansoegt_2021": "Skovtilsagn:Skov_med_biodiversitetsformaal_ansoegt_2021",
         "Skov_med_biodiversitetsformaal_ansoegt_2022": "Skovtilsagn:Skov_med_biodiversitetsformaal_ansoegt_2022",
         "Skovnaturtyper_2016-2019": "N2000_udpegninger:Skovnaturtyper_2016-2019",
         "Smaabeplantning": "Ovrige_projekter:Smaabeplantning",
         "Smaabiotoper_2023": "Marker:Smaabiotoper_2023",
         "Smaabiotoper_2024": "Marker:Smaabiotoper_2024",
         "Smaabiotoper_2025": "Marker:Smaabiotoper_2025",
         "Soe_dybdekort_konturer": "NOVANA:Soe_dybdekort_konturer",
         "Soe_dybdekort_polygonafgraensning": "NOVANA:Soe_dybdekort_polygonafgraensning",
         "Soe_dybdekort_punkter": "NOVANA:Soe_dybdekort_punkter",
         "Soer_VP3": "Vandmiljoeplaner:Soer_VP3",
         "Soer_skaerpede_fosforlofter_2024": "Soer_skaerpede_fosforlofter:Soer_skaerpede_fosforlofter_2024",
         "Soer_vandomraadeplanerne_2015-2021": "Soer_skaerpede_fosforlofter:Soer_vandomraadeplanerne_2015-2021",
         "Soer_vandomraadeplanerne_2021_2027": "Soer_skaerpede_fosforlofter:Soer_vandomraadeplanerne_2021_2027",
         "Synlig_smaabiotop_2024": "GB_og_bioordninger:Synlig_smaabiotop_2024",
         "Synlig_smaabiotop_2025": "GB_og_bioordninger:Synlig_smaabiotop_2025",
         "Synlig_smaabiotop_2026": "GB_og_bioordninger:Synlig_smaabiotop_2026",
         "Tilsagn_til_oekologiske_arealtilskud_2015-2020": "Miljoe_og_oekologitilsagn:Tilsagn_til_oekologiske_arealtilskud_2015-2020",
         "Tilsagn_til_oekologiske_arealtilskud_2015-2020_2017": "Miljoe_og_oekologitilsagn:Tilsagn_til_oekologiske_arealtilskud_2015-2020_2017",
         "Tilsagn_til_oekologiske_arealtilskud_2015-2020_2018": "Miljoe_og_oekologitilsagn:Tilsagn_til_oekologiske_arealtilskud_2015-2020_2018",
         "Tilsagn_til_oekologiske_arealtilskud_2015-2020_2019": "Miljoe_og_oekologitilsagn:Tilsagn_til_oekologiske_arealtilskud_2015-2020_2019",
         "Tilsagn_til_oekologiske_arealtilskud_2015-2020_2020": "Miljoe_og_oekologitilsagn:Tilsagn_til_oekologiske_arealtilskud_2015-2020_2020",
         "Tilsagn_til_oekologiske_arealtilskud_2015-2020_2021": "Miljoe_og_oekologitilsagn:Tilsagn_til_oekologiske_arealtilskud_2015-2020_2021",
         "Tilsagn_til_oekologiske_arealtilskud_2015-2020_2022": "Miljoe_og_oekologitilsagn:Tilsagn_til_oekologiske_arealtilskud_2015-2020_2022",
         "Tilsagn_til_oekologiske_arealtilskud_2015-2020_2023": "Miljoe_og_oekologitilsagn:Tilsagn_til_oekologiske_arealtilskud_2015-2020_2023",
         "Tilsagn_til_oekologiske_arealtilskud_2015-2020_2024": "Miljoe_og_oekologitilsagn:Tilsagn_til_oekologiske_arealtilskud_2015-2020_2024",
         "Tilsagn_til_permanent_ekstensivering_2025": "Miljoe_og_oekologitilsagn:Tilsagn_til_permanent_ekstensivering_2025",
         "Tilsagn_til_pleje_af_graes_2015-2020": "Miljoe_og_oekologitilsagn:Tilsagn_til_pleje_af_graes_2015-2020",
         "Tilsagn_til_pleje_af_graes_2015-2020_2017": "Miljoe_og_oekologitilsagn:Tilsagn_til_pleje_af_graes_2015-2020_2017",
         "Tilsagn_til_pleje_af_graes_2015-2020_2018": "Miljoe_og_oekologitilsagn:Tilsagn_til_pleje_af_graes_2015-2020_2018",
         "Tilsagn_til_pleje_af_graes_2015-2020_2019": "Miljoe_og_oekologitilsagn:Tilsagn_til_pleje_af_graes_2015-2020_2019",
         "Tilsagn_til_pleje_af_graes_2015-2020_2020": "Miljoe_og_oekologitilsagn:Tilsagn_til_pleje_af_graes_2015-2020_2020",
         "Tilsagn_til_pleje_af_graes_2015-2020_2021": "Miljoe_og_oekologitilsagn:Tilsagn_til_pleje_af_graes_2015-2020_2021",
         "Tilsagn_til_pleje_af_graes_2015-2020_2022": "Miljoe_og_oekologitilsagn:Tilsagn_til_pleje_af_graes_2015-2020_2022",
         "Tilsagn_til_pleje_af_graes_2015-2020_2023": "Miljoe_og_oekologitilsagn:Tilsagn_til_pleje_af_graes_2015-2020_2023",
         "Tilsagn_til_pleje_af_graes_2015-2020_2024": "Miljoe_og_oekologitilsagn:Tilsagn_til_pleje_af_graes_2015-2020_2024",
         "Tilsagn_til_pleje_af_graes_2023-2027": "Miljoe_og_oekologitilsagn:Tilsagn_til_pleje_af_graes_2023-2027",
         "Tilsagn_til_pleje_af_graes_2023-2027_2024": "Miljoe_og_oekologitilsagn:Tilsagn_til_pleje_af_graes_2023-2027_2024",
         "Toerverig_lavbund_2024": "Jordbunds_og_terraenforhold:Toerverig_lavbund_2024",
         "Trampestier": "Ovrige_projekter:Trampestier",
         "Udledningsgraenser_til_Udledningsbaseret_Markregulering_2027": "Udledningsbaseret_mark_regulering:Udledningsgraenser_til_Udledningsbaseret_Markregulering_2027",
         "Udpegningskort_2018": "Vandprojekter:Udpegningskort_2018",
         "Udpegningskort_2019": "Vandprojekter:Udpegningskort_2019",
         "VMPII": "Vandprojekter:VMPII",
         "VMPIII": "Vandprojekter:VMPIII",
         "Vand_Natur_og_Skovprojekter_2024": "GB_og_bioordninger:Vand_Natur_og_Skovprojekter_2024",
         "Vand_Natur_og_Skovprojekter_2025": "GB_og_bioordninger:Vand_Natur_og_Skovprojekter_2025",
         "Vandboringer_i_IMK_2024": "Drikkevand:Vandboringer_i_IMK_2024",
         "Vandloebsrestaurering_E": "Ovrige_projekter:Vandloebsrestaurering_E",
         "Vandloebsrestaurering_F": "Ovrige_projekter:Vandloebsrestaurering_F",
         "Vurderet_afvist_GB_til_projektareal": "GB_og_bioordninger:Vurderet_afvist_GB_til_projektareal",
         "oeko_biavl_2017": "Biavl:oeko_biavl_2017",
         "oeko_biavl_2018": "Biavl:oeko_biavl_2018",
         "oeko_biavl_2019": "Biavl:oeko_biavl_2019",
         "oeko_biavl_2020": "Biavl:oeko_biavl_2020",
         "oeko_biavl_2021": "Biavl:oeko_biavl_2021",
         "oeko_biavl_2022": "Biavl:oeko_biavl_2022",
         "oeko_biavl_2023": "Biavl:oeko_biavl_2023",
         "oeko_biavl_2024": "Biavl:oeko_biavl_2024",
         "toerveholdig2019_over6": "Jordbunds_og_terraenforhold:toerveholdig2019_over6"
      }
   },
   "Landsplandirektiver (PD)": {
      endpoint: "https://gisp.bpst.dk/lpd/wfs",
      featureTypes: {
         "Egedal areal til højspændingsstation (LPD)": "lpd:theme-lpd_ege_grib_egedal_omr",
         "Egedal delområder (LPD)": "lpd:theme-lpd_ege_grib_egedal_delomr",
         "Energipark, forslag": "lpd:energiparker_forslag",
         "Energiparker, udpeget": "lpd:energiparker_udpeget",
         "Gribskov areal til højspændingsstation (LPD)": "lpd:theme-lpd_ege_grib_gribskov_omr",
         "Gribskov delområder (LPD)": "lpd:theme-lpd_ege_grib_gribskov_delomr",
         "Højspændingsstation i Høje-Taastrup Kommune og kabelovergangsmaster i Ishøj Kommune": "lpd:theme-lpd_hoeje_taastrup_ishoej",
         "lpd_bp_Stationer": "lpd:lpd_bp_Stationer",
         "lpd_bp_arealreservation": "lpd:lpd_bp_arealreservation",
         "lpd_bp_arealreservation_400m": "lpd:lpd_bp_arealreservation_400m",
         "lpd_bp_byggezoner_stationer": "lpd:lpd_bp_byggezoner_stationer",
         "lpd_bp_kompressorstation_everdrup": "lpd:lpd_bp_kompressorstation_everdrup",
         "lpd_bp_modtageterminal_nybro": "lpd:lpd_bp_modtageterminal_nybro",
         "lpd_bp_oplag_og_arbplads": "lpd:lpd_bp_oplag_og_arbplads",
         "lpd_gaslf_arealreservation": "lpd:lpd_gaslf_arealreservation",
         "lpd_gaslf_midlertidige_arbejdspladser": "lpd:lpd_gaslf_midlertidige_arbejdspladser",
         "lpd_gaslf_stationer": "lpd:lpd_gaslf_stationer",
         "lpd_gaslf_stationsareal": "lpd:lpd_gaslf_stationsareal",
         "lpd_hoevsoere_maaleomraade_region": "lpd:lpd_hoevsoere_maaleomraade_region",
         "lpd_oesterild_maaleomraade_region": "lpd:lpd_oesterild_maaleomraade_region",
         "lpd_omplacering_sommerhusomr_vedt_2019_skal_tilbagefoeres": "lpd:lpd_omplacering_sommerhusomr_vedt_2019_skal_tilbagefoeres",
         "lpd_omplacering_sommerhusomr_vedt_2019_tilbagefoerelse": "lpd:lpd_omplacering_sommerhusomr_vedt_2019_tilbagefoerelse",
         "lpd_omplacering_sommerhusomr_vedt_2019_udlaeg": "lpd:lpd_omplacering_sommerhusomr_vedt_2019_udlaeg",
         "lpd_omplacering_sommerhusomr_vedt_2019_udlaeg_betinget": "lpd:lpd_omplacering_sommerhusomr_vedt_2019_udlaeg_betinget",
         "lpd_sommerhus_tilbagefoerelse_20190315": "lpd:lpd_sommerhus_tilbagefoerelse_20190315",
         "lpd_udviklingsomr_vedt_2019": "lpd:lpd_udviklingsomr_vedt_2019",
         "lpd_udviklingsomr_vedt_2019_paragraf3": "lpd:lpd_udviklingsomr_vedt_2019_paragraf3",
         "lpd_udviklingsomr_vedt_2019_paragraf5": "lpd:lpd_udviklingsomr_vedt_2019_paragraf5",
         "lpd_udviklingsomr_vedt_2019_traadt_i_kraft": "lpd:lpd_udviklingsomr_vedt_2019_traadt_i_kraft",
         "lpd_udviklingsomr_vedt_2021": "lpd:lpd_udviklingsomr_vedt_2021",
         "lpd_udviklingsomr_vedt_2021_paragraf3": "lpd:lpd_udviklingsomr_vedt_2021_paragraf3",
         "lpd_udviklingsomr_vedt_2021_paragraf5": "lpd:lpd_udviklingsomr_vedt_2021_paragraf5",
         "lpd_udviklingsomr_vedt_2021_traadt_i_kraft": "lpd:lpd_udviklingsomr_vedt_2021_traadt_i_kraft",
         "sommerhusomr_2019_tilbagefoert": "lpd:sommerhusomr_2019_tilbagefoert",
         "sommerhusomr_2019_udlagt": "lpd:sommerhusomr_2019_udlagt",
         "sommerhusomr_2021_ikke_udlagt": "lpd:sommerhusomr_2021_ikke_udlagt",
         "sommerhusomr_2021_tilbagefoert": "lpd:sommerhusomr_2021_tilbagefoert",
         "sommerhusomr_2021_udlagt": "lpd:sommerhusomr_2021_udlagt",
         "sommerhusomr_2025_tilbagefoert": "lpd:sommerhusomr_2025_tilbagefoert",
         "sommerhusomr_2025_udlagt": "lpd:sommerhusomr_2025_udlagt",
         "theme-lpd-aflastning-34-kom": "lpd:theme-lpd-aflastning-34-kom",
         "theme-lpd-aflastning-7-kom": "lpd:theme-lpd-aflastning-7-kom",
         "theme-lpd-aflastningsomraader-hovedstadsomraadet": "lpd:theme-lpd-aflastningsomraader-hovedstadsomraadet",
         "theme-lpd-asylcentre": "lpd:theme-lpd-asylcentre",
         "theme-lpd-auderoed": "lpd:theme-lpd-auderoed",
         "theme-lpd-bestseller-brande": "lpd:theme-lpd-bestseller-brande",
         "theme-lpd-hedensted-vaaben": "lpd:theme-lpd-hedensted-vaaben",
         "theme-lpd-hei_100m_baelte": "lpd:theme-lpd-hei_100m_baelte",
         "theme-lpd-hei_arbejdspladser": "lpd:theme-lpd-hei_arbejdspladser",
         "theme-lpd-hei_arealreservation": "lpd:theme-lpd-hei_arealreservation",
         "theme-lpd-hei_kabelcenter": "lpd:theme-lpd-hei_kabelcenter",
         "theme-lpd-hei_kabelovergang": "lpd:theme-lpd-hei_kabelovergang",
         "theme-lpd-hei_stationsudv_pkt": "lpd:theme-lpd-hei_stationsudv_pkt",
         "theme-lpd-hei_stationsudv_polygon": "lpd:theme-lpd-hei_stationsudv_polygon",
         "theme-lpd-helelandet": "lpd:theme-lpd-helelandet",
         "theme-lpd-klinkby": "lpd:theme-lpd-klinkby",
         "theme-lpd-krydstogt-nordhavn": "lpd:theme-lpd-krydstogt-nordhavn",
         "theme-lpd-nationalregionale_retn": "lpd:theme-lpd-nationalregionale_retn",
         "theme-lpd-naturomr": "lpd:theme-lpd-naturomr",
         "theme-lpd-omplacering_sommerhusomr_vedt_2019_tilbagefoerelse_opdateret": "lpd:theme-lpd-omplacering_sommerhusomr_vedt_2019_tilbagefoerelse_opdateret",
         "theme-lpd-omplacering_sommerhusomr_vedt_2019_udlaeg_opdateret": "lpd:theme-lpd-omplacering_sommerhusomr_vedt_2019_udlaeg_opdateret",
         "theme-lpd-omplacering_sommerhusomr_vedt_2021_tilbagefoert": "lpd:theme-lpd-omplacering_sommerhusomr_vedt_2021_tilbagefoert",
         "theme-lpd-sjaelsmarkskaserne": "lpd:theme-lpd-sjaelsmarkskaserne",
         "theme-lpd-sommerhusomr": "lpd:theme-lpd-sommerhusomr",
         "theme-lpd-sommerhusomraade-til-byzone": "lpd:theme-lpd-sommerhusomraade-til-byzone",
         "theme-lpd-sondervig": "lpd:theme-lpd-sondervig",
         "theme-lpd-svanemoellekaserne": "lpd:theme-lpd-svanemoellekaserne",
         "theme-lpd-taarnby-dragor": "lpd:theme-lpd-taarnby-dragor",
         "theme-lpd-tekniskeanl": "lpd:theme-lpd-tekniskeanl",
         "theme-lpd-transmissionsnet-arealresv": "lpd:theme-lpd-transmissionsnet-arealresv",
         "theme-lpd-transmissionsnet-linief": "lpd:theme-lpd-transmissionsnet-linief",
         "theme-lpd-turistbillund": "lpd:theme-lpd-turistbillund",
         "theme-lpd-udviklingsomr_2019": "lpd:theme-lpd-udviklingsomr_2019",
         "theme-lpd-udviklingsomr_2021": "lpd:theme-lpd-udviklingsomr_2021",
         "theme-lpd-udviklingsomr_2025": "lpd:theme-lpd-udviklingsomr_2025",
         "theme-lpd-udviklingsomraader-2019f": "lpd:theme-lpd-udviklingsomraader-2019f",
         "theme-lpd-vaerloese-flyvestation": "lpd:theme-lpd-vaerloese-flyvestation",
         "theme-lpd-vindm": "lpd:theme-lpd-vindm",
         "theme-lpd-virk_alleroed": "lpd:theme-lpd-virk_alleroed",
         "theme-lpd_heg_100m_rammeomr": "lpd:theme-lpd_heg_100m_rammeomr",
         "theme-lpd_heg_400m_planzone": "lpd:theme-lpd_heg_400m_planzone",
         "theme-lpd_heg_centerlinje_kabler": "lpd:theme-lpd_heg_centerlinje_kabler",
         "theme-lpd_heg_kabelovergang": "lpd:theme-lpd_heg_kabelovergang",
         "theme-lpd_heg_kabelovergangsstation": "lpd:theme-lpd_heg_kabelovergangsstation",
         "theme-lpd_heg_midlertidige_arbplads": "lpd:theme-lpd_heg_midlertidige_arbplads",
         "theme-overfoersel_af_somomr_til_byzone_2018": "lpd:theme-overfoersel_af_somomr_til_byzone_2018",
         "theme-overfoersel_af_somomr_til_byzone_2021": "lpd:theme-overfoersel_af_somomr_til_byzone_2021"
      }
   },
   "Nationale Interesser (PD)": {
      endpoint: "https://gisp.bpst.dk/ni/wfs",
      featureTypes: {
         "Meddelt tilladelse til efterforskning- og lagring af CO2 - C2024/01 (ved Randers)": "ni:ni_ens_co2_storage_2024_01",
         "Meddelt tilladelse til efterforskning- og lagring af CO2 - C2024/02 (på Lolland)": "ni:ni_ens_co2_storage_2024_02",
         "Meddelt tilladelse til efterforskning- og lagring af CO2 - C2024/03 (ved Kalundborg)": "ni:ni_ens_co2_storage_2024_03",
         "Meddelt tilladelse til efterforskning- og lagring af CO2 - C2024/04 (Syd for Viborg)": "ni:ni_ens_co2_storage_2025_01",
         "Opmærksomhedszone omkring produktions-, transport- og logistikvirksomheder af national interesse": "ni:theme-prodvirk_1500m_obs_zone",
         "Produktions-, transport- og logistikvirksomheder af national interesse": "ni:theme-ni_prodvirk",
         "ni25_fp19_overordnede_trafikanlaeg_samlet": "ni:ni25_fp19_overordnede_trafikanlaeg_samlet"
      }
   },
   "Luftfart (PD)": {
      endpoint: "https://gisp.bpst.dk/ts/wfs",
      featureTypes: {
         "tbb_fuglekollision": "ts:tbb_fuglekollision",
         "tbb_hems": "ts:tbb_hems",
         "tbb_hems_sikkerhedszoner": "ts:tbb_hems_sikkerhedszoner",
         "tbb_hoeringszoner": "ts:tbb_hoeringszoner",
         "tbb_indflyvningszoner_region": "ts:tbb_indflyvningszoner_region",
         "tbb_lazerfrie_zoner": "ts:tbb_lazerfrie_zoner",
         "tbb_master2_region": "ts:tbb_master2_region",
         "tbb_respektafstande_region": "ts:tbb_respektafstande_region",
         "tbb_slv_master_point": "ts:tbb_slv_master_point"
      }
   },
   "Vedvarende Energi (PD)": {
      endpoint: "https://gisp.bpst.dk/ve/wfs",
      featureTypes: {
         "Landvindmøller på kommuneniveau": "ve:ve_landvindmoeller_paa_kommuneniveau",
         "Solcelleanlæg på kommuneniveau": "ve:ve_solcelleanlaeg_paa_kommuneniveau",
         "Solcelleanlæg på kommuneniveau 2018": "ve:ve_solcelleanlaeg_paa_kommuneniveau_201801",
         "Solcelleanlæg på kommuneniveau 2019": "ve:ve_solcelleanlaeg_paa_kommuneniveau_201901",
         "Solcelleanlæg på kommuneniveau 2020": "ve:ve_solcelleanlaeg_paa_kommuneniveau_202001",
         "Solcelleanlæg på kommuneniveau 2021": "ve:ve_solcelleanlaeg_paa_kommuneniveau_202101",
         "Solcelleanlæg på kommuneniveau 2022": "ve:ve_solcelleanlaeg_paa_kommuneniveau_202201",
         "Solcelleanlæg på kommuneniveau 2023": "ve:ve_solcelleanlaeg_paa_kommuneniveau_202301",
         "Solcelleanlæg på kommuneniveau 2024": "ve:ve_solcelleanlaeg_paa_kommuneniveau_202401",
         "Store solcelleanlæg": "ve:store_solcelleanlaeg",
         "Tage gennemsnitlig årlig indstråling": "ve:tage_udst",
         "Tagflader potentiale for solceller": "ve:tagflade_udst",
         "Vindmølle afstandskort 100m": "ve:vindmoelle_afstand_100m",
         "Vindmølle afstandskort 125m": "ve:vindmoelle_afstand_125m",
         "Vindmølle afstandskort 150m": "ve:vindmoelle_afstand_150m",
         "Vindmølle afstandskort 175m": "ve:vindmoelle_afstand_175m",
         "Vindmølle afstandskort 200m": "ve:vindmoelle_afstand_200m",
         "Vindmølle afstandskort 225m": "ve:vindmoelle_afstand_225m",
         "Vindmølle afstandskort 250m": "ve:vindmoelle_afstand_250m",
         "Vindmøller": "ve:vindmoeller"
      }
   },
   "EnergiNet": {
      endpoint: "https://agis.energinet.dk/server/services/INSPIRE/XP_el_Inspir/MapServer/WFSServer",
      fetchMethods: "Post_Xml",
      active: false,
      featureTypes: {
         "LuftLedningsTrace": "XP_el_Inspir:LuftLedningsTrace",
         "KabelTrace": "XP_el_Inspir:KabelTrace",
         "Opmærksomhedszoner_hos_Energinet_Eltransmission_WFL1_-_Opmærksomhedszone_Luftledning": "XP_el_Inspir:Opmærksomhedszoner_hos_Energinet_Eltransmission_WFL1_-_Opmærksomhedszone_Luftledning",
         "Opmærksomhedszoner_hos_Energinet_Eltransmission_WFL1_-_Opmærksomhedszone_Kabel": "XP_el_Inspir:Opmærksomhedszoner_hos_Energinet_Eltransmission_WFL1_-_Opmærksomhedszone_Kabel",
         "Opmærksomhedszoner_hos_Energinet_Eltransmission_WFL1_-_Opmærksomhedszone_Station": "XP_el_Inspir:Opmærksomhedszoner_hos_Energinet_Eltransmission_WFL1_-_Opmærksomhedszone_Station",
         "Stationsarealer_hos_Energinet_Eltransmission": "XP_el_Inspir:Stationsarealer_hos_Energinet_Eltransmission"
      }
   },
   "Kulturarvstyrelsen": {
      endpoint: "https://www.kulturarv.dk/geoserver/ows",
      featureTypes: {
         "bygningslag": "fbb:bygningslag",
         "kommuneatlas": "fbb:kommuneatlas",
         "view_bebyggetstruktur_bebyggelsesmoenster": "fbb:view_bebyggetstruktur_bebyggelsesmoenster",
         "view_bebyggetstruktur_dominerendebygning": "fbb:view_bebyggetstruktur_dominerendebygning",
         "view_bebyggetstruktur_enkeltstaaendetrae": "fbb:view_bebyggetstruktur_enkeltstaaendetrae",
         "view_bebyggetstruktur_indkig": "fbb:view_bebyggetstruktur_indkig",
         "view_bebyggetstruktur_omfang": "fbb:view_bebyggetstruktur_omfang",
         "view_bebyggetstruktur_rumdannendebygning": "fbb:view_bebyggetstruktur_rumdannendebygning",
         "view_bebyggetstruktur_torv": "fbb:view_bebyggetstruktur_torv",
         "view_bebyggetstruktur_traeraekke": "fbb:view_bebyggetstruktur_traeraekke",
         "view_bebyggetstruktur_udsigt": "fbb:view_bebyggetstruktur_udsigt",
         "view_bebyggetstruktur_vej": "fbb:view_bebyggetstruktur_vej",
         "view_bygning_alle": "fbb:view_bygning_alle",
         "view_bygning_bevaringssag": "fbb:view_bygning_bevaringssag",
         "view_bygning_fredede": "fbb:view_bygning_fredede",
         "view_bygning_fredningstatus_hoej": "fbb:view_bygning_fredningstatus_hoej",
         "view_bygning_fredningstatus_lav": "fbb:view_bygning_fredningstatus_lav",
         "view_bygning_fredningstatus_med": "fbb:view_bygning_fredningstatus_med",
         "view_bygningslag": "fbb:view_bygningslag",
         "view_polygon_alle": "fbb:view_polygon_alle",
         "view_polygon_bevaringssag": "fbb:view_polygon_bevaringssag",
         "view_polygon_fredede": "fbb:view_polygon_fredede",
         "view_polygon_fredningstatus_hoej": "fbb:view_polygon_fredningstatus_hoej",
         "view_polygon_fredningstatus_lav": "fbb:view_polygon_fredningstatus_lav",
         "view_polygon_fredningstatus_med": "fbb:view_polygon_fredningstatus_med",
         "view_polygon_oevrige": "fbb:view_polygon_oevrige",
         "view_sagsomgivelse_flader": "fbb:view_sagsomgivelse_flader",
         "view_sagsomgivelse_linjer": "fbb:view_sagsomgivelse_linjer",
         "view_sagsomgivelse_punkter": "fbb:view_sagsomgivelse_punkter"
      },
   },
   "Fund og Fortid (SLKS)": {
      endpoint: "https://www.kulturarv.dk/ffgeoserver/public/wfs",
      featureTypes: {
         "fundogfortidsminder_areal_adm": "public:fundogfortidsminder_areal_adm",
         "fundogfortidsminder_areal_alle": "public:fundogfortidsminder_areal_alle",
         "fundogfortidsminder_areal_beskyttelse": "public:fundogfortidsminder_areal_beskyttelse",
         "fundogfortidsminder_areal_fredet": "public:fundogfortidsminder_areal_fredet",
         "fundogfortidsminder_areal_ka": "public:fundogfortidsminder_areal_ka",
         "fundogfortidsminder_areal_marin": "public:fundogfortidsminder_areal_marin",
         "fundogfortidsminder_linie_alle": "public:fundogfortidsminder_linie_alle",
         "fundogfortidsminder_linie_marin": "public:fundogfortidsminder_linie_marin",
         "fundogfortidsminder_linje_fredet": "public:fundogfortidsminder_linje_fredet",
         "fundogfortidsminder_punkt_fredet": "public:fundogfortidsminder_punkt_fredet",
         "fundogfortidsminder_punkt_ikkefredet": "public:fundogfortidsminder_punkt_ikkefredet",
         "fundogfortidsminder_punkt_marin": "public:fundogfortidsminder_punkt_marin"
      }
   },
   "Miljø Portal (Ekstern)": {
      endpoint: "https://arld-extgeo.miljoeportal.dk/geoserver/wfs",
      featureTypes: {
         "DMP brugerseminarer 2024": "dmp:brugerseminarer_2024",
         "Deposition af NHx (den del af kvælstofafsætningen som stammer fra udledning af ammoniak) (2023)": "luft:ID15_Luft_Deposition_2023_NHx",
         "Deposition af NOy (den del af kvælstofafsætningen som stammer fra udledning af NOx) (2023)": "luft:ID16_Luft_Deposition_2023_NOy",
         "Deposition af svovl (2023)": "luft:ID12_Luft_Deposition_2023_svovl",
         "Forslag til 30% beskyttede områder": "dn:arealreservation_20220928",
         "HNV2020_20200302": "hnv:HNV2020_20200302",
         "HNV2021_20210226": "hnv:HNV2021_20210226",
         "Jordbundstyper": "landbrugsdrift:DJF_FGJOR",
         "Koncentration af ammoniak (2023)": "luft:ID10_Luft_Koncentration_2023_NH3",
         "Koncentration af fine partikler, PM2.5 (2023)": "luft:ID7_Luft_Koncentration_2023_PM2_5",
         "Koncentration af jordnær ozon (2023)": "luft:ID9_Luft_Koncentration_2023_O3",
         "Koncentration af kvælstofdioxid (2023)": "luft:ID6_Luft_Koncentration_2023_NO2",
         "Koncentration af partikler, PM10 (2023)": "luft:ID8_Luft_Koncentration_2023_PM10",
         "Koncentration af svovldioxid (2023)": "luft:ID11_Luft_Koncentration_2023_SO2",
         "Kvælstofreduktionspotentialer": "husdyr:KVAELSTOF_RED_POT",
         "Lavbund og okker": "landbrugsdrift:DJF_LAVBUND",
         "N2000-arealer til hydrologi": "landbrugsdrift:N2000_HYDROLOGI",
         "N2000-arealer til rydning": "landbrugsdrift:RYDNING",
         "Paaskeaeg": "paaskeaeg:Paaskeaeg",
         "Prioritering af områder": "ku:ku_239omr_cmec2024_2_2",
         "Samlet deposition af kvælstof (2023)": "luft:ID14_Luft_Deposition_2023_TotN",
         "Samlet deposition af kvælstof til miljøgodkendelser (2018-2020)": "luft:ID17_Luft_Deposition_2018-2020_TotN",
         "Samlet deposition af kvælstof til miljøgodkendelser (2019-2021)": "luft:ID18_Luft_Deposition_2019-2021_TotN",
         "Samlet deposition af kvælstof til miljøgodkendelser (2020-2022)": "luft:ID19_Luft_Deposition_2020-2022_TotN",
         "Samlet deposition af kvælstof til miljøgodkendelser (2021-2023)": "luft:ID20_Luft_Deposition_2021-2023_TotN",
         "Samlet deposition af total kvælstof til naturovervågning (naturtilstand) (2020)": "luft:ID13_Luft_Deposition_2020_TotN_natur",
         "Store naturområder i Danmark": "ku:ku_239omr_cmec2024_2_1",
         "Særligt udpegede N2000-arealer": "landbrugsdrift:SAER_UDPEG_N2000",
         "Terrænhældning over 6 grader": "landbrugsdrift:HAELDNING_GT_6GR",
         "Årlig emission af ammoniak (2022)": "luft:ID5_Luft_Emission_2022_NH3",
         "Årlig emission af fine partikler, PM2.5 (2022)": "luft:ID2_Luft_Emission_2022_PM2_5",
         "Årlig emission af kvælstofoxider (2022)": "luft:ID1_Luft_Emission_2022_NOx",
         "Årlig emission af partikler, PM10 (2022)": "luft:ID3_Luft_Emission_2022_PM10",
         "Årlig emission af svovldioxid (2022)": "luft:ID4_Luft_Emission_2022_SO2"
      }
   },
   "Miljø Portal (Natur)": {
      endpoint: "https://naturarealdatageo.miljoeportal.dk/geoserver/wfs",
      featureTypes: {
         "Besigtigelser flader": "nature_ws:NAT_BESIGTIGELSER_FL",
         "Besigtigelser linjer": "nature_ws:NAT_BESIGTIGELSER_LN",
         "Besigtigelser punkter": "nature_ws:NAT_BESIGTIGELSER_PKT",
         "Generelle artsfund flader": "nature_ws:GEN_ARTSFUND_FL",
         "Generelle artsfund linjer": "nature_ws:GEN_ARTSFUND_LN",
         "Generelle artsfund punkter": "nature_ws:GEN_ARTSFUND_PKT",
         "Habitatdirektivets bilagsarter": "nature_ws:ART_BILAGSARTER",
         "Invasive arter og EU-listen": "nature_ws:ART_INVASIVEARTER",
         "Kortlægning levesteder flader": "nature_ws:KORTLAEG_LEVESTEDER_FL",
         "Kortlægning levesteder punkter": "nature_ws:KORTLAEG_LEVESTEDER_PKT",
         "Kortlægning naturtyper flader": "nature_ws:KORTLAEG_NATURTYPER_FL",
         "Kortlægning naturtyper punkter": "nature_ws:KORTLAEG_NATURTYPER_PKT",
         "Naturmæssigt særlig værdifuld skov (2016-2017, offentlige arealer)": "nature_ws:NATURMAESSIGT_SAERLIG_VAERDIFULD_SKOV_2016_2017_OFFENTLIGE_AREALER",
         "Naturmæssigt særlig værdifuld skov (2022-2024, private arealer)": "nature_ws:NATURMAESSIGT_SAERLIG_VAERDIFULD_SKOV_2022_2024_PRIVATE_AREALER",
         "Overvågning af bilagsarter flader": "nature_ws:OVERVAAGN_BILAGSARTER_FL",
         "Overvågning af bilagsarter punkter": "nature_ws:OVERVAAGN_BILAGSARTER_PKT",
         "Overvågning af fugle flader": "nature_ws:OVERVAAGN_FUGLE_FL",
         "Overvågning af fugle linjer": "nature_ws:OVERVAAGN_FUGLE_LN",
         "Overvågning af fugle punkter": "nature_ws:OVERVAAGN_FUGLE_PKT",
         "Overvågning af naturtyper flader": "nature_ws:OVERVAAGN_NATURTYPER_FL",
         "Overvågning af naturtyper punkter": "nature_ws:OVERVAAGN_NATURTYPER_PKT",
         "Rødlistede arter": "nature_ws:ART_ROEDLISTEARTER"
      }
   },
   "Miljø Portal": {
      endpoint: "https://arealeditering-dist-geo.miljoeportal.dk/geoserver/wfs",
      featureTypes: {
         "2002 Beskyttede sten- og jorddiger": "dai:bes_sten_jorddiger_2022",
         "2003 Søbeskyttelseslinjer": "dai:soe_bes_linjer",
         "2004 Åbeskyttelseslinjer": "dai:aa_bes_linjer",
         "2005 Skovbyggelinjer": "dai:skovbyggelinjer",
         "2008 Kirkebyggelinjer": "dai:kirkebyggelinjer",
         "2009 Fredede områder": "dai:fredede_omr",
         "2010 Fredede områder, forslag": "dai:fredede_omr_forslag",
         "2013 Beskyttede naturtyper": "dai:bes_naturtyper",
         "2014 Beskyttede vandløb": "dai:bes_vandloeb",
         "2018 NATURA 2000 - Fuglebeskyttelse": "dai:fugle_bes_omr",
         "2019 NATURA 2000 - Habitatområder": "dai:habitat_omr",
         "2020 Ramsar områder": "dai:ramsar_omr",
         "2037 Natur- og vildtreservater": "dai:natur_vildt_reservat",
         "2054 Områdeklassificering": "dai:omr_klassificering",
         "2055 Råstofområder": "dai:raastofomr",
         "2097 Igangværende påbud JFL": "dai:paabud_jfl",
         "2112 Kommunale indsatsplaner for grundvandsbeskyttelse": "dai:indsatsplaner",
         "2140 Bekendtgørelsesfredninger": "dai:fredede_omr_bk",
         "2141 Aftaleområder for grundvand": "dai:aftarea_grvbes",
         "2142 Kommunernes status for boringsnære beskyttelsesområder (BNBO)": "dai:status_bnbo",
         "2162 Status på bræmmer - søer": "dai:br_soer_2024",
         "2163 Status på bræmmer - vandløb": "dai:br_vandloeb_2024",
         "2170 Arealer ejet af folkekirken": "dai:fk_areal",
         "2171 Marker ejet af folkekirken": "dai:fk_mark",
         "2213 Naturstyrelsens indstilling til beskyttede naturtyper": "dai:bes_naturtyper_nst"
      },
   },
   "Stednavne": {
      endpoint: "https://wfs.datafordeler.dk/STEDNAVN/STEDNAVNE_BEARBEJDET_GML3SFP/1/WFS",
      urlParams: "Datafordeler",
      featureTypes: {
         "AndenTopografiFlade": "sn:AndenTopografiFlade",
         "AndenTopografiPunkt": "sn:AndenTopografiPunkt",
         "Bebyggelse": "sn:Bebyggelse",
         "Begravelsesplads": "sn:Begravelsesplads",
         "Bygning": "sn:Bygning",
         "Campingplads": "sn:Campingplads",
         "FaergeruteLinje": "sn:FaergeruteLinje",
         "FaergerutePunkt": "sn:FaergerutePunkt",
         "Farvand": "sn:Farvand",
         "Fortidsminde": "sn:Fortidsminde",
         "Friluftsbad": "sn:Friluftsbad",
         "Havnebassin": "sn:Havnebassin",
         "Idraetsanlaeg": "sn:Idraetsanlaeg",
         "Jernbane": "sn:Jernbane",
         "Landskabsform": "sn:Landskabsform",
         "Lufthavn": "sn:Lufthavn",
         "Naturareal": "sn:Naturareal",
         "Navigationsanlaeg": "sn:Navigationsanlaeg",
         "Restriktionsareal": "sn:Restriktionsareal",
         "Rute": "sn:Rute",
         "Sevaerdighed": "sn:Sevaerdighed",
         "Soe": "sn:Soe",
         "Standsningssted": "sn:Standsningssted",
         "Terraenkontur": "sn:Terraenkontur",
         "UrentFarvand": "sn:UrentFarvand",
         "Vandloeb": "sn:Vandloeb",
         "Vej": "sn:Vej"
      }
   },
   "GeoDanmark": {
      endpoint: "https://wfs.datafordeler.dk/GeoDanmarkVektor/GeoDanmark60_NOHIST_GML3/1.0.0/WFS",
      urlParams: "Datafordeler",
      featureTypes: {
         "Afvandingsgroeft": "gdk60:Afvandingsgroeft",
         "AnlaegDiverse": "gdk60:AnlaegDiverse",
         "BadeBaadebro": "gdk60:BadeBaadebro",
         "Bassin": "gdk60:Bassin",
         "Begravelsesomraade": "gdk60:Begravelsesomraade",
         "Broenddaeksel": "gdk60:Broenddaeksel",
         "Brugsgraense": "gdk60:Brugsgraense",
         "Bygning": "gdk60:Bygning",
         "Bygvaerk": "gdk60:Bygvaerk",
         "Bykerne": "gdk60:Bykerne",
         "Chikane": "gdk60:Chikane",
         "DHMHestesko": "gdk60:DHMHestesko",
         "DHMLinje": "gdk60:DHMLinje",
         "Daemning": "gdk60:Daemning",
         "Dige": "gdk60:Dige",
         "Erhverv": "gdk60:Erhverv",
         "Fotoindex": "gdk60:Fotoindex",
         "Gartneri": "gdk60:Gartneri",
         "Havn": "gdk60:Havn",
         "Hede": "gdk60:Hede",
         "Hegn": "gdk60:Hegn",
         "Helle": "gdk60:Helle",
         "HistoriskFlade": "gdk60:HistoriskFlade",
         "HistoriskLinje": "gdk60:HistoriskLinje",
         "HistoriskPunkt": "gdk60:HistoriskPunkt",
         "Hoefde": "gdk60:Hoefde",
         "HoejBebyggelse": "gdk60:HoejBebyggelse",
         "Hoejspaendingsledning": "gdk60:Hoejspaendingsledning",
         "Jernbane": "gdk60:Jernbane",
         "Kommuneomraade": "gdk60:Kommuneomraade",
         "KratBevoksning": "gdk60:KratBevoksning",
         "Kyst": "gdk60:Kyst",
         "LavBebyggelse": "gdk60:LavBebyggelse",
         "Mast": "gdk60:Mast",
         "Nedloebsrist": "gdk60:Nedloebsrist",
         "Omraadepolygon": "gdk60:Omraadepolygon",
         "Parkering": "gdk60:Parkering",
         "Parkeringsomraade": "gdk60:Parkeringsomraade",
         "Plads": "gdk60:Plads",
         "Raastofomraade": "gdk60:Raastofomraade",
         "RekreativtOmraade": "gdk60:RekreativtOmraade",
         "SandKlit": "gdk60:SandKlit",
         "Skorsten": "gdk60:Skorsten",
         "Skov": "gdk60:Skov",
         "Skraent": "gdk60:Skraent",
         "Soe": "gdk60:Soe",
         "Sportsbane": "gdk60:Sportsbane",
         "Startbane": "gdk60:Startbane",
         "StatueSten": "gdk60:StatueSten",
         "Systemlinje": "gdk60:Systemlinje",
         "TekniskAnlaegFlade": "gdk60:TekniskAnlaegFlade",
         "TekniskAnlaegPunkt": "gdk60:TekniskAnlaegPunkt",
         "TekniskAreal": "gdk60:TekniskAreal",
         "Telemast": "gdk60:Telemast",
         "Togstation": "gdk60:Togstation",
         "Trae": "gdk60:Trae",
         "Traegruppe": "gdk60:Traegruppe",
         "Trafikhegn": "gdk60:Trafikhegn",
         "UdpegningFlade": "gdk60:UdpegningFlade",
         "UdpegningLinje": "gdk60:UdpegningLinje",
         "UdpegningPunkt": "gdk60:UdpegningPunkt",
         "Vaadomraade": "gdk60:Vaadomraade",
         "Vandafstroemningsopland": "gdk60:Vandafstroemningsopland",
         "Vandhaendelse": "gdk60:Vandhaendelse",
         "Vandknude": "gdk60:Vandknude",
         "Vandloebskant": "gdk60:Vandloebskant",
         "Vandloebsmidte": "gdk60:Vandloebsmidte",
         "Vejkant": "gdk60:Vejkant",
         "Vejmidte": "gdk60:Vejmidte",
         "Vindmoelle": "gdk60:Vindmoelle"
      },
   },
   "DKJord": {
      endpoint: "https://jord.miljoeportal.dk/geo/wfs",
      featureTypes: {
         "Jordforurening, V1 kortlagt": "DKJord:View_V1Flader",
         "Jordforurening, V2 kortlagt": "DKJord:View_V2Flader",
         "Jordforurening, lokaliseret (uafklaret)": "DKJord:View_LokaliseretFlader",
         "Jordforurening, nuanceret": "DKJord:View_NuanceringsFlader",
         "Jordforurening, udgået efter kortlægning": "DKJord:View_UEKFlader",
         "Jordforurening, udgået før kortlægning": "DKJord:View_UIKFlader",
         "View_Lokaliteter": "DKJord:View_Lokaliteter"
      },
   },
   "Plandata.dk": {
      endpoint: "https://geoserver.plandata.dk/geoserver/wfs",
      featureTypes: {
         "regionplaner": "region:regionplaner",
         "theme-knz-kystnaerhedszone-linje": "knz:theme-knz-kystnaerhedszone-linje",
         "theme-knz-kystnaerhedszone-polygon": "knz:theme-knz-kystnaerhedszone-polygon",
         "theme_pdk_anvendelsevandsoekyst_aflyst": "pdk:theme_pdk_anvendelsevandsoekyst_aflyst",
         "theme_pdk_anvendelsevandsoekyst_forslag": "pdk:theme_pdk_anvendelsevandsoekyst_forslag",
         "theme_pdk_anvendelsevandsoekyst_vedtaget": "pdk:theme_pdk_anvendelsevandsoekyst_vedtaget",
         "theme_pdk_bevaringsvaerdigelandskaber_aflyst": "pdk:theme_pdk_bevaringsvaerdigelandskaber_aflyst",
         "theme_pdk_bevaringsvaerdigelandskaber_forslag": "pdk:theme_pdk_bevaringsvaerdigelandskaber_forslag",
         "theme_pdk_bevaringsvaerdigelandskaber_vedtaget": "pdk:theme_pdk_bevaringsvaerdigelandskaber_vedtaget",
         "theme_pdk_byggefelt_aflyst": "pdk:theme_pdk_byggefelt_aflyst",
         "theme_pdk_byggefelt_forslag": "pdk:theme_pdk_byggefelt_forslag",
         "theme_pdk_byggefelt_med_historik": "pdk:theme_pdk_byggefelt_med_historik",
         "theme_pdk_byggefelt_vedtaget": "pdk:theme_pdk_byggefelt_vedtaget",
         "theme_pdk_byggefelt_vedtaget_version": "pdk:theme_pdk_byggefelt_vedtaget_version",
         "theme_pdk_byzonesommerhusomraade_aflyst": "pdk:theme_pdk_byzonesommerhusomraade_aflyst",
         "theme_pdk_byzonesommerhusomraade_forslag": "pdk:theme_pdk_byzonesommerhusomraade_forslag",
         "theme_pdk_byzonesommerhusomraade_vedtaget": "pdk:theme_pdk_byzonesommerhusomraade_vedtaget",
         "theme_pdk_codelist_bygberegnaf_v": "pdk:theme_pdk_codelist_bygberegnaf_v",
         "theme_pdk_codelist_byggefelttype_v": "pdk:theme_pdk_codelist_byggefelttype_v",
         "theme_pdk_codelist_detailhandel_v": "pdk:theme_pdk_codelist_detailhandel_v",
         "theme_pdk_codelist_forsyningsforbudomraade_v": "pdk:theme_pdk_codelist_forsyningsforbudomraade_v",
         "theme_pdk_codelist_forsyningsform_v": "pdk:theme_pdk_codelist_forsyningsform_v",
         "theme_pdk_codelist_fremtidigzonestatus_v": "pdk:theme_pdk_codelist_fremtidigzonestatus_v",
         "theme_pdk_codelist_generelanvendelse_v": "pdk:theme_pdk_codelist_generelanvendelse_v",
         "theme_pdk_codelist_kloak_v": "pdk:theme_pdk_codelist_kloak_v",
         "theme_pdk_codelist_konkretanvendelse_v": "pdk:theme_pdk_codelist_konkretanvendelse_v",
         "theme_pdk_codelist_naturbeskyttelse_v": "pdk:theme_pdk_codelist_naturbeskyttelse_v",
         "theme_pdk_codelist_oekologiskforbindelse_v": "pdk:theme_pdk_codelist_oekologiskforbindelse_v",
         "theme_pdk_codelist_omraadetype_v": "pdk:theme_pdk_codelist_omraadetype_v",
         "theme_pdk_codelist_oprindelse_v": "pdk:theme_pdk_codelist_oprindelse_v",
         "theme_pdk_codelist_oversvoemerosion_v": "pdk:theme_pdk_codelist_oversvoemerosion_v",
         "theme_pdk_codelist_planlagttekniskanlaeg_v": "pdk:theme_pdk_codelist_planlagttekniskanlaeg_v",
         "theme_pdk_codelist_planlagttrafikanlaeg_v": "pdk:theme_pdk_codelist_planlagttrafikanlaeg_v",
         "theme_pdk_codelist_plansubtype_v": "pdk:theme_pdk_codelist_plansubtype_v",
         "theme_pdk_codelist_plantype_v": "pdk:theme_pdk_codelist_plantype_v",
         "theme_pdk_codelist_revisionstype_v": "pdk:theme_pdk_codelist_revisionstype_v",
         "theme_pdk_codelist_skovrejsning_v": "pdk:theme_pdk_codelist_skovrejsning_v",
         "theme_pdk_codelist_specifikanvendelse_v": "pdk:theme_pdk_codelist_specifikanvendelse_v",
         "theme_pdk_codelist_status_v": "pdk:theme_pdk_codelist_status_v",
         "theme_pdk_codelist_tilslutningspligt_v": "pdk:theme_pdk_codelist_tilslutningspligt_v",
         "theme_pdk_codelist_tilslutningspligtomraade_v": "pdk:theme_pdk_codelist_tilslutningspligtomraade_v",
         "theme_pdk_codelist_zonestatus_v": "pdk:theme_pdk_codelist_zonestatus_v",
         "theme_pdk_detailhandel_aflyst": "pdk:theme_pdk_detailhandel_aflyst",
         "theme_pdk_detailhandel_forslag": "pdk:theme_pdk_detailhandel_forslag",
         "theme_pdk_detailhandel_vedtaget": "pdk:theme_pdk_detailhandel_vedtaget",
         "theme_pdk_digitalretningslinje_aflyst_v": "pdk:theme_pdk_digitalretningslinje_aflyst_v",
         "theme_pdk_digitalretningslinje_forslag_v": "pdk:theme_pdk_digitalretningslinje_forslag_v",
         "theme_pdk_digitalretningslinje_vedtaget_v": "pdk:theme_pdk_digitalretningslinje_vedtaget_v",
         "theme_pdk_forsyningomraade_aflyst_v": "pdk:theme_pdk_forsyningomraade_aflyst_v",
         "theme_pdk_forsyningomraade_vedtaget_v": "pdk:theme_pdk_forsyningomraade_vedtaget_v",
         "theme_pdk_forsyningsforbudomraade_aflyst_v": "pdk:theme_pdk_forsyningsforbudomraade_aflyst_v",
         "theme_pdk_forsyningsforbudomraade_vedtaget_v": "pdk:theme_pdk_forsyningsforbudomraade_vedtaget_v",
         "theme_pdk_kloakopland_aflyst_v": "pdk:theme_pdk_kloakopland_aflyst_v",
         "theme_pdk_kloakopland_forslag_v": "pdk:theme_pdk_kloakopland_forslag_v",
         "theme_pdk_kloakopland_vedtaget_v": "pdk:theme_pdk_kloakopland_vedtaget_v",
         "theme_pdk_kommuneplan_oversigt_aflyst_v": "pdk:theme_pdk_kommuneplan_oversigt_aflyst_v",
         "theme_pdk_kommuneplan_oversigt_forslag_v": "pdk:theme_pdk_kommuneplan_oversigt_forslag_v",
         "theme_pdk_kommuneplan_oversigt_vedtaget_v": "pdk:theme_pdk_kommuneplan_oversigt_vedtaget_v",
         "theme_pdk_kommuneplanramme_aflyst_v": "pdk:theme_pdk_kommuneplanramme_aflyst_v",
         "theme_pdk_kommuneplanramme_alle_aflyst_v": "pdk:theme_pdk_kommuneplanramme_alle_aflyst_v",
         "theme_pdk_kommuneplanramme_alle_forslag_v": "pdk:theme_pdk_kommuneplanramme_alle_forslag_v",
         "theme_pdk_kommuneplanramme_alle_vedtaget_v": "pdk:theme_pdk_kommuneplanramme_alle_vedtaget_v",
         "theme_pdk_kommuneplanramme_forslag_v": "pdk:theme_pdk_kommuneplanramme_forslag_v",
         "theme_pdk_kommuneplanramme_vedtaget_v": "pdk:theme_pdk_kommuneplanramme_vedtaget_v",
         "theme_pdk_kommuneplanstrategi_aflyst_v": "pdk:theme_pdk_kommuneplanstrategi_aflyst_v",
         "theme_pdk_kommuneplanstrategi_forslag_v": "pdk:theme_pdk_kommuneplanstrategi_forslag_v",
         "theme_pdk_kommuneplanstrategi_vedtaget_v": "pdk:theme_pdk_kommuneplanstrategi_vedtaget_v",
         "theme_pdk_kommuneplantillaeg_aflyst_v": "pdk:theme_pdk_kommuneplantillaeg_aflyst_v",
         "theme_pdk_kommuneplantillaeg_aflyst_vvm_v": "pdk:theme_pdk_kommuneplantillaeg_aflyst_vvm_v",
         "theme_pdk_kommuneplantillaeg_alle_typer_forslag_v": "pdk:theme_pdk_kommuneplantillaeg_alle_typer_forslag_v",
         "theme_pdk_kommuneplantillaeg_alle_typer_vedtaget_v": "pdk:theme_pdk_kommuneplantillaeg_alle_typer_vedtaget_v",
         "theme_pdk_kommuneplantillaeg_forslag_v": "pdk:theme_pdk_kommuneplantillaeg_forslag_v",
         "theme_pdk_kommuneplantillaeg_forslag_vvm_v": "pdk:theme_pdk_kommuneplantillaeg_forslag_vvm_v",
         "theme_pdk_kommuneplantillaeg_helekommunen_aflyst_v": "pdk:theme_pdk_kommuneplantillaeg_helekommunen_aflyst_v",
         "theme_pdk_kommuneplantillaeg_helekommunen_forslag_v": "pdk:theme_pdk_kommuneplantillaeg_helekommunen_forslag_v",
         "theme_pdk_kommuneplantillaeg_helekommunen_vedtaget_v": "pdk:theme_pdk_kommuneplantillaeg_helekommunen_vedtaget_v",
         "theme_pdk_kommuneplantillaeg_vedtaget_v": "pdk:theme_pdk_kommuneplantillaeg_vedtaget_v",
         "theme_pdk_kommuneplantillaeg_vedtaget_vvm_v": "pdk:theme_pdk_kommuneplantillaeg_vedtaget_vvm_v",
         "theme_pdk_konsekvensomraade_aflyst": "pdk:theme_pdk_konsekvensomraade_aflyst",
         "theme_pdk_konsekvensomraade_forslag": "pdk:theme_pdk_konsekvensomraade_forslag",
         "theme_pdk_konsekvensomraade_vedtaget": "pdk:theme_pdk_konsekvensomraade_vedtaget",
         "theme_pdk_kulturhistoriskbevaringsvaerdi_aflyst": "pdk:theme_pdk_kulturhistoriskbevaringsvaerdi_aflyst",
         "theme_pdk_kulturhistoriskbevaringsvaerdi_forslag": "pdk:theme_pdk_kulturhistoriskbevaringsvaerdi_forslag",
         "theme_pdk_kulturhistoriskbevaringsvaerdi_vedtaget": "pdk:theme_pdk_kulturhistoriskbevaringsvaerdi_vedtaget",
         "theme_pdk_landzonetilladelse_aflyst_v": "pdk:theme_pdk_landzonetilladelse_aflyst_v",
         "theme_pdk_landzonetilladelse_vedtaget_v": "pdk:theme_pdk_landzonetilladelse_vedtaget_v",
         "theme_pdk_lavbundsareal_aflyst": "pdk:theme_pdk_lavbundsareal_aflyst",
         "theme_pdk_lavbundsareal_forslag": "pdk:theme_pdk_lavbundsareal_forslag",
         "theme_pdk_lavbundsareal_vedtaget": "pdk:theme_pdk_lavbundsareal_vedtaget",
         "theme_pdk_lokalplan_aflyst": "pdk:theme_pdk_lokalplan_aflyst",
         "theme_pdk_lokalplan_aflyst_solcelle": "pdk:theme_pdk_lokalplan_aflyst_solcelle",
         "theme_pdk_lokalplan_aflyst_vindmoelle": "pdk:theme_pdk_lokalplan_aflyst_vindmoelle",
         "theme_pdk_lokalplan_forslag": "pdk:theme_pdk_lokalplan_forslag",
         "theme_pdk_lokalplan_forslag_solcelle": "pdk:theme_pdk_lokalplan_forslag_solcelle",
         "theme_pdk_lokalplan_forslag_vindmoelle": "pdk:theme_pdk_lokalplan_forslag_vindmoelle",
         "theme_pdk_lokalplan_med_historik": "pdk:theme_pdk_lokalplan_med_historik",
         "theme_pdk_lokalplan_vedtaget": "pdk:theme_pdk_lokalplan_vedtaget",
         "theme_pdk_lokalplan_vedtaget_solcelle": "pdk:theme_pdk_lokalplan_vedtaget_solcelle",
         "theme_pdk_lokalplan_vedtaget_version": "pdk:theme_pdk_lokalplan_vedtaget_version",
         "theme_pdk_lokalplan_vedtaget_vindmoelle": "pdk:theme_pdk_lokalplan_vedtaget_vindmoelle",
         "theme_pdk_lokalplan_visplaner": "pdk:theme_pdk_lokalplan_visplaner",
         "theme_pdk_lokalplandelomraade_aflyst": "pdk:theme_pdk_lokalplandelomraade_aflyst",
         "theme_pdk_lokalplandelomraade_forslag": "pdk:theme_pdk_lokalplandelomraade_forslag",
         "theme_pdk_lokalplandelomraade_med_historik": "pdk:theme_pdk_lokalplandelomraade_med_historik",
         "theme_pdk_lokalplandelomraade_vedtaget": "pdk:theme_pdk_lokalplandelomraade_vedtaget",
         "theme_pdk_lokalplandelomraade_vedtaget_version": "pdk:theme_pdk_lokalplandelomraade_vedtaget_version",
         "theme_pdk_mulighedforudtraedenkloakopland_aflyst_v": "pdk:theme_pdk_mulighedforudtraedenkloakopland_aflyst_v",
         "theme_pdk_mulighedforudtraedenkloakopland_forslag_v": "pdk:theme_pdk_mulighedforudtraedenkloakopland_forslag_v",
         "theme_pdk_mulighedforudtraedenkloakopland_vedtaget_v": "pdk:theme_pdk_mulighedforudtraedenkloakopland_vedtaget_v",
         "theme_pdk_naturbeskyttelsesomraade_aflyst": "pdk:theme_pdk_naturbeskyttelsesomraade_aflyst",
         "theme_pdk_naturbeskyttelsesomraade_forslag": "pdk:theme_pdk_naturbeskyttelsesomraade_forslag",
         "theme_pdk_naturbeskyttelsesomraade_vedtaget": "pdk:theme_pdk_naturbeskyttelsesomraade_vedtaget",
         "theme_pdk_oekologiskforbindelse_aflyst": "pdk:theme_pdk_oekologiskforbindelse_aflyst",
         "theme_pdk_oekologiskforbindelse_forslag": "pdk:theme_pdk_oekologiskforbindelse_forslag",
         "theme_pdk_oekologiskforbindelse_vedtaget": "pdk:theme_pdk_oekologiskforbindelse_vedtaget",
         "theme_pdk_omdannelseslandsby_aflyst": "pdk:theme_pdk_omdannelseslandsby_aflyst",
         "theme_pdk_omdannelseslandsby_forslag": "pdk:theme_pdk_omdannelseslandsby_forslag",
         "theme_pdk_omdannelseslandsby_vedtaget": "pdk:theme_pdk_omdannelseslandsby_vedtaget",
         "theme_pdk_oversvoemerosion_aflyst": "pdk:theme_pdk_oversvoemerosion_aflyst",
         "theme_pdk_oversvoemerosion_forslag": "pdk:theme_pdk_oversvoemerosion_forslag",
         "theme_pdk_oversvoemerosion_vedtaget": "pdk:theme_pdk_oversvoemerosion_vedtaget",
         "theme_pdk_planlagttekniskanlaeg_aflyst": "pdk:theme_pdk_planlagttekniskanlaeg_aflyst",
         "theme_pdk_planlagttekniskanlaeg_forslag": "pdk:theme_pdk_planlagttekniskanlaeg_forslag",
         "theme_pdk_planlagttekniskanlaeg_vedtaget": "pdk:theme_pdk_planlagttekniskanlaeg_vedtaget",
         "theme_pdk_planlagttrafikanlaeg_aflyst": "pdk:theme_pdk_planlagttrafikanlaeg_aflyst",
         "theme_pdk_planlagttrafikanlaeg_forslag": "pdk:theme_pdk_planlagttrafikanlaeg_forslag",
         "theme_pdk_planlagttrafikanlaeg_vedtaget": "pdk:theme_pdk_planlagttrafikanlaeg_vedtaget",
         "theme_pdk_produktionserhvervsomraade_aflyst": "pdk:theme_pdk_produktionserhvervsomraade_aflyst",
         "theme_pdk_produktionserhvervsomraade_forslag": "pdk:theme_pdk_produktionserhvervsomraade_forslag",
         "theme_pdk_produktionserhvervsomraade_vedtaget": "pdk:theme_pdk_produktionserhvervsomraade_vedtaget",
         "theme_pdk_selvstaendig_aflyst_vvm_v": "pdk:theme_pdk_selvstaendig_aflyst_vvm_v",
         "theme_pdk_selvstaendig_forslag_vvm_v": "pdk:theme_pdk_selvstaendig_forslag_vvm_v",
         "theme_pdk_selvstaendig_vedtaget_vvm_v": "pdk:theme_pdk_selvstaendig_vedtaget_vvm_v",
         "theme_pdk_skovrejsningsomraade_aflyst": "pdk:theme_pdk_skovrejsningsomraade_aflyst",
         "theme_pdk_skovrejsningsomraade_forslag": "pdk:theme_pdk_skovrejsningsomraade_forslag",
         "theme_pdk_skovrejsningsomraade_vedtaget": "pdk:theme_pdk_skovrejsningsomraade_vedtaget",
         "theme_pdk_specifikgeologiskbevaringsvaerdi_aflyst": "pdk:theme_pdk_specifikgeologiskbevaringsvaerdi_aflyst",
         "theme_pdk_specifikgeologiskbevaringsvaerdi_forslag": "pdk:theme_pdk_specifikgeologiskbevaringsvaerdi_forslag",
         "theme_pdk_specifikgeologiskbevaringsvaerdi_vedtaget": "pdk:theme_pdk_specifikgeologiskbevaringsvaerdi_vedtaget",
         "theme_pdk_statslige_kommuneplantillaeg_aflyst_v": "pdk:theme_pdk_statslige_kommuneplantillaeg_aflyst_v",
         "theme_pdk_statslige_kommuneplantillaeg_forslag_v": "pdk:theme_pdk_statslige_kommuneplantillaeg_forslag_v",
         "theme_pdk_statslige_kommuneplantillaeg_helekommunen_aflyst_v": "pdk:theme_pdk_statslige_kommuneplantillaeg_helekommunen_aflyst_v",
         "theme_pdk_statslige_kommuneplantillaeg_helekommunen_forslag_v": "pdk:theme_pdk_statslige_kommuneplantillaeg_helekommunen_forslag_v",
         "theme_pdk_statslige_kommuneplantillaeg_helekommunen_vedtaget_v": "pdk:theme_pdk_statslige_kommuneplantillaeg_helekommunen_vedtaget_v",
         "theme_pdk_statslige_kommuneplantillaeg_vedtaget_v": "pdk:theme_pdk_statslige_kommuneplantillaeg_vedtaget_v",
         "theme_pdk_stoejbelastetareal_aflyst": "pdk:theme_pdk_stoejbelastetareal_aflyst",
         "theme_pdk_stoejbelastetareal_forslag": "pdk:theme_pdk_stoejbelastetareal_forslag",
         "theme_pdk_stoejbelastetareal_vedtaget": "pdk:theme_pdk_stoejbelastetareal_vedtaget",
         "theme_pdk_stoerresammenhaengendelandskaber_aflyst": "pdk:theme_pdk_stoerresammenhaengendelandskaber_aflyst",
         "theme_pdk_stoerresammenhaengendelandskaber_forslag": "pdk:theme_pdk_stoerresammenhaengendelandskaber_forslag",
         "theme_pdk_stoerresammenhaengendelandskaber_vedtaget": "pdk:theme_pdk_stoerresammenhaengendelandskaber_vedtaget",
         "theme_pdk_storehusdyrbrug_aflyst": "pdk:theme_pdk_storehusdyrbrug_aflyst",
         "theme_pdk_storehusdyrbrug_forslag": "pdk:theme_pdk_storehusdyrbrug_forslag",
         "theme_pdk_storehusdyrbrug_vedtaget": "pdk:theme_pdk_storehusdyrbrug_vedtaget",
         "theme_pdk_tekniskanlaegkonsekvensomraade_aflyst": "pdk:theme_pdk_tekniskanlaegkonsekvensomraade_aflyst",
         "theme_pdk_tekniskanlaegkonsekvensomraade_forslag": "pdk:theme_pdk_tekniskanlaegkonsekvensomraade_forslag",
         "theme_pdk_tekniskanlaegkonsekvensomraade_vedtaget": "pdk:theme_pdk_tekniskanlaegkonsekvensomraade_vedtaget",
         "theme_pdk_tilbagefoerttillandzone_vedtaget_v": "pdk:theme_pdk_tilbagefoerttillandzone_vedtaget_v",
         "theme_pdk_tilslutningspligtomraade_aflyst_v": "pdk:theme_pdk_tilslutningspligtomraade_aflyst_v",
         "theme_pdk_tilslutningspligtomraade_vedtaget_v": "pdk:theme_pdk_tilslutningspligtomraade_vedtaget_v",
         "theme_pdk_transformationsomraade_aflyst": "pdk:theme_pdk_transformationsomraade_aflyst",
         "theme_pdk_transformationsomraade_forslag": "pdk:theme_pdk_transformationsomraade_forslag",
         "theme_pdk_transformationsomraade_vedtaget": "pdk:theme_pdk_transformationsomraade_vedtaget",
         "theme_pdk_udbygningsaftale_aflyst_v": "pdk:theme_pdk_udbygningsaftale_aflyst_v",
         "theme_pdk_udbygningsaftale_forslag_v": "pdk:theme_pdk_udbygningsaftale_forslag_v",
         "theme_pdk_udbygningsaftale_vedtaget_v": "pdk:theme_pdk_udbygningsaftale_vedtaget_v",
         "theme_pdk_vaerdifuldtkulturmiljoe_aflyst": "pdk:theme_pdk_vaerdifuldtkulturmiljoe_aflyst",
         "theme_pdk_vaerdifuldtkulturmiljoe_forslag": "pdk:theme_pdk_vaerdifuldtkulturmiljoe_forslag",
         "theme_pdk_vaerdifuldtkulturmiljoe_vedtaget": "pdk:theme_pdk_vaerdifuldtkulturmiljoe_vedtaget",
         "theme_pdk_vaerdifuldtlandbrugsomraade_aflyst": "pdk:theme_pdk_vaerdifuldtlandbrugsomraade_aflyst",
         "theme_pdk_vaerdifuldtlandbrugsomraade_forslag": "pdk:theme_pdk_vaerdifuldtlandbrugsomraade_forslag",
         "theme_pdk_vaerdifuldtlandbrugsomraade_vedtaget": "pdk:theme_pdk_vaerdifuldtlandbrugsomraade_vedtaget",
         "theme_pdk_varmeplansomraade_aflyst_v": "pdk:theme_pdk_varmeplansomraade_aflyst_v",
         "theme_pdk_varmeplansomraade_vedtaget_v": "pdk:theme_pdk_varmeplansomraade_vedtaget_v",
         "theme_pdk_virksomhedsaerligtbeliggenhedskrav_aflyst": "pdk:theme_pdk_virksomhedsaerligtbeliggenhedskrav_aflyst",
         "theme_pdk_virksomhedsaerligtbeliggenhedskrav_forslag": "pdk:theme_pdk_virksomhedsaerligtbeliggenhedskrav_forslag",
         "theme_pdk_virksomhedsaerligtbeliggenhedskrav_vedtaget": "pdk:theme_pdk_virksomhedsaerligtbeliggenhedskrav_vedtaget",
         "theme_pdk_zonekort_samlet_v": "pdk:theme_pdk_zonekort_samlet_v",
         "theme_pdk_zonekort_udgangspunkt_20211208_v": "pdk:theme_pdk_zonekort_udgangspunkt_20211208_v",
         "theme_pdk_zonekort_v": "pdk:theme_pdk_zonekort_v",
         "theme_pdk_zonekort_version_v": "pdk:theme_pdk_zonekort_version_v"
      },
   },
   "DAGI (Polygons)": {
      endpoint: "https://wfs.datafordeler.dk/DAGIM/DAGI_10MULTIGEOM_GMLSFP/1.0.0/WFS",
      urlParams: "Datafordeler",
      featureTypes: {
         "Afstemningsomraade": "dagi10:Afstemningsomraade",
         "Kommuneinddeling": "dagi10:Kommuneinddeling",
         "Landsdel": "dagi10:Landsdel",
         "Menighedsraadsafstemningsomraade": "dagi10:Menighedsraadsafstemningsomraade",
         "Opstillingskreds": "dagi10:Opstillingskreds",
         "Politikreds": "dagi10:Politikreds",
         "Postnummerinddeling": "dagi10:Postnummerinddeling",
         "Regionsinddeling": "dagi10:Regionsinddeling",
         "Retskreds": "dagi10:Retskreds",
         "Sogneinddeling": "dagi10:Sogneinddeling",
         "Storkreds": "dagi10:Storkreds",
         "SupplerendeBynavn": "dagi10:SupplerendeBynavn"
      }
   },
   "Matriklen2": {
      endpoint: "https://wfs.datafordeler.dk/MATRIKLEN2/MatGaeldendeOgForeloebigWFS/1.0.0/WFS",
      urlParams: "Datafordeler",
      featureTypes: {
         "BygningPaaFremmedGrundFlade_Foreloebig": "mat:BygningPaaFremmedGrundFlade_Foreloebig",
         "BygningPaaFremmedGrundFlade_Gaeldende": "mat:BygningPaaFremmedGrundFlade_Gaeldende",
         "BygningPaaFremmedGrundPunkt_Foreloebig": "mat:BygningPaaFremmedGrundPunkt_Foreloebig",
         "BygningPaaFremmedGrundPunkt_Gaeldende": "mat:BygningPaaFremmedGrundPunkt_Gaeldende",
         "Centroide_Foreloebig": "mat:Centroide_Foreloebig",
         "Centroide_Gaeldende": "mat:Centroide_Gaeldende",
         "Ejerlav_Foreloebig": "mat:Ejerlav_Foreloebig",
         "Ejerlav_Gaeldende": "mat:Ejerlav_Gaeldende",
         "Ejerlejlighed_Foreloebig": "mat:Ejerlejlighed_Foreloebig",
         "Ejerlejlighed_Gaeldende": "mat:Ejerlejlighed_Gaeldende",
         "Ejerlejlighedslod_Foreloebig": "mat:Ejerlejlighedslod_Foreloebig",
         "Ejerlejlighedslod_Gaeldende": "mat:Ejerlejlighedslod_Gaeldende",
         "FredskovFlade_Foreloebig": "mat:FredskovFlade_Foreloebig",
         "FredskovFlade_Gaeldende": "mat:FredskovFlade_Gaeldende",
         "FredskovLinje_Foreloebig": "mat:FredskovLinje_Foreloebig",
         "FredskovLinje_Gaeldende": "mat:FredskovLinje_Gaeldende",
         "Jordstykke_Foreloebig": "mat:Jordstykke_Foreloebig",
         "Jordstykke_Gaeldende": "mat:Jordstykke_Gaeldende",
         "KlitfredningFlade_Foreloebig": "mat:KlitfredningFlade_Foreloebig",
         "KlitfredningFlade_Gaeldende": "mat:KlitfredningFlade_Gaeldende",
         "KlitfredningLinje_Foreloebig": "mat:KlitfredningLinje_Foreloebig",
         "KlitfredningLinje_Gaeldende": "mat:KlitfredningLinje_Gaeldende",
         "Lodflade_Foreloebig": "mat:Lodflade_Foreloebig",
         "Lodflade_Gaeldende": "mat:Lodflade_Gaeldende",
         "MatrikelKommune_Foreloebig": "mat:MatrikelKommune_Foreloebig",
         "MatrikelKommune_Gaeldende": "mat:MatrikelKommune_Gaeldende",
         "MatrikelSogn_Foreloebig": "mat:MatrikelSogn_Foreloebig",
         "MatrikelSogn_Gaeldende": "mat:MatrikelSogn_Gaeldende",
         "Matrikelskel_Foreloebig": "mat:Matrikelskel_Foreloebig",
         "Matrikelskel_Gaeldende": "mat:Matrikelskel_Gaeldende",
         "MatrikulaerSag_Afsluttet": "mat:MatrikulaerSag_Afsluttet",
         "MatrikulaerSag_Igangvaerende": "mat:MatrikulaerSag_Igangvaerende",
         "MatrikulaerSag_IkkeGennemfoert": "mat:MatrikulaerSag_IkkeGennemfoert",
         "Nullinje_Foreloebig": "mat:Nullinje_Foreloebig",
         "Nullinje_Gaeldende": "mat:Nullinje_Gaeldende",
         "OptagetVej_Foreloebig": "mat:OptagetVej_Foreloebig",
         "OptagetVej_Gaeldende": "mat:OptagetVej_Gaeldende",
         "SamletFastEjendom_Foreloebig": "mat:SamletFastEjendom_Foreloebig",
         "SamletFastEjendom_Gaeldende": "mat:SamletFastEjendom_Gaeldende",
         "Skelpunkt_Foreloebig": "mat:Skelpunkt_Foreloebig",
         "Skelpunkt_Gaeldende": "mat:Skelpunkt_Gaeldende",
         "StrandbeskyttelseFlade_Foreloebig": "mat:StrandbeskyttelseFlade_Foreloebig",
         "StrandbeskyttelseFlade_Gaeldende": "mat:StrandbeskyttelseFlade_Gaeldende",
         "StrandbeskyttelseLinje_Foreloebig": "mat:StrandbeskyttelseLinje_Foreloebig",
         "StrandbeskyttelseLinje_Gaeldende": "mat:StrandbeskyttelseLinje_Gaeldende"
      }
   },
   "Skovfonden": {
      endpoint: "https://test.admin.gc2.io/ows/klimaskovfonden/public/",
      featureTypes: {
         "Klimaskovfondens projekter april 2025": "klimaskovfonden:public.klimaskovfondens_projekter_april_2025",
         "Klimaskovfondens projekter marts 2025": "klimaskovfonden:public.klimaskovfondens_projekter_marts_2025",
         "Klimaskovfondens projekter": "klimaskovfonden:public.klimaskovfondens_projekter"
      }
   },
   "DHM Højdekurver": {
      endpoint: "https://wfs.datafordeler.dk/DHMHoejdekurver/DHMHoejdekurver_WFS/1.0.0/WFS",
      urlParams: "Datafordeler",
      featureTypes: {
         "formkurve0_5_current": "dhmhoejdekurver_v001:formkurve0_5_current",
         "formkurve0_5_hist": "dhmhoejdekurver_v001:formkurve0_5_hist",
         "formkurve2_5_current": "dhmhoejdekurver_v001:formkurve2_5_current",
         "formkurve2_5_hist": "dhmhoejdekurver_v001:formkurve2_5_hist",
         "kote0_5_current": "dhmhoejdekurver_v001:kote0_5_current",
         "kote0_5_hist": "dhmhoejdekurver_v001:kote0_5_hist",
         "kote2_5_current": "dhmhoejdekurver_v001:kote2_5_current",
         "kote2_5_hist": "dhmhoejdekurver_v001:kote2_5_hist",
         "referencekurve0_25_current": "dhmhoejdekurver_v001:referencekurve0_25_current",
         "referencekurve0_25_hist": "dhmhoejdekurver_v001:referencekurve0_25_hist"
      }
   },
   "Fikspunkter": {
      endpoint: "https://wfs.datafordeler.dk/FIKSPUNKT/FIKSPUNKT_WFS/1.0.0/WFS",
      urlParams: "Datafordeler",
      featureTypes: {
         "fikspunktsys34_current": "fikspunkt_v001:fikspunktsys34_current",
         "fikspunktsys34_hist": "fikspunkt_v001:fikspunktsys34_hist",
         "fikspunktsys34_plandesc_current": "fikspunkt_v001:fikspunktsys34_plandesc_current",
         "fikspunktsys34_punktdesc_current": "fikspunkt_v001:fikspunktsys34_punktdesc_current",
         "fikspunktsys34_specialnr_current": "fikspunkt_v001:fikspunktsys34_specialnr_current",
         "hoejdefikspunktdk_current": "fikspunkt_v001:hoejdefikspunktdk_current",
         "hoejdefikspunktdk_foto_current": "fikspunkt_v001:hoejdefikspunktdk_foto_current",
         "hoejdefikspunktdk_hist": "fikspunkt_v001:hoejdefikspunktdk_hist",
         "hoejdefikspunktdk_kotedesc_current": "fikspunkt_v001:hoejdefikspunktdk_kotedesc_current",
         "hoejdefikspunktdk_punktdesc_current": "fikspunkt_v001:hoejdefikspunktdk_punktdesc_current",
         "hoejdefikspunktdk_specialnr_current": "fikspunkt_v001:hoejdefikspunktdk_specialnr_current",
         "hoejdefikspunktdnn_current": "fikspunkt_v001:hoejdefikspunktdnn_current",
         "hoejdefikspunktdnn_hist": "fikspunkt_v001:hoejdefikspunktdnn_hist",
         "hoejdefikspunktdnn_kotedesc_current": "fikspunkt_v001:hoejdefikspunktdnn_kotedesc_current",
         "hoejdefikspunktdnn_punktdesc_current": "fikspunkt_v001:hoejdefikspunktdnn_punktdesc_current",
         "hoejdefikspunktdnn_specialnr_current": "fikspunkt_v001:hoejdefikspunktdnn_specialnr_current",
         "hoejdefikspunktfo_current": "fikspunkt_v001:hoejdefikspunktfo_current",
         "hoejdefikspunktfo_foto_current": "fikspunkt_v001:hoejdefikspunktfo_foto_current",
         "hoejdefikspunktfo_hist": "fikspunkt_v001:hoejdefikspunktfo_hist",
         "hoejdefikspunktfo_kotedesc_current": "fikspunkt_v001:hoejdefikspunktfo_kotedesc_current",
         "hoejdefikspunktfo_punktdesc_current": "fikspunkt_v001:hoejdefikspunktfo_punktdesc_current",
         "hoejdefikspunktfo_specialnr_current": "fikspunkt_v001:hoejdefikspunktfo_specialnr_current",
         "hoejdefikspunktgl_current": "fikspunkt_v001:hoejdefikspunktgl_current",
         "hoejdefikspunktgl_foto_current": "fikspunkt_v001:hoejdefikspunktgl_foto_current",
         "hoejdefikspunktgl_hist": "fikspunkt_v001:hoejdefikspunktgl_hist",
         "hoejdefikspunktgl_kotedesc_current": "fikspunkt_v001:hoejdefikspunktgl_kotedesc_current",
         "hoejdefikspunktgl_punktdesc_current": "fikspunkt_v001:hoejdefikspunktgl_punktdesc_current",
         "hoejdefikspunktgl_specialnr_current": "fikspunkt_v001:hoejdefikspunktgl_specialnr_current",
         "planfikspunktdk_current": "fikspunkt_v001:planfikspunktdk_current",
         "planfikspunktdk_foto_current": "fikspunkt_v001:planfikspunktdk_foto_current",
         "planfikspunktdk_hist": "fikspunkt_v001:planfikspunktdk_hist",
         "planfikspunktdk_plandesc_current": "fikspunkt_v001:planfikspunktdk_plandesc_current",
         "planfikspunktdk_punktdesc_current": "fikspunkt_v001:planfikspunktdk_punktdesc_current",
         "planfikspunktdk_specialnr_current": "fikspunkt_v001:planfikspunktdk_specialnr_current",
         "planfikspunktfo_current": "fikspunkt_v001:planfikspunktfo_current",
         "planfikspunktfo_foto_current": "fikspunkt_v001:planfikspunktfo_foto_current",
         "planfikspunktfo_hist": "fikspunkt_v001:planfikspunktfo_hist",
         "planfikspunktfo_plandesc_current": "fikspunkt_v001:planfikspunktfo_plandesc_current",
         "planfikspunktfo_punktdesc_current": "fikspunkt_v001:planfikspunktfo_punktdesc_current",
         "planfikspunktfo_specialnr_current": "fikspunkt_v001:planfikspunktfo_specialnr_current",
         "planfikspunktgl_current": "fikspunkt_v001:planfikspunktgl_current",
         "planfikspunktgl_foto_current": "fikspunkt_v001:planfikspunktgl_foto_current",
         "planfikspunktgl_hist": "fikspunkt_v001:planfikspunktgl_hist",
         "planfikspunktgl_plandesc_current": "fikspunkt_v001:planfikspunktgl_plandesc_current",
         "planfikspunktgl_punktdesc_current": "fikspunkt_v001:planfikspunktgl_punktdesc_current",
         "planfikspunktgl_specialnr_current": "fikspunkt_v001:planfikspunktgl_specialnr_current",
         "specialnummer_current": "fikspunkt_v001:specialnummer_current"
      }
   },
   "Fingerplan19": {
      endpoint: "https://gisp.bpst.dk/fingerplan19/ows",
      featureTypes: {
         "fingerplan19:theme-fp19vo_letbane_line": "fingerplan19:theme-fp19vo_letbane_line",
         "fingerplan19:theme-fp19vs_naturgashvdtransledn": "fingerplan19:theme-fp19vs_naturgashvdtransledn",
         "fingerplan19:fp19vu_stojzone_roskilde": "fingerplan19:fp19vu_stojzone_roskilde",
         "fp19va_byfingre": "fingerplan19:theme-fp19va_byfingre",
         "fp19va_byomr_oevr": "fingerplan19:theme-fp19va_byomr_ovr",
         "fp19va_haandflade": "fingerplan19:theme-fp19va_haandflade",
         "fp19va_indre_kiler": "fingerplan19:theme-fp19va_indre_kiler",
         "fp19va_ydre_kiler": "fingerplan19:theme-fp19va_ydre_kiler",
         "fp19va_ydre_landomr": "fingerplan19:theme-fp19va_ydre_landomr",
         "fp19vb_4_gronne_ring": "fingerplan19:theme-fp19vd_4_gronne_ring",
         "fp19vc_friluftsanlaeg": "fingerplan19:theme-fp19vc_friluftsanlaeg",
         "fp19vd_koege_bugt_strandpark": "fingerplan19:theme-fp19vb_koege_bugt_strandpark",
         "fp19ve_friluftsanvendelse": "fingerplan19:theme-fp19vb_friluftsanvendelse",
         "fp19vf_bykiler": "fingerplan19:theme-fp19vf_bykiler",
         "fp19vg_stationer": "fingerplan19:theme-fp19vf_stationer",
         "fp19vg_stationer_ovr": "fingerplan19:theme-fp19vf_stationer_ovr",
         "fp19vh_letbane_line": "fingerplan19:theme-fp19vh_letbane_line",
         "fp19vh_letbane_station": "fingerplan19:theme-fp19vh_letbane_station",
         "fp19vi_vsb_omr": "fingerplan19:theme-fp19vi_vsb_omr",
         "fp19vj_containerterminal_line": "fingerplan19:theme-fp19vj_containerterminal_line",
         "fp19vj_containerterminal_reg": "fingerplan19:theme-fp19vj_containerterminal_reg",
         "fp19vk_kbh_til_bz": "fingerplan19:theme-fp19vk_kbh_til_bz",
         "fp19vl_omr_produktionsvirksomheder": "fingerplan19:theme-fp19vi_omr_produktionsvirksomheder",
         "fp19vm1_forskerpark_og_risoe": "fingerplan19:theme-fp19vm_forskerpark_risoe",
         "fp19vm2_sportsbyen": "fingerplan19:theme-fp19vm_sportsbyen",
         "fp19vm3_saerlige_lokaliseringsomraader": "fingerplan19:theme-fp19vm3_lokaliseringsomraade",
         "fp19vn_transportkorridorer": "fingerplan19:theme-fp19vn_transportkorridorer",
         "fp19vo_kbh_ringsted_centerl": "fingerplan19:theme-fp19vo_kbh_ringsted_centerl",
         "fp19vo_metro": "fingerplan19:theme-fp19vo_metro",
         "fp19vo_regionaltog_dobbeltspor": "fingerplan19:theme-fp19vo_regionaltog_dobbeltspor",
         "fp19vo_regionaltog_eks": "fingerplan19:theme-fp19vo_regionaltog_eks",
         "fp19vo_s_tog_eks": "fingerplan19:theme-fp19vo_s_tog_eks",
         "fp19vo_s_tog_vige": "fingerplan19:theme-fp19vo_s_tog_vige",
         "fp19vp_igangvaerende_undersoegelser": "fingerplan19:theme-fp19vp_igangvaerende_undersoeg",
         "fp19vp_motorvej_eksist": "fingerplan19:theme-fp19vp_motorvej_eksist",
         "fp19vp_motorvejanlaeg_udv": "fingerplan19:theme-fp19vp_motorvejanlaeg_udv",
         "fp19vp_oevr_vej_anl": "fingerplan19:theme-fp19vp_oevr_vej_anl",
         "fp19vp_oevr_vej_eks": "fingerplan19:theme-fp19vp_oevr_vej_eks",
         "fp19vq_ml_trafiksti": "fingerplan19:theme-fp19vq_ml_trafiksti",
         "fp19vq_supercykelstier_versionsplan_2045": "fingerplan19:theme-fp19vq_supercykelstier_vp",
         "fp19vq_trafiksti": "fingerplan19:theme-fp19vq_trafiksti",
         "fp19vr_mangl_sikr_skaering": "fingerplan19:theme-fp19vr_mangl_sikr_skreing",
         "fp19vr_miss_links_reg_rekrea_sti": "fingerplan19:theme-fp19vr_miss_links_reg_rekrea_sti",
         "fp19vr_reg_rekrea_sti": "fingerplan19:theme-fp19vr_reg_rekrea_sti",
         "fp19vs1_naturgasledning_ny": "fingerplan19:theme-fp19vs1_naturgasledning_ny",
         "fp19vs1_naturgasledning_udg": "fingerplan19:theme-fp19vs1_naturgasledning_udg",
         "fp19vs_hoejspaendingsanlaeg": "fingerplan19:theme-fp19vs_hoejspaendingsanlaeg",
         "fp19vs_hoejspaendingsanlaeg_planlagt": "fingerplan19:theme-fp19vs_hoejspaendingsanlaeg_planlagt",
         "fp19vs_natgaskompresstation_plan": "fingerplan19:theme-fp19vs_natgaskompresstation_plan",
         "fp19vt1_graense_stojafskaerm_kastrup": "fingerplan19:theme-fp19vt1_graense_stojafskaerm_kastrup",
         "fp19vt1_lufthavnsomr_kastrup": "fingerplan19:theme-fp19vt1_lufthavnsomr_kastrup",
         "fp19vt1_restrik_kastrup": "fingerplan19:theme-fp19vt1_restrik_kastrup",
         "fp19vt1_restrik_tvaerbane_kastrup": "fingerplan19:theme-fp19vt1_restrik_tvaerbane_kastrup",
         "fp19vt2_maalestat_stoj_kastrup": "fingerplan19:theme-fp19vt2_maalestat_stoj_kastrup",
         "fp19vt2_motoromr_stoj_kastrup": "fingerplan19:theme-fp19vt2_motoromr_stoj_kastrup",
         "fp19vt2_stojzone_kastrup": "fingerplan19:theme-fp19vt2_stojzone_kastrup",
         "fp19vu_lufthavnsomr_roskilde": "fingerplan19:theme-fp19vu_lufthavnsomr_roskilde",
         "fp19vu_restrik_roskilde": "fingerplan19:theme-fp19vu_restrik_roskilde",
         "fp19vu_stoejkonsekvensomr": "fingerplan19:theme-fp19vu_stoejkonsekvensomr",
         "fp19vv_sh_til_bz": "fingerplan19:theme-fp19vv_sh_til_bz"
      }
   },
   "DHM Oprindelse": {
      endpoint: "https://wfs.datafordeler.dk/DHMOprindelse/DHMOprindelse_WFS/1.0.0/WFS",
      urlParams: "Datafordeler",
      featureTypes: {
         "korrektionegne_current": "dhmoprindelse_v001:korrektionegne_current",
         "korrektionegne_hist": "dhmoprindelse_v001:korrektionegne_hist",
         "korrektionegne_register_current": "dhmoprindelse_v001:korrektionegne_register_current",
         "korrektiongeodanmark_current": "dhmoprindelse_v001:korrektiongeodanmark_current",
         "korrektiongeodanmark_hist": "dhmoprindelse_v001:korrektiongeodanmark_hist",
         "korrektiongeodanmark_register_current": "dhmoprindelse_v001:korrektiongeodanmark_register_current",
         "punktoprindelse_current": "dhmoprindelse_v001:punktoprindelse_current",
         "punktoprindelse_hist": "dhmoprindelse_v001:punktoprindelse_hist"
      }
   },
   "MARS SGAV": {
      endpoint: "https://mars.sgav.dk/geo/wfs",
      featureTypes: {
         "Naturpotentialer": "mars:naturpotentialer",
         "Projekter - Samlet": "mars:projekter_samlet",
         "Projekter - Tilskudsordning - Skovrejsning": "mars:projekter_tilskudsordning_skovrejsning",
         "Skitseprojekter - Samlet": "mars:skitseprojekter"
      }
   }
} as const;
